webpackJsonp([1],{

/***/ "+B+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inbox_vue__ = __webpack_require__("U3Ej");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5fa9588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inbox_vue__ = __webpack_require__("v6u5");
function injectStyle (ssrContext) {
  __webpack_require__("XH1l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c5fa9588"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5fa9588_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+dVs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radial-progress-container",style:(_vm.containerStyle)},[_c('div',{staticClass:"radial-progress-inner",style:(_vm.innerCircleStyle)},[_vm._t("default")],2),_vm._v(" "),_c('svg',{staticClass:"radial-progress-bar",attrs:{"width":_vm.diameter,"height":_vm.diameter,"version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},[_c('defs',[_c('radialGradient',{attrs:{"id":'radial-gradient' + _vm._uid,"fx":_vm.gradient.fx,"fy":_vm.gradient.fy,"cx":_vm.gradient.cx,"cy":_vm.gradient.cy,"r":_vm.gradient.r}},[_c('stop',{attrs:{"offset":"30%","stop-color":_vm.startColor}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":_vm.stopColor}})],1)],1),_vm._v(" "),_c('circle',{style:(_vm.strokeStyle),attrs:{"r":_vm.innerCircleRadius,"cx":_vm.radius,"cy":_vm.radius,"fill":"transparent","stroke":_vm.innerStrokeColor,"stroke-dasharray":_vm.circumference,"stroke-dashoffset":"0","stroke-linecap":"round"}}),_vm._v(" "),_c('circle',{style:(_vm.progressStyle),attrs:{"transform":'rotate(270, ' + _vm.radius + ',' + _vm.radius + ')',"r":_vm.innerCircleRadius,"cx":_vm.radius,"cy":_vm.radius,"fill":"transparent","stroke":'url(#radial-gradient' + _vm._uid + ')',"stroke-dasharray":_vm.circumference,"stroke-dashoffset":_vm.circumference,"stroke-linecap":"round"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/9G1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Register New Admin")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"field is-horizontal"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adminPermissionCode),expression:"adminPermissionCode"}],staticClass:"input",attrs:{"type":"text","id":"adminPermissionCode","placeholder":"Admin Permission Code","required":""},domProps:{"value":(_vm.adminPermissionCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.adminPermissionCode=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company),expression:"company"}],staticClass:"input",attrs:{"type":"text","id":"company","placeholder":"Company","required":""},domProps:{"value":(_vm.company)},on:{"input":function($event){if($event.target.composing){ return; }_vm.company=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input",attrs:{"type":"email","id":"registerEmail","placeholder":"Email","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_vm._m(3,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input",attrs:{"type":"password","id":"password","placeholder":"Password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_vm._m(5,false,false)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"input",attrs:{"type":"password","id":"confirmPassword","placeholder":"Confirm Password","required":""},domProps:{"value":(_vm.confirmPassword)},on:{"keyup":_vm.comparePasswords,"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}}),_vm._v(" "),_vm._m(6,false,false)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded"},[(_vm.passwordsNotMatch)?_c('b',{staticClass:"help is-success"},[_vm._v("\n                  Passwords match\n                ")]):_vm._e(),_vm._v(" "),(!_vm.passwordsNotMatch)?_c('b',{staticClass:"help is-danger"},[_vm._v("\n                  Passwords do not match\n                ")]):_vm._e()])])])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"field is-grouped"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-medium is-fullwidth",on:{"click":_vm.register}},[_vm._v("Submit")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Admin Permission Code:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Company:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Email:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Password:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-lock"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Z6G":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAPoAQAAAABl2OlJAAAAAnRSTlMAAQGU/a4AAAAJcEhZcwAAAEgAAABIAEbJaz4AAAHPSURBVHja7dMxDQAACANB/KvECYhowsL93tzUmqjO5kWn0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6nJ7p03+fH0el0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+l0Op1Op9PpdDqdTqfT6XQ6nU6n0+lBC3Y2lPr+wSyaAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA0LTEzVDE2OjI4OjA2LTA0OjAwyIaNcgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNC0xM1QxNjoyODowNi0wNDowMLnbNc4AAAAASUVORK5CYII="

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d473226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("FIJ3");
function injectStyle (ssrContext) {
  __webpack_require__("3GDT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0d473226_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1110":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/shoes.85c9ead.png";

/***/ }),

/***/ "1Oe9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'deviceSyncModal',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "22zb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/OdysseusBadgeSilver.ff162b8.png";

/***/ }),

/***/ "2gZF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('div',{staticClass:"tile is-ancestor"},[_c('div',{staticClass:"tile is-vertical"},[_vm._m(0,false,false),_vm._v(" "),_c('article',{staticClass:"tile is-child"},[_c('p',{staticClass:"title is-3",attrs:{"align":"center"}},[_vm._v("Available points: "+_vm._s(_vm.user.points))])]),_vm._v(" "),_vm._m(1,false,false)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"tile is-child"},[_c('p',{staticClass:"title is-1",attrs:{"align":"center"}},[_vm._v("Customize Your Avatar!!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-parent"},[_c('article',{staticClass:"tile is-child box"},[_c('p',{staticClass:"subtitle is-5",attrs:{"align":"center"}},[_vm._v("Body Parts")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("5b+q"),"alt":"Body Parts"}})]),_vm._v(" "),_c('article',{staticClass:"tile is-child box"},[_c('p',{staticClass:"subtitle is-5",attrs:{"align":"center"}},[_vm._v("Hair Styles")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("Ueqq"),"alt":"Hair Styles"}})]),_vm._v(" "),_c('article',{staticClass:"tile is-child box"},[_c('p',{staticClass:"subtitle is-5",attrs:{"align":"center"}},[_vm._v("Clothes")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("t0Z9"),"alt":"Clothes"}})]),_vm._v(" "),_c('article',{staticClass:"tile is-child box"},[_c('p',{staticClass:"subtitle is-5",attrs:{"align":"center"}},[_vm._v("Accessories")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("9pL1"),"alt":"Accessories"}})]),_vm._v(" "),_c('article',{staticClass:"tile is-child box"},[_c('p',{staticClass:"subtitle is-5",attrs:{"align":"center"}},[_vm._v("Shoes")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("1110"),"alt":"Shoes"}})]),_vm._v(" "),_c('article',{staticClass:"tile is-child box"},[_c('p',{staticClass:"subtitle is-5",attrs:{"align":"center"}},[_vm._v("Eyewear")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("8+D+"),"alt":"Eyeware"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2nJM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/HeraBadgePlatinum.00fcff0.png";

/***/ }),

/***/ "33Z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['user']))
});

/***/ }),

/***/ "3GDT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3y59":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4tVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('username-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showUsernameModal),expression:"showUsernameModal"}],on:{"close":function($event){_vm.showUsernameModal = false}}}),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"title is-1",attrs:{"align":"center"}},[_vm._v("Welcome Back "+_vm._s(_vm.user.firstName))]),_vm._v(" "),(_vm.deviceNotSynced)?_c('div',{staticClass:"content"},[_c('p',{staticClass:"title is-3",attrs:{"align":"center"}},[_vm._v("Please Sync Device To View Daily Progress")]),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticClass:"title is-6",attrs:{"align":"center"}},[_vm._v(" “From all of us at KNOSIS, Thank you for participating in our revolutionary platform’s Closed BETA Test.")]),_vm._v(" "),_c('p',{staticClass:"title is-6",attrs:{"align":"center"}},[_vm._v("You are part of a select group of people who will be testing this proprietary platform for the very first time.")]),_vm._v(" "),_c('p',{staticClass:"title is-6",attrs:{"align":"center"}},[_vm._v("Your participation and feedback will be important for us to improve upon our methodology as we seek to revolutionize")]),_vm._v(" "),_c('p',{staticClass:"title is-6",attrs:{"align":"center"}},[_vm._v(" the healthcare industry by engaging users to live healthier lifestyles. - Wilman Vergara, Founder and CEO”")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns is-centered"},[(_vm.summaryReady)?_c('div',{staticClass:"column is-one-third"},[_c('div',{staticClass:"flip-container"},[_c('div',{staticClass:"flipper"},[_c('radial-progress-bar',{attrs:{"diameter":250,"completed-steps":_vm.achievedSteps,"total-steps":_vm.goalSteps,"startColor":_vm.stepsStartColor,"stopColor":_vm.stepsEndColor,"innerStrokeColor":_vm.stockColor}},[_c('p',{staticClass:"title is-3"},[_vm._v("Steps")]),_vm._v(" "),_c('div',{staticClass:"front"},[_c('p',{staticClass:"title is-5",attrs:{"align":"center"}},[_vm._v("Goal: "+_vm._s(_vm.goalSteps)),_c('br'),_vm._v("Completed: "+_vm._s(_vm.achievedSteps))])]),_vm._v(" "),_c('div',{staticClass:"back"},[_c('p',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.stepsPercent)+"%")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"flip-container"},[_c('div',{staticClass:"flipper"},[_c('radial-progress-bar',{attrs:{"diameter":250,"completed-steps":_vm.achievedCalorieOut,"total-steps":_vm.goalCalorieOut,"startColor":_vm.caloriesStartColor,"stopColor":_vm.caloriesEndColor,"innerStrokeColor":_vm.stockColor1}},[_c('p',{staticClass:"title is-3"},[_vm._v("Calories")]),_vm._v(" "),_c('div',{staticClass:"front"},[_c('p',{staticClass:"title is-5",attrs:{"align":"center"}},[_vm._v("Goal: "+_vm._s(_vm.goalCalorieOut)),_c('br'),_vm._v("Completed: "+_vm._s(_vm.achievedCalorieOut))])]),_vm._v(" "),_c('div',{staticClass:"back"},[_c('p',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.caloriePercent)+"%")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"flip-container"},[_c('div',{staticClass:"flipper"},[_c('radial-progress-bar',{attrs:{"diameter":250,"completed-steps":_vm.achievedFloors,"total-steps":_vm.goalFloors,"startColor":_vm.floorsStartColor,"stopColor":_vm.floorsEndColor,"innerStrokeColor":_vm.stockColor2}},[_c('p',{staticClass:"title is-3"},[_vm._v("Floors")]),_vm._v(" "),_c('div',{staticClass:"front"},[_c('p',{staticClass:"title is-5"},[_vm._v("Goal: "+_vm._s(_vm.goalFloors)),_c('br'),_vm._v("Completed: "+_vm._s(_vm.achievedFloors))])]),_vm._v(" "),_c('div',{staticClass:"back"},[_c('p',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.floorPercent)+"%")])])])],1)])]):_vm._e(),_vm._v(" "),(_vm.summaryReady)?_c('div',{staticClass:"column is-one-third"},[_c('figure',{staticClass:"image"},[_c('didimoModal')],1),_c('br'),_c('br'),_vm._v(" "),(_vm.summaryReady)?_c('div',{staticClass:"content"},[_c('article',{staticClass:"media"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('div',{staticClass:"content"},[_c('p',{staticClass:"title is-6"},[_vm._v("Goal: "+_vm._s(_vm.goalDistance)+" miles"),_c('br'),_vm._v("Completed: "+_vm._s(_vm.achievedDistance)+" miles")]),_c('br')])])]),_vm._v(" "),_c('progress',{staticClass:"progress is-large is-primary",attrs:{"max":_vm.goalDistance},domProps:{"value":_vm.achievedDistance}})]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.summaryReady)?_c('div',{staticClass:"column is-one-third"},[_c('p',{staticClass:"title",attrs:{"align":"center"}},[_vm._v("Tracker Minutes")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('article',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('p',{staticClass:"title is-6"},[_vm._v("Inactive: "+_vm._s(_vm.inactiveMinutes))])]),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('progress',{staticClass:"progress is-small is-danger",attrs:{"max":_vm.goalMinutes},domProps:{"value":_vm.inactiveMinutes}})])]),_vm._v(" "),_c('article',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('p',{staticClass:"title is-6"},[_vm._v("Lightly Active: "+_vm._s(_vm.lightMinutes))])]),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('progress',{staticClass:"progress is-warning",attrs:{"max":_vm.goalMinutes},domProps:{"value":_vm.lightMinutes}})])]),_vm._v(" "),_c('article',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('p',{staticClass:"title is-6"},[_vm._v("Fairly Active: "+_vm._s(_vm.fairMinutes))])]),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('progress',{staticClass:"progress is-medium is-link",attrs:{"max":_vm.goalMinutes},domProps:{"value":_vm.fairMinutes}})])]),_vm._v(" "),_c('article',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('p',{staticClass:"title is-6"},[_vm._v("Very Active: "+_vm._s(_vm.activeMinutes))])]),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('progress',{staticClass:"progress is-large is-success",attrs:{"max":_vm.goalMinutes},domProps:{"value":_vm.activeMinutes}})])])]),_vm._v(" "),_c('div',{staticClass:"ball"},[_c('p',{staticClass:"title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.rank))]),_vm._v(" "),_c('figure',{staticClass:"image"})])]):_vm._e()])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-left"},[_c('p',{staticClass:"title is-5"},[_vm._v("Distance Traveled")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5CKD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_localstorage__ = __webpack_require__("UnSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__didimoModal_vue__ = __webpack_require__("RWhW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createNewAvatarModal_vue__ = __webpack_require__("7f5Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      showCreateNewAvatarModal: false,
      hasAvatar2: this.$store.getters.avatar.hasAvatar
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['user'])),
  methods: {
    closeCreateNewAvatarModal: function closeCreateNewAvatarModal(bool) {
      var self = this;
      if (bool == true) {
        self.$emit('close');
      }
    },
    goToMarketplacePage: function goToMarketplacePage() {
      this.$router.push({ path: '/market' });
    }
  },
  components: {
    didimoModal: __WEBPACK_IMPORTED_MODULE_2__didimoModal_vue__["a" /* default */],
    createNewAvatarModal: __WEBPACK_IMPORTED_MODULE_4__createNewAvatarModal_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "5ETr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('p',{staticClass:"title is-3",attrs:{"align":"center"}},[_vm._v("Send A Message To Your Group")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column box is-one-third"},[_c('form',[_c('label',[_vm._v("Recipients")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('label',{attrs:{"for":"subject"}},[_vm._v("Subject")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.messageSubject),expression:"messageSubject"}],attrs:{"type":"text","id":"subject","name":"subject","placeholder":"Message Subject.."},domProps:{"value":(_vm.messageSubject)},on:{"input":function($event){if($event.target.composing){ return; }_vm.messageSubject=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"message"}},[_vm._v("Message")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.messageBody),expression:"messageBody"}],staticStyle:{"height":"200px"},attrs:{"id":"message","name":"message","placeholder":"Write something.."},domProps:{"value":(_vm.messageBody)},on:{"input":function($event){if($event.target.composing){ return; }_vm.messageBody=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"button is-medium is-fullwidth",on:{"click":_vm.addMessage}},[_vm._v("Send")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{attrs:{"id":"user","name":"user"}},[_c('option',[_vm._v("All")]),_vm._v(" "),_c('option',[_vm._v("Specific User coming later")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Ej0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/knosisWHITE.48c4e22.png";

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a49fa3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("KrRW");
function injectStyle (ssrContext) {
  __webpack_require__("AJr4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a49fa3a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5b+q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/body-parts.f25f923.png";

/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d1e9e4ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("r/ZB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d1e9e4ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5wB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminGroupData_vue__ = __webpack_require__("Wmlc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9367bd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminGroupData_vue__ = __webpack_require__("bG/c");
function injectStyle (ssrContext) {
  __webpack_require__("gA8B")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9367bd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminGroupData_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9367bd8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminGroupData_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6EED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


/*
  This is just a regular javascript object and no longer is a store.
  It no longer is a store, instead it gets sent to the store file now.
*/
/* harmony default export */ __webpack_exports__["a"] = ({
  // the store configuration
  state: {
    user: {}
  },
  mutations: {
    // changes the state of data properties
    setUser: function setUser(state, payload) {
      state.user = payload; // the currently signed in user
    }
  },
  /*
    Perform all asynchronous tasks in the actions area
   */
  actions: {
    // to dispatch the mutations
    signUserUp: function signUserUp(_ref, payload) {
      var commit = _ref.commit;
      // manage the user signup in our store
      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users/' + __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().currentUser.uid).set({
          id: __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().currentUser.uid,
          firstName: payload.firstName,
          lastName: payload.lastName,
          username: payload.username,
          email: payload.email,
          admin: false,
          dob: payload.dob,
          gender: payload.gender,
          race: payload.race,
          weight: payload.weight,
          feet: payload.feet,
          inches: payload.inches,
          longitude: 0,
          latitude: 0,
          messages: [],
          points: 100,
          rank: 'No Rank',
          zipcode: payload.zipcode,
          hasAvatar: false,
          didimoKey: ''
        });
        commit('setUser', {
          id: __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().currentUser.uid,
          firstName: payload.firstName,
          lastName: payload.lastName,
          username: payload.username,
          email: payload.email,
          admin: false,
          dob: payload.dob,
          gender: payload.gender,
          race: payload.race,
          weight: payload.weight,
          feet: payload.feet,
          inches: payload.inches,
          longitude: 0,
          latitude: 0,
          messages: [],
          points: 100,
          rank: 'No Rank',
          zipcode: payload.zipcode,
          hasAvatar: false,
          didimoKey: ''
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    signUserIn: function signUserIn(_ref2, payload) {
      var commit = _ref2.commit;
      // payload is an object with an email and password
      // payload is what is currently in the store
      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        // receive the user and store it in the store
        var newUser = {
          id: user.uid
        };
        commit('setUser', newUser); // mutation and pass the new user
      }).catch(function (error) {
        console.log(error);
      });
    },
    autoSignIn: function autoSignIn(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setUser', {
        id: payload.uid
      });
    },
    fetchUserData: function fetchUserData(_ref4) {
      var commit = _ref4.commit,
          getters = _ref4.getters;

      // get user data from firebase using the getters
      // once fetches the data once.  It doesn't set up a permanent listener
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(getters.user.id).once('value', function (data) {
        var updatedUser = {
          id: getters.user.id,
          gender: data.child('gender').val(),
          race: data.child('race').val(),
          firstName: data.child('firstName').val(),
          lastName: data.child('lastName').val(),
          dob: data.child('dob').val(),
          email: data.child('email').val(),
          admin: data.child('admin').val(),
          username: data.child('username').val(),
          heightFT: data.child('feet').val(),
          heightIN: data.child('inches').val(),
          weight: data.child('weight').val(),
          zipcode: data.child('zipcode').val(),
          fitbitID: data.child('fitbitID').val(),
          fitbitAccessToken: data.child('fitbitAccessToken').val(),
          rank: data.child('rank').val(),
          points: data.child('points').val()
        };
        commit('setUser', updatedUser);
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateUserData: function updateUserData(_ref5, payload) {
      var commit = _ref5.commit,
          getters = _ref5.getters;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(getters.user.id).update({
        firstName: payload.firstName,
        lastName: payload.lastName,
        weight: payload.weight,
        zipcode: payload.zipcode
      });
      this.dispatch('fetchUserData');
    },
    logout: function logout(_ref6) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().signOut();
      commit('setUser', null);
      commit('setUserPosition', null);
      commit('setPastChallenges', []);
      commit('setChallenges', []);
      commit('setAvatar', null);
      commit('setAvailableChallengers', []);
    }
  },
  getters: {
    // get the store in our components
    user: function user(state) {
      // return the user from vuex store
      return state.user;
    }
  }
});

/***/ }),

/***/ "6dM0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "714C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_vm._m(0,false,false),_vm._v(" "),_c('section',{staticClass:"modal-card-body",attrs:{"id":"camera"}},[(_vm.previewOn)?_c('div',[_c('p',{staticClass:"subtitle is-4",attrs:{"align":"center"}},[_vm._v("Preview")])]):_c('div',[_c('p',{staticClass:"subtitle is-4",attrs:{"align":"center"}},[_vm._v("Please center your face as best as you can.")])]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__("/Z6G"),"id":"videoOverlay"}}),_vm._v(" "),_c('video',{attrs:{"id":"video"}}),_vm._v(" "),_c('canvas',{attrs:{"id":"canvas"}}),_vm._v(" "),_c('form',{attrs:{"id":"newFromSource","method":"post","enctype":"multipart/form-data","action":"https://mydidimo.com/api/1.2.0/didimo/new/autodetect/autorun"}})]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[(_vm.photoReady)?_c('div',{staticStyle:{"display":"inline-block"}},[_c('button',{staticClass:"button is-fullwidth",attrs:{"id":"retakeButton"},on:{"click":function($event){_vm.photoReady = false; _vm.previewOn = false; _vm.$emit('closeCanvas');}}},[_vm._v("Retake")]),_vm._v(" "),_c('button',{staticClass:"button is-fullwidth",attrs:{"id":"usePhotoButton"},on:{"click":function($event){_vm.postNewFromSource('https://mydidimo.com/api/1.2.0/didimo/new/autodetect/autorun');_vm.$emit('close');_vm.$emit('closeCreateNewAvatarModal', true);_vm.turnMediaOff()}}},[_vm._v("Use Photo")])]):_c('div',[_c('button',{staticClass:"button",on:{"click":_vm.capturePhoto}},[_vm._v("Take Photo")])]),_vm._v(" "),_c('button',{staticClass:"button",staticStyle:{"justify-content":"space-between"},on:{"click":function($event){_vm.$emit('close'); _vm.turnMediaOff()}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Upload New Photo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "79Kf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7HfY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtotop_vue__ = __webpack_require__("LTTF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa8542b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtotop_vue__ = __webpack_require__("KYxL");
function injectStyle (ssrContext) {
  __webpack_require__("M64J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4aa8542b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_backtotop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4aa8542b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_backtotop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.68f09af.png";

/***/ }),

/***/ "7f5Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createNewAvatarModal_vue__ = __webpack_require__("YLc+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af2aa9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createNewAvatarModal_vue__ = __webpack_require__("v1Zf");
function injectStyle (ssrContext) {
  __webpack_require__("uLGF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7af2aa9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_createNewAvatarModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7af2aa9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_createNewAvatarModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8+D+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/eyeware.bc6e83b.png";

/***/ }),

/***/ "8fqk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "90FC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__didimoModal_vue__ = __webpack_require__("RWhW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__loaderModal_vue__ = __webpack_require__("dO9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localstorage__ = __webpack_require__("UnSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_localstorage__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* Packages needed to render avatar on WebGLRenderer */
var THREE = __webpack_require__("Ml+6");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cameraModal',
  components: {
    didimoModal: __WEBPACK_IMPORTED_MODULE_2__didimoModal_vue__["a" /* default */],
    loaderModal: __WEBPACK_IMPORTED_MODULE_3__loaderModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      hasAvatar: false,
      didimoKey: '',

      showLoaderModal: false,
      showCameraModal: true,

      photoReady: false,
      previewOn: false,

      /* Data needed to Authorization string */
      secret_key: 'test_secret_key_eval253498',
      realm: 'Avatar',
      auth_method: "sha256",
      auth_key: "test_api_key_eval253498",
      auth_nonce: '',
      auth_digest: '',

      /* auth_uri must be exactly same as request for algorithm to work */
      auth_uri: "/api/1.2.0/didimo/new/autodetect/autorun"

      /* eval URI */
      // auth_uri: "/api/1.1/didimo/new/photo/autorun",
    };
  },

  methods: {
    displayLoaderModal: function displayLoaderModal() {
      this.$router.push({ path: '/loader' });
    },
    changeDidimoKey: function changeDidimoKey(key) {
      this.$store.dispatch('changeDidimoKey', key);
    },
    changeHasAvatarBoolean: function changeHasAvatarBoolean(boolean) {
      this.$store.dispatch('changeHasAvatar', boolean);
    },
    turnMediaOff: function turnMediaOff() {
      var video = document.getElementById('video');
      var stream = video.srcObject;
      var tracks = stream.getTracks();

      tracks.forEach(function (track) {
        track.stop();
      });

      video.srcObject = null;
    },


    /* Need this function for the getDidimoImage function to use out of range characters for encoding/decoding */
    Uint8ToString: function Uint8ToString(u8a) {
      var CHUNK_SZ = 0x8000;
      var c = [];
      for (var i = 0; i < u8a.length; i += CHUNK_SZ) {
        c.push(String.fromCharCode.apply(null, u8a.subarray(i, i + CHUNK_SZ)));
      }
      return c.join("");
    },


    /**
     * Convert a base64 string in a Blob according to the data and contentType.
     *
     * @param b64Data {String} Pure base64 string without contentType
     * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
     * @param sliceSize {Int} SliceSize to process the byteCharacters
     * @see http://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
     * @return Blob
     */
    b64toBlob: function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      // SAVE
      // var b64DataString = b64Data.substr(b64Data.indexOf(',') + 1);
      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },


    /*
     * Method that takes the captured photo
     * and sends it through the MyDidimo pipeline
     * to be transformed into a 3D avatar
    */
    postNewFromSource: function postNewFromSource(newsrc) {
      var self = this;

      var fbxFile;

      /* Didimo API doesn't allow for base64 uploads, so we have to convert to a file in a form */
      var form = document.getElementById("newFromSource");

      // Get image from canvas.toDataURL saved in localStorage
      var userPhotoData = localStorage.getItem('photo');

      // Split the base64 string in data and contentType
      var block = userPhotoData.split(";");

      // Get the content type
      var contentType = block[0].split(":")[1];

      // Get the real base64 content of the file
      var realData = block[1].split(",")[1];

      // Convert to blob
      var blob = self.b64toBlob(realData, contentType);

      // Optionally, create objectURL
      var blobURL = URL.createObjectURL(blob);

      var web = "web";

      // Create a FormData and append the file
      var fd = new FormData(form);
      fd.append("sender", web);
      fd.append("file", blob);

      /* Authorization string must take a new Nonce and digest every call */
      var AuthString = 'DidimoDigest '.concat('realm="Avatar",').concat(" ").concat('auth_method="sha256",').concat(" ").concat('auth_key="test_api_key_eval253498",').concat(" ").concat('auth_nonce="' + self.randomNonce + '",').concat(" ").concat('auth_digest="' + self.randomDigest + '"');

      var xhr = new XMLHttpRequest();
      xhr.open('POST', newsrc, true);
      xhr.setRequestHeader('Authorization', AuthString);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.onload = function () {

        /* This is the key you get from the response to know which didimo you will download */
        var responseText = JSON.parse(xhr.responseText);
        self.changeDidimoKey(responseText["key"]);

        if (xhr.readyState == 4 && xhr.status == 200) {
          setTimeout(function () {

            document.getElementById('previewcanvas').style.display = "none";

            /* Deletes the old previewcanvas and creates a new one */
            var previewcanvas = document.getElementById('previewcanvas');
            previewcanvas.parentNode.removeChild(previewcanvas);

            var _previewcanvas = document.createElement('div');
            _previewcanvas.setAttribute("id", "previewcanvas");
            var parentCanvas = document.getElementById('parentCanvas');
            var loading = document.getElementById('loading');

            parentCanvas.insertBefore(_previewcanvas, loading);

            document.getElementById('previewcanvas').style.display = "block";

            /* PerspectiveCamera sets the initial render position of the avatar when page loads */
            var camera = new THREE.PerspectiveCamera(35, 1, 1, 2000);

            var scene = new THREE.Scene();

            var mixers = [];
            var renderer;

            //defalt options, settable by url
            var options = {
              audiourl: 'audio.pcm',
              visemesurl: 'visemes.txt',
              controls3d: true,
              controlsAudio: true,
              initialDistance: 60,
              autoplay: false,
              camTarget: "head",
              camAdjust: "0,0,0",
              fbxfile: 'avatar_model.fbx',
              posesfile: null, //"poses_diff_auto.json",
              clearColor: 0x222222,
              animSyncMillis: -100,
              maxBlendMillis: 150,
              // didimo:null,
              sceneInfoFile: null
            };

            if (!Detector.webgl) Detector.addGetWebGLMessage();

            window._getvar = window._getvar || function (n) {
              var r;if (r = new RegExp("[?&]" + String(n).replace(/[\[\]]/g, "\\$&") + "(=([^&#]*)|&|#|$)").exec(window.location.href)) r = r[2] && decodeURIComponent(r[2].replace(/\+/g, " ")) || '';return r;
            };

            function parseUrl(query) {
              var urlParams;
              var match,
                  pl = /\+/g,
                  // Regex for replacing addition symbol with a space
              search = /([^&=]+)=?([^&]*)/g,
                  decode = function decode(s) {
                return decodeURIComponent(s.replace(pl, " "));
              };
              urlParams = {};
              while (match = search.exec(query)) {
                var decoded = decode(match[2]);
                try {
                  decoded = JSON.parse(decoded);
                } catch (e) {}
                urlParams[decode(match[1])] = decoded;
              }
              return urlParams;
            }
            var urlParams = parseUrl(window.location.search.substring(1));

            for (var i in urlParams) {
              options[i] = urlParams[i];
            }

            // This must end with /preview
            if (options.didimo !== null) {
              var didimodir = 'https://' + 'mydidimo.com/api/latest/didimo/' + self.$store.getters.avatar.didimoKey + '/preview';
              options.fbxfile = didimodir + '/avatar_model.fbx';
              options.sceneInfoFile = didimodir + "/scene_info.json";
            }

            var previewcanvas = document.getElementById("previewcanvas") || document.body;

            function getRenderHeight() {
              return window.innerHeight * 0.7;
            }
            function getRenderWidth() {
              return window.innerWidth * 0.7;
            }
            function halfway(a, b) {
              return a + (b - a) / 2;
            }

            var helpers = [];
            function addHelper(helper) {
              helpers.push(helper);
              scene.add(helper);
            }
            function updateHelpers() {
              for (var i = 0; i < helpers.length; i++) {
                helpers[i].update();
              }
            }

            var mesh;
            var controls;

            var poses = {};
            var visemeList = [];

            var pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
            var antialias = pixelRatio == 1;

            // model
            var manager = new THREE.LoadingManager();
            manager.onStart = function (url, itemsLoaded, itemsTotal) {
              console.log('Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
            };
            manager.onProgress = function (item, loaded, total) {
              console.log(item, loaded, total);
            };
            manager.onLoad = function () {
              console.log('Loading Complete!');
              // onWindowResize();

              head.add(mesh);
              head.visible = true;

              // if(visemeList && visemeList.length > 0 && audio && audio.src)
              //   setTimeout(function(){ audio.play() },0);
            };
            manager.onError = function (url) {
              console.log('There was an error loading: ' + url);
            };

            var onProgress = function onProgress(xhr) {
              if (xhr.lengthComputable) {
                var percentComplete = xhr.loaded / xhr.total * 100;
                console.log(Math.round(percentComplete, 2) + '% downloaded');
              }
            };
            function onError(error) {
              console.error(error);
            }

            function globalLoadProgressManager(xhr) {
              var xhrp = 0;

              if (xhr.lengthComputable) {
                xhrp = xhr.loaded / xhr.total;
              } else {
                xhrp = 0;
              }

              var percentComplete = (xhrp + manager.loaded) / manager.total * 100;
              var _s = document.getElementById("loading").style;
              _s.transition = "all 100ms";
              _s.width = ~~percentComplete + "%";
            }

            var fbxLoader = new THREE.FBXLoader(manager);
            var imageLoader = new THREE.ImageLoader(manager);
            var fileLoader = new THREE.FileLoader(manager);
            var jsonLoader = new THREE.JSONLoader(manager);
            var objectLoader = new THREE.ObjectLoader(manager);

            /* Need to force local paths for .jpg assets to load correctly */
            THREE.FBXLoader.forceLocalPaths = true;

            var clock = new THREE.Clock();
            clock.start();

            renderer = new THREE.WebGLRenderer({ antialias: antialias, logarithmicDepthBuffer: true, alpha: true });
            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setSize(360, 400);
            renderer.setClearColor(0xffffff, 0);
            previewcanvas.appendChild(renderer.domElement);

            var head = new THREE.Group();
            scene.add(head);

            /* TRACKBALL CONTROLS */
            var controls = new THREE.TrackballControls(camera, renderer.domElement);
            controls.rotateSpeed = 1.0;
            controls.zoomSpeed = 0.2;
            controls.panSpeed = 0.8;
            controls.noRotate = false;
            controls.noZoom = false;
            controls.noPan = true;
            controls.dynamicDampingFactor = .4;
            controls.keys = [65, 83, 68];
            controls.target.set(0, 0, 0);
            controls.minDistance = 20;
            controls.maxDistance = 80;
            controls.enabled = options.controls3d;

            var light_ambient = new THREE.AmbientLight(0x606060);
            scene.add(light_ambient);

            var light_camera = new THREE.DirectionalLight(0xFFEFE1, 0.80);
            controls.addEventListener('change', light_update);
            function light_update() {
              light_camera.position.copy(camera.position);
              light_camera.position.y = 0;
            }
            light_camera.position.copy(camera.position);
            scene.add(light_camera);

            if (options.posesfile) fileLoader.load(options.posesfile, function (js) {
              var ps = JSON.parse(js);
              for (var n in ps) {
                if (n != "rest") poses[n] = ps[n];
              }
            }, globalLoadProgressManager);

            function loadFBX(sceneInfo) {
              document.getElementById('previewcanvas').style.display = "block";
              var bbcenter;
              var bbtarget;

              if (sceneInfo && sceneInfo.eyes_center && sceneInfo.head_center) {
                var eyes_center = new THREE.Vector3().fromArray(sceneInfo.eyes_center);
                var head_center = new THREE.Vector3().fromArray(sceneInfo.head_center);
                bbcenter = new THREE.Vector3().addScaledVector(eyes_center, .5).addScaledVector(head_center, .5);
                bbcenter.z = head_center.z;
                console.log(sceneInfo);
              }

              fbxLoader.load(options.fbxfile, function (m) {
                document.getElementById('previewcanvas').style.display = "block";
                mesh = m;

                if (!bbcenter) {
                  //no scene file, autodetect
                  if (bbtarget = mesh.getObjectByName(options.camTarget)) {
                    var bb = new THREE.Box3().setFromObject(bbtarget);
                    bbcenter = new THREE.Vector3(halfway(bb.min.x, bb.max.x), halfway(bb.min.y, bb.max.y), halfway(bb.min.z, bb.max.z));
                  } else {
                    console.error("camTarget", options.camTarget, "not found!");
                  }
                }

                var camAdjust = options.camAdjust && options.camAdjust.split(',');
                if ((typeof camAdjust === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(camAdjust)) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()([])) {
                  bbcenter.x += Number(camAdjust[0]);
                  bbcenter.y += Number(camAdjust[1]);
                  bbcenter.z += Number(camAdjust[2]);
                }
                camera.lookAt(bbcenter);
                camera.position.x = 0;
                camera.position.y = bbcenter.y;
                camera.position.z = options.initialDistance;

                if (controls) controls.target = bbcenter;

                //generate rest pose
                mesh.skeleton.bones.forEach(function (bone) {
                  var name = bone.name;
                  if (!poses.rest) poses.rest = {};
                  if (!poses.rest[name]) poses.rest[name] = {};
                  if (!poses.rest[name].translation) poses.rest[name].translation = [0, 0, 0];
                  if (!poses.rest[name].rotation) poses.rest[name].rotation = [0, 0, 0];
                  if (!poses.rest[name].scale) poses.rest[name].scale = [1, 1, 1];
                  poses.rest[name].translation = bone.position.toArray();
                  poses.rest[name].rotation = bone.rotation.toArray();
                  poses.rest[name].scale = bone.scale.toArray();
                });

                //regardless of choice of materials
                //force skinning
                mesh.traverse(function (m) {
                  if (m.isSkinnedMesh && m.material && !m.material.skinning) {
                    m.material.skinning = true;
                  }
                });

                if (document.body.classList) document.body.classList.add("hasVisual");else document.body.className += ' ' + "hasVisual";

                // fix z-buffer problems with eyelashes
                var lashesOrder = 10;
                mesh.traverse(function (child) {
                  if (child instanceof THREE.Mesh && String(child.name).match("lashes")) {
                    child.renderOrder = lashesOrder;
                    child.material.side = THREE.DoubleSide;
                    child.material.depthWrite = false;
                  }
                });
              }, onProgress, onError);
            }

            if (options.sceneInfoFile) fileLoader.load(options.sceneInfoFile, function (sceneInfo) {
              try {
                sceneInfo = JSON.parse(sceneInfo);
              } catch (e) {
                console.log("can't parse scene_info, continue with options/defaults");
                sceneInfo = null;
              }
              loadFBX(sceneInfo);
            }, undefined, function (data) {
              console.log("no scene_info, continue with options/defaults");
              loadFBX(null);
            });

            function animate() {
              requestAnimationFrame(animate);
              render();
            }
            animate();

            var maxFPS = 60;
            var renderPtime = 0;
            var oldposition = 0;
            function render() {

              var ctime = new Date().getTime();
              if (!window.audio || window.audio.paused) if (ctime - renderPtime < 1000 / maxFPS) return;

              renderPtime = ctime;

              var delta = clock.getDelta();

              window.stats && stats.update();

              window.animate_triggers && animate_triggers();

              window.updateHelpers && updateHelpers();

              var controlsAreQuiet = true;

              if (controls) {
                controls && controls.update();

                //throttle
                var co = controls.object;
                co.up.x += (0 - co.up.x) * (delta * 8);
                co.up.y += (1 - co.up.y) * (delta * 8);
                co.up.z += (0 - co.up.z) * (delta * 8);
                var p = Math.abs(co.position.x) + Math.abs(co.position.y) + Math.abs(co.position.z);
                controlsAreQuiet = Math.abs(p - oldposition) < 0.000001;
                oldposition = p;
              }

              var slow = window.audio && audio.paused && controlsAreQuiet;

              maxFPS = slow ? 10 : 50;

              //should not be needed if we don't change cameras, but a bug on some chrome versions
              //create dragging effect
              //renderer.clear();
              renderer.render(scene, camera);
            }

            function populate() {
              var objects = { unnamed: [] };
              mesh.traverse(function (o) {

                if (o.name) {
                  if (window[o.name]) console.log("window." + o.name + " already exists");else {
                    window[o.name] = o;
                  }
                }

                if (o.name) objects[o.name] = o;else objects.unnamed.push(o);
              });
            }

            function setupDatGui() {
              var gui = new dat.GUI();
              var folder = gui.addFolder("BONES");

              var bones = mesh.skeleton.bones;

              var BoneSelect = function BoneSelect(bone) {
                this.bone = bone;
                this.bonename = bone.name;
                this.selectbone = function () {
                  tcontrol.attach(this.bone);
                };
              };

              for (var i = 0; i < bones.length; i++) {
                var boneSelect = new BoneSelect(bones[i]);
                folder.add(boneSelect, 'selectbone').name(bones[i].name.replace('Template', ''));
              }

              folder.open();
              scene.add(skeletonHelper = new THREE.SkeletonHelper(scene));
            }

            function seeBones() {
              setTimeout(function () {
                var scriptGui = document.createElement('script');
                scriptGui.onload = setupDatGui;
                scriptGui.src = 'dat.gui.js';
                document.head.appendChild(scriptGui);
              }, 100);
            }

            self.changeHasAvatarBoolean(true);
          }, 60000);
          self.displayLoaderModal();
        }
      };
      xhr.send(fd);
    },
    capturePhoto: function capturePhoto() {
      this.previewOn = true;
      var canvas = document.getElementById("canvas");
      canvas.style.display = "block";

      var video = document.getElementById('video');
      video.style.display = "none";
      var videoOverlay = document.getElementById('videoOverlay');
      videoOverlay.style.display = "none";

      if (canvas != null) {
        var video = document.getElementById('video');

        var camera = document.getElementById('camera');
        camera.insertBefore(canvas, video);

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

        var canvasPhoto = canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

        localStorage.setItem('canvasPhoto', canvasPhoto);

        this.photoReady = true;

        var image = canvas.toDataURL("image/png");
        localStorage.setItem('photo', image);
        localStorage.setItem('canvas', canvas);
      } else {
        var canvas = document.createElement("canvas");

        var camera = document.getElementById('camera');
        camera.appendChild(canvas);

        var video = document.getElementById('video');

        camera.insertBefore(canvas, video);

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

        var canvasPhoto = canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

        localStorage.setItem('canvasPhoto', canvasPhoto);

        this.photoReady = true;

        var image = canvas.toDataURL("image/png");
        localStorage.setItem('photo', image);
        localStorage.setItem('canvas', canvas);
      }
    },

    /* Randomizes each Digest for each call using Authorization header */
    randomDigestAgain: function randomDigestAgain(authURI) {
      var digest = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.HmacSHA256(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.SHA256(this.auth_key + this.secret_key) + __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.SHA256(this.auth_key + this.randomNonce + authURI), this.secret_key);
      return digest;
    }
  },
  computed: {
    /* Randomizes each Nonce for each call using Authorization header */
    randomNonce: function randomNonce() {
      var text = "";
      var possible = "abcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 11; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },

    /* Randomizes each Digest for each call using Authorization header */
    randomDigest: function randomDigest() {
      var digest = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.HmacSHA256(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.SHA256(this.auth_key + this.secret_key) + __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.SHA256(this.auth_key + this.randomNonce + this.auth_uri), this.secret_key);
      return digest;
    },

    /* Randomizes each Nonce for each call using Authorization header */
    randomNonceAgain: function randomNonceAgain() {
      var text = "";
      var possible = "abcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 11; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    }
  }
});

/***/ }),

/***/ "9pL1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/accessories.357ae0a.png";

/***/ }),

/***/ "A7K3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AD8Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminNavbar_vue__ = __webpack_require__("vdG7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38468017_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminNavbar_vue__ = __webpack_require__("OFEc");
function injectStyle (ssrContext) {
  __webpack_require__("ri/H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38468017"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38468017_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AJr4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BzcA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      usernameAvailable: true,
      username: ''
    };
  },

  methods: {
    checkUsername: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function () {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('users').once('value').then(function (data) {
        var obj = data.val(); // store all objects
        for (var key in obj) {
          if (obj[key].username == _this.username) {
            _this.usernameAvailable = false;
            return;
          }
        }
        _this.usernameAvailable = true;
      });
    },
    // This is the number of milliseconds we wait for the
    // user to stop typing.
    500),
    submitUsername: function submitUsername() {
      if (this.username !== '' && this.usernameAvailable) {
        __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('users').child(__WEBPACK_IMPORTED_MODULE_1_firebase__["auth"]().currentUser.uid).update({
          username: this.username
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        alert('Username cannot be empty');
      }
    }
  }
});

/***/ }),

/***/ "CUFp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login($event)},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login($event)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control button-control"},[_c('button',{staticClass:"button is-medium is-fullwidth",attrs:{"placeholder":"Login"},on:{"click":_vm.login}},[_vm._v("Login")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_vm._m(1,false,false),_vm._v(" "),_c('p',{staticClass:"forgot-password",attrs:{"align":"center"},on:{"click":function($event){_vm.toastErr()}}},[_vm._v("New User? Sign up now\n            "),_c('i',{staticClass:"fas fa-angle-right"})])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('br'),_vm._v(" "),_c('p',{staticClass:"forgot-password",attrs:{"align":"center"},on:{"click":_vm.goToAdminLogin}},[_vm._v("Admin\n            "),_c('i',{staticClass:"fas fa-angle-right"})])])])])]),_vm._v(" "),_c('registerModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRegisterModal),expression:"showRegisterModal"}],on:{"close":function($event){_vm.showRegisterModal = false}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-image"},[_c('img',{attrs:{"id":"profile-img","src":__webpack_require__("5Ej0")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"forgot-password",attrs:{"align":"center"}},[_vm._v("Forgot your password?\n            "),_c('i',{staticClass:"fas fa-angle-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CXlY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cj4E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cqth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registerModal_vue__ = __webpack_require__("qKFl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8f4759_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registerModal_vue__ = __webpack_require__("yDfm");
function injectStyle (ssrContext) {
  __webpack_require__("A7K3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b8f4759"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registerModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b8f4759_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_registerModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CuRo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DK0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'challengeModal',
  data: function data() {
    return {
      challengeModal: true,
      opponent: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
        rank: ''
      }
    };
  },

  methods: {
    challengeUser: function challengeUser(selectedDuration) {
      var oRank = '';
      if (this.opponent.rank == null || this.opponent.rank == undefined) {
        oRank = 'No Rank';
      } else {
        oRank = this.opponent.rank;
      }
      if (this.$store.getters.user.id != this.opponent.id) {
        var challenge = {
          opponentRank: oRank,
          opponentId: this.opponent.id,
          opponentFirstName: this.opponent.firstName,
          opponentHasAccepted: false,
          startDate: '',
          winnerId: '',
          duration: selectedDuration
        };

        this.$store.dispatch('createChallenge', challenge);
        this.challengeModal = false;
      } else {
        alert('Error. You can\'t challenge yourself.');
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // listen for the event when the user is found by email
    this.$root.$on('selectOpponent', function (foundUser) {
      _this.opponent.id = foundUser.id;
      _this.opponent.firstName = foundUser.firstName;
      _this.opponent.rank = foundUser.rank;
    });
  }
});

/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Fitness_deviceSyncModal_vue__ = __webpack_require__("wsFh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navbar',
  data: function data() {
    return {
      showNav: false,
      showDeviceSyncModal: false,
      newMessage: false
    };
  },

  components: {
    deviceSyncModal: __WEBPACK_IMPORTED_MODULE_1__Fitness_deviceSyncModal_vue__["a" /* default */]
  },
  methods: {
    logout: function logout() {
      this.$store.dispatch('logout'); // call the logout method from the store
      this.$router.push({ path: '/login' });
    },
    goToAccountPage: function goToAccountPage() {
      this.showNav = false;
      this.$router.push({ path: '/account' });
      this.checkNewMessageReceived();
    },
    goToChallengePage: function goToChallengePage() {
      this.showNav = false;
      this.$router.push({ path: '/challenge' });
      this.checkNewMessageReceived();
    },
    goToFitnessHistoryPage: function goToFitnessHistoryPage() {
      this.showNav = false;
      this.$router.push({ path: '/FitnessHistory' });
      this.checkNewMessageReceived();
    },
    goToHomePage: function goToHomePage() {
      this.showNav = false;
      this.$router.push({ path: '/home' });
      this.checkNewMessageReceived();
    },
    goToAvatarPage: function goToAvatarPage() {
      this.showNav = false;
      this.$router.push({ path: '/avatar' });
      this.checkNewMessageReceived();
    },
    goToInboxPage: function goToInboxPage() {
      this.showNav = false;
      this.dismissMessageAlert();
      this.newMessage = false;
      this.$router.push({ path: '/inbox' });
      this.checkNewMessageReceived();
    },
    goToMarketPage: function goToMarketPage() {
      this.showNav = false;
      this.$router.push({ path: '/market' });
      this.checkNewMessageReceived();
    },
    checkNewMessageReceived: function checkNewMessageReceived() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(this.$store.getters.user.id).child('newMessage').once('value').then(function (data) {
        _this.newMessage = data.val();
      });
      if (this.newMessage) {
        alert("You have received a new message!");
        this.dismissMessageAlert();
      }
    },
    dismissMessageAlert: function dismissMessageAlert() {
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(this.$store.getters.user.id).update({
        newMessage: false
      });
    }
  }
});

/***/ }),

/***/ "DyPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"title is-1",attrs:{"align":"center"}},[_vm._v("Fitness History")]),_vm._v(" "),_c('p',{staticClass:"title",attrs:{"align":"center","id":"categ"}}),_vm._v(" "),(_vm.mountView)?_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column"},[_c('radial-progress-bar',{attrs:{"diameter":300,"completed-steps":10,"total-steps":10,"startColor":_vm.stepsColor,"stopColor":_vm.stepsColor}},[_c('p',{staticClass:"title",on:{"click":function($event){_vm.processSelect('Steps')}}},[_vm._v("Steps")])])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('radial-progress-bar',{attrs:{"diameter":300,"completed-steps":10,"total-steps":10,"startColor":_vm.distanceColor,"stopColor":_vm.distanceColor}},[_c('p',{staticClass:"title",on:{"click":function($event){_vm.processSelect('Distance')}}},[_vm._v("Distance")])])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('radial-progress-bar',{attrs:{"diameter":300,"completed-steps":10,"total-steps":10,"startColor":_vm.activeColor,"stopColor":_vm.activeColor}},[_c('p',{staticClass:"title",on:{"click":function($event){_vm.processSelect('Active Minutes')}}},[_vm._v("Active Minutes")])])],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('radial-progress-bar',{attrs:{"diameter":300,"completed-steps":10,"total-steps":10,"startColor":_vm.hrColor,"stopColor":_vm.hrColor}},[_c('p',{staticClass:"title",on:{"click":function($event){_vm.processSelect('Heart Rate')}}},[_vm._v("Heart Rate")])])],1)]):_vm._e(),_vm._v(" "),(_vm.detailView)?_c('p',{staticClass:"button is-small is-fullwidth notification is-dark",on:{"click":_vm.reloadPage}},[_vm._v("BACK")]):_vm._e(),_vm._v(" "),(_vm.detailView)?_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"title is-5",attrs:{"align":"center"}},[_vm._v("LAST MONTH")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"subtitle is-5 is-spaced",attrs:{"align":"center"}},[_vm._v("TOTAL")]),_vm._v(" "),_c('p',{staticClass:"subtitle is-6",attrs:{"align":"center"}},[_vm._v(" "+_vm._s(_vm.tileObj[0].sum)+" ")]),_vm._v(" "),_c('p',{staticClass:"subtitle is-5 is-spaced",attrs:{"align":"center"}},[_vm._v("AVERAGE")]),_vm._v(" "),_c('p',{staticClass:"subtitle is-6",attrs:{"align":"center"}},[_vm._v(" "+_vm._s(_vm.tileObj[0].avg)+" ")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"subtitle is-4",attrs:{"align":"center"}},[_vm._v("TOP 10")]),_c('br'),_vm._v(" "),_vm._l((_vm.tileObj[0].sorted),function(item){return _c('ol',{staticClass:"subtitle is-6",attrs:{"align":"center"}},[_vm._v("\n                  "+_vm._s(item.dateTime)+" - "+_vm._s(item.value)+"\n                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"column is-half"},[_c('vue-slider',_vm._b({model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}},'vue-slider',_vm.sliderOptions,false)),_c('br'),_vm._v(" "),_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control is-expanded"},[_c('span',{staticClass:"button is-static is-fullwidth"},[_vm._v(_vm._s(_vm.sliderValue))])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('span',{staticClass:"button is-dark",on:{"click":function($event){_vm.fillData(_vm.chartChangeData)}}},[_vm._v("UPDATE CHART")])])]),_vm._v(" "),_c('div',{staticClass:"small"},[_c('line-chart',{attrs:{"chart-data":_vm.datacollection}})],1)],1),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"title is-5",attrs:{"align":"center"}},[_vm._v("LAST YEAR")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"subtitle is-5 is-spaced",attrs:{"align":"center"}},[_vm._v("TOTAL")]),_vm._v(" "),_c('p',{staticClass:"subtitle is-6",attrs:{"align":"center"}},[_vm._v(" "+_vm._s(_vm.tileObj[1].sum)+" ")]),_vm._v(" "),_c('p',{staticClass:"subtitle is-5 is-spaced",attrs:{"align":"center"}},[_vm._v("AVERAGE")]),_vm._v(" "),_c('p',{staticClass:"subtitle is-6",attrs:{"align":"center"}},[_vm._v(" "+_vm._s(_vm.tileObj[1].avg)+" ")])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('p',{staticClass:"subtitle is-4",attrs:{"align":"center"}},[_vm._v("TOP 10")]),_c('br'),_vm._v(" "),_vm._l((_vm.tileObj[1].sorted),function(item){return _c('ol',{staticClass:"subtitle is-6",attrs:{"align":"center"}},[_vm._v("\n                  "+_vm._s(item.dateTime)+" - "+_vm._s(item.value)+"\n                ")])})],2)])])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EetY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminRegister_vue__ = __webpack_require__("S0ha");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36094b28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminRegister_vue__ = __webpack_require__("/9G1");
function injectStyle (ssrContext) {
  __webpack_require__("79Kf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36094b28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36094b28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FGg3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FIJ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FJSo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FVO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'messageModal',
  data: function data() {
    return {
      messageModal: true,
      message: {
        key: '',
        date: '',
        subject: '',
        message: ''
      }
    };
  },

  methods: {
    dismissMessage: function dismissMessage() {
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(this.$store.getters.user.id).child('messages').child(this.message.key).update({
        dismissed: true
      });
      this.$emit('close');
    }
  },
  mounted: function mounted() {
    var _this = this;

    // listen for the event when the user is found by email
    this.$root.$on('currentMessage', function (currentMessage) {
      _this.message.key = currentMessage.key;
      _this.message.date = currentMessage.date;
      _this.message.subject = currentMessage.subject;
      _this.message.message = currentMessage.message;
    });
  }
});

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localstorage__ = __webpack_require__("UnSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Avatar_didimoModal_vue__ = __webpack_require__("RWhW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_Badges_ApolloBadgeGold_png__ = __webpack_require__("Kbp6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_Badges_ApolloBadgeGold_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_Badges_ApolloBadgeGold_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_Badges_ArtemisBadgeBronze_png__ = __webpack_require__("PQCO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_Badges_ArtemisBadgeBronze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_Badges_ArtemisBadgeBronze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_Badges_AthenaBadgeGold_png__ = __webpack_require__("gKAU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_Badges_AthenaBadgeGold_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_Badges_AthenaBadgeGold_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_Badges_HeraBadgePlatinum_png__ = __webpack_require__("2nJM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_Badges_HeraBadgePlatinum_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_Badges_HeraBadgePlatinum_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_Badges_PoseidonBadgeBronze_png__ = __webpack_require__("GBCF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_Badges_PoseidonBadgeBronze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_Badges_PoseidonBadgeBronze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_Badges_ZeusBadgePlatinum_png__ = __webpack_require__("GwdR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_Badges_ZeusBadgePlatinum_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_Badges_ZeusBadgePlatinum_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_Badges_VestaBadgeSilver_png__ = __webpack_require__("vvyU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_Badges_VestaBadgeSilver_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_Badges_VestaBadgeSilver_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_Badges_OdysseusBadgeSilver_png__ = __webpack_require__("22zb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_Badges_OdysseusBadgeSilver_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_Badges_OdysseusBadgeSilver_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_logo_png__ = __webpack_require__("7Otq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__usernameModal__ = __webpack_require__("wCqn");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rank: 'No Rank',
      accessToken: '',
      tempUsername: '',
      // gender: null,

      //Radiant colors for radial progress bars
      caloriesStartColor: "#ff9933",
      caloriesEndColor: "#ff0000",
      stepsStartColor: "#e600e6",
      stepsEndColor: "#990099",
      floorsStartColor: "#4e84c4",
      floorsEndColor: "#f4edca",
      stockColor: "#ff6347",
      stockColor1: "#00bfff",
      stockColor2: "#dcdcdc",

      //v-if booleans
      deviceNotSynced: true,
      summaryReady: false,
      showUsernameModal: false,

      //Hardcoded baseline goal values for fitness trackers
      //Overwritten by tracker is applicable
      goalSteps: 10000,
      goalDistance: 10,
      goalCalorieOut: 1000,
      goalMinutes: 100,
      goalFloors: 10,

      //Achieved values of fitness tracker data
      achievedSteps: 0,
      achievedDistance: 0,
      achievedCalorieOut: 0,
      inactiveMinutes: 0,
      lightMinutes: 0,
      fairMinutes: 0,
      activeMinutes: 0,
      achievedFloors: 0,

      //Percentages calculated from achieved/goals
      stepsPercent: 0,
      distancePercent: 0,
      caloriePercent: 0,
      floorPercent: 0
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
    // rankSource() {
    //   this.getRankData()
    //   return this.setRank()
    // }

  },
  watch: {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('/users/').child(__WEBPACK_IMPORTED_MODULE_1_firebase__["auth"]().currentUser.uid).once('value').then(function (data) {
      var username = data.child('username').val();
      if (typeof username === 'undefined' || username == null || username == '') {
        _this.showUsernameModal = true;
      }

      var adminLevel = data.child('admin').val();
      if (typeof adminLevel === 'undefined' || adminLevel == null || adminLevel == '') {
        __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('/users/').child(__WEBPACK_IMPORTED_MODULE_1_firebase__["auth"]().currentUser.uid).update({
          admin: false
        }).catch(function (error) {
          console.log(error);
        });
      }

      var fbAccess = data.child('fitbitAccessToken').val();
      if (typeof fbAccess === 'undefined' || fbAccess == null || fbAccess == '') {
        __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('/users/').child(__WEBPACK_IMPORTED_MODULE_1_firebase__["auth"]().currentUser.uid).update({
          fitbitAccessToken: ''
        }).catch(function (error) {
          console.log(error);
        });
      }

      var fitID = data.child('fitbitID').val();
      if (typeof fitID === 'undefined' || fitID == null || fitID == '') {
        __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('/users/').child(__WEBPACK_IMPORTED_MODULE_1_firebase__["auth"]().currentUser.uid).update({
          fitbitID: ''
        }).catch(function (error) {
          console.log(error);
        });
      }
    }).catch(function (error) {
      console.log(error);
    });
  },
  mounted: function mounted() {
    this.setAccessToken();
    this.getProgressData();
    this.getProfileData();

    this.$root.$on('close', function () {
      this.showUsernameModal = false;
    });
  },

  methods: {

    // //If FITBIT authorization is confirmed set a cookie as the access token
    setAccessToken: function setAccessToken() {
      if (window.location.href.indexOf("state=confirm") > -1) {
        this.$cookies.set('oauth_access_token', window.location.href.split('access_token=')[1].split('&')[0], '1m');
        this.accessToken = window.location.href.split('access_token=')[1].split('&')[0];
        __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('users').child(this.user.id).update({
          fitbitAccessToken: this.accessToken
        });
      }
    },


    //Get users fitbit profile ID for challenge needs - store to firebase
    getProfileData: function getProfileData() {
      if (this.$cookies.isKey('oauth_access_token')) {
        var AuthString = 'Bearer ' + this.$cookies.get('oauth_access_token');
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = AuthString;

        //Call for profile data
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'get',
          url: 'https://api.fitbit.com/1/user/-/profile.json'
        }).then(function (response) {
          var obj = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
          __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('users').child(__WEBPACK_IMPORTED_MODULE_1_firebase__["auth"]().currentUser.uid).update({
            fitbitID: obj.user.encodedId
          });
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.deviceNotSynced = true;
      }
    },


    //Check to make sure access is granted to FITBIT Web API by checking for access token
    //Access granted -> get todays tracker data
    getProgressData: function getProgressData() {
      var _this2 = this;

      if (this.$cookies.isKey('oauth_access_token')) {
        var AuthString = 'Bearer ' + this.$cookies.get('oauth_access_token');
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = AuthString;

        //Call for 1 month of data
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'get',
          url: 'https://api.fitbit.com/1/user/-/activities/date/today.json'
        }).then(function (response) {
          _this2.setProgressData(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data)));
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.deviceNotSynced = true;
      }
    },


    //Update charts with progress data
    setProgressData: function setProgressData(val) {
      //Set goals
      this.goalSteps = parseInt(val.goals.steps);
      this.goalDistance = parseInt(val.goals.distance);
      this.goalCalorieOut = parseInt(val.goals.caloriesOut);
      this.goalMinutes = parseInt(val.goals.activeMinutes);
      if (isNaN(val.goals.floors)) {
        this.goalFloors = 10;
      } else {
        this.goalFloors = val.goals.floors;
      }

      //Set achieved
      this.achievedSteps = parseInt(val.summary.steps);
      this.achievedDistance = parseInt(val.summary.distances[0].distance);
      this.achievedCalorieOut = parseInt(val.summary.caloriesOut);
      this.inactiveMinutes = parseInt(val.summary.sedentaryMinutes);
      this.fairMinutes = parseInt(val.summary.fairlyActiveMinutes);
      this.lightMinutes = parseInt(val.summary.lightlyActiveMinutes);
      this.activeMinutes = parseInt(val.summary.veryActiveMinutes);
      if (isNaN(val.summary.floors)) {
        this.achievedFloors = 0;
      } else {
        this.achievedFloors = val.summary.floors;
      }

      //Set percents
      this.stepsPercent = Number(this.achievedSteps / this.goalSteps * 100).toFixed(0);
      this.distancePercent = Number(this.achievedDistance / this.goalDistance * 100).toFixed(0);
      this.caloriePercent = Number(this.achievedCalorieOut / this.goalCalorieOut * 100).toFixed(0);
      if (isNaN(this.achievedFloors)) {
        this.floorPercent = 0;
      } else {
        this.floorPercent = Number(this.achievedFloors / this.goalFloors * 100).toFixed(0);
      }

      this.deviceNotSynced = false;
      this.summaryReady = true;
    },


    //Get step count from fitbit - last sunday and previous 7 days to calculate rank
    getRankData: function getRankData() {
      var _this3 = this;

      var end = '';
      var endD = new Date();
      //If today is sunday get last sunday
      if (endD.getDay() == 0) {
        endD.setDate(endD.getDate() - 7);
      } else {
        endD.setDate(endD.getDate() - endD.getDay());
      }

      //Convert date format to fitbit friendly YYYY-MM-DD
      if (endD.getMonth() + 1 < 10) {
        if (endD.getDate() < 10) {
          end = endD.getFullYear() + '-0' + (endD.getMonth() + 1) + '-0' + endD.getDate();
        } else {
          end = endD.getFullYear() + '-0' + (endD.getMonth() + 1) + '-' + endD.getDate();
        }
      } else {
        if (endD.getDate() < 10) {
          end = endD.getFullYear() + '-' + (endD.getMonth() + 1) + '-0' + endD.getDate();
        } else {
          end = endD.getFullYear() + '-' + (endD.getMonth() + 1) + '-' + endD.getDate();
        }
      }

      //Check to make sure access is granted to FITBIT Web API by checking for access token
      //Access granted -> get week data last sunday and previous 7 days for user rank
      if (this.$cookies.isKey('oauth_access_token')) {
        var AuthString = 'Bearer ' + this.$cookies.get('oauth_access_token');
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = AuthString;

        //Call for 7 days of data
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({ method: 'get',
          url: 'https://api.fitbit.com/1/user/-/activities/tracker/steps/date/' + end + '/7d.json'
        }).then(function (response) {
          var rank = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data);
          rank = JSON.parse(rank.split('steps\":')[1].split(']}')[0] + ']');

          //Sum the steps for pass to setRank
          var rankSteps = 0;
          for (var key in rank) {
            rankSteps += parseInt(rank[key].value);
          }

          //Set rank in store
          if (rankSteps >= 20000 && rankSteps < 30000) {
            if (_this3.gender == 'Male') {
              // this.$store.dispatch('changeRank', 'Poseidon')
            } else {
                // this.$store.dispatch('changeRank', 'Artemis')
              }
          } else if (rankSteps >= 30000 && rankSteps < 40000) {
            if (_this3.gender == 'Male') {
              // this.$store.dispatch('changeRank', 'Odysseus')
            } else {
                // this.$store.dispatch('changeRank', 'Vesta')
              }
          } else if (rankSteps >= 40000 && rankSteps < 50000) {
            if (_this3.gender == 'Male') {
              // this.$store.dispatch('changeRank', 'Apollo')
            } else {
                // this.$store.dispatch('changeRank', 'Athena')
              }
          } else if (rankSteps >= 50000) {
            if (_this3.gender == 'Male') {
              // this.$store.dispatch('changeRank', 'Zeus')
            } else {
                // this.$store.dispatch('changeRank', 'Hera')
              }
          } else {
            // this.$store.dispatch('changeRank', 'No Rank')
            console.log('Set Rank State Error');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.deviceNotSynced = true;
      }
    },


    //Set rank and award badge
    setRank: function setRank() {
      switch (this.user.rank) {
        case 'Zeus':
          this.rank = 'Platinum Level Achieved';
          return __WEBPACK_IMPORTED_MODULE_11__assets_Badges_ZeusBadgePlatinum_png___default.a;
          break;
        case 'Poseidon':
          this.rank = 'Bronze Level Achieved';
          return __WEBPACK_IMPORTED_MODULE_10__assets_Badges_PoseidonBadgeBronze_png___default.a;
          break;
        case 'Vesta':
          this.rank = 'Silver Level Achieved';
          return __WEBPACK_IMPORTED_MODULE_12__assets_Badges_VestaBadgeSilver_png___default.a;
          break;
        case 'Odysseus':
          this.rank = 'Silver Level Achieved';
          return __WEBPACK_IMPORTED_MODULE_13__assets_Badges_OdysseusBadgeSilver_png___default.a;
          break;
        case 'Hera':
          this.rank = 'Platinum Level Achieved';
          return __WEBPACK_IMPORTED_MODULE_9__assets_Badges_HeraBadgePlatinum_png___default.a;
          break;
        case 'Athena':
          this.rank = 'Gold Level Achieved';
          return __WEBPACK_IMPORTED_MODULE_8__assets_Badges_AthenaBadgeGold_png___default.a;
          break;
        case 'Artemis':
          this.rank = 'Bronze Level Achieved';
          return __WEBPACK_IMPORTED_MODULE_7__assets_Badges_ArtemisBadgeBronze_png___default.a;
          break;
        case 'Apollo':
          this.rank = 'Gold Level Achieved';
          return __WEBPACK_IMPORTED_MODULE_6__assets_Badges_ApolloBadgeGold_png___default.a;
          break;
        case 'No Rank':
          this.rank = 'Keep Working Hard';
          return __WEBPACK_IMPORTED_MODULE_14__assets_logo_png___default.a;
          break;
        default:
          console.log('Set Rank Error');
          this.rank = 'Badge Error';
          break;
      }
    }
  },
  components: {
    didimoModal: __WEBPACK_IMPORTED_MODULE_5__Avatar_didimoModal_vue__["a" /* default */],
    usernameModal: __WEBPACK_IMPORTED_MODULE_16__usernameModal__["a" /* default */]
  }
});

/***/ }),

/***/ "GBBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GBCF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/PoseidonBadgeBronze.f0336ca.png";

/***/ }),

/***/ "GEU/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cameraModal_vue__ = __webpack_require__("90FC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a048862_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cameraModal_vue__ = __webpack_require__("714C");
function injectStyle (ssrContext) {
  __webpack_require__("bjju")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a048862"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cameraModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a048862_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cameraModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Gf+F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GkPm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GwdR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ZeusBadgePlatinum.1e34862.png";

/***/ }),

/***/ "IBEa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__challengeModal_vue__ = __webpack_require__("oeeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









//Include the use of google maps in Vue
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBIgWkXLfO8bgbBfQF_N-r7Ut0SK0DRzRE',
    v: '3'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'challenge-modal': __WEBPACK_IMPORTED_MODULE_5__challengeModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      searchedUser: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
        rank: ''
      },

      showChallengeModal: false,
      showMap: true,
      foundEmail: false,

      email: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['challenges', 'pastChallenges', 'availableChallengers', 'user', 'mapCenter'])),
  mounted: function mounted() {
    this.daysLeft();
    /*
        this listener listens for when the challengeModal closes
        if you don't set these to false you can't search again because it stores
        the information that was there on the last search
     */
    this.$root.$on('close', function () {
      this.foundEmail = false;
      this.showChallengeModal = false;
    });

    this.$root.$on('closeChallengeModal', function () {
      this.showChallengeModal = false;
    });
  },

  methods: {
    //Accept/decline challenge by changing accept value in the store and updating firebase accordingly
    acceptChallenge: function acceptChallenge(key, acceptVal) {
      var d = new Date();
      var challengeStart = d.getMonth() + 1 + '/' + (d.getDate() + 1) + '/' + d.getFullYear();

      var updatedChallenge = {
        key: key,
        opponentHasAccepted: acceptVal,
        startDate: challengeStart
      };
      this.$store.dispatch('acceptChallenge', updatedChallenge);
    },


    // get daysLeft in challenge
    daysLeft: function daysLeft() {
      var _this = this;

      var opposeName = '';
      var opposeRank = '';
      var opposeId = '';
      var t = new Date();
      var today = Date.UTC(t.getFullYear(), t.getMonth(), t.getDate());
      var _MS_PER_DAY = 1000 * 60 * 60 * 24;
      var challenges = this.challenges;
      console.log(challenges);
      var currentId = this.user.id;
      console.log(currentId);
      var currentName = this.user.firstName;
      var currentRank = this.user.rank;

      var _loop = function _loop(val) {
        var start = new Date(challenges[val].startDate);
        var duration = challenges[val].duration;
        var key = challenges[val].key;
        var daysSinceStart = Math.ceil((today - start) / _MS_PER_DAY);

        if (currentId == challenges[val].opponentId) {
          opposeId = challenges[val].challengerId;
          opposeName = challenges[val].challengerFirstName;
          if (challenges[val].challengerRank == null || challenges[val].challengerRank == undefined) {
            opposeRank = 'No Rank';
          } else {
            opposeRank = challenges[val].challengerRank;
          }
        } else if (currentId == challenges[val].challengerId) {
          opposeId = challenges[val].opponentId;
          opposeName = challenges[val].opponentFirstName;
          if (challenges[val].opponentRank == null || challenges[val].opponentRank == undefined) {
            opposeRank = 'No Rank';
          } else {
            opposeRank = challenges[val].opponentRank;
          }
        }

        if (daysSinceStart >= duration) {
          var end = _this.formatDate(start, duration - 1);
          console.log('end: ' + end);

          var formatStart = _this.formatDate(start, 0);
          console.log('start: ' + formatStart);

          __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users').child(opposeId).once('value').then(function (data) {
            var obj = data.val();

            var opposeData = {
              fitbitId: obj.fitbitID,
              authToken: obj.fitbitAccessToken
            };
            console.log('get: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(opposeData));

            __WEBPACK_IMPORTED_MODULE_7_axios___default.a.all([_this.getLoggedInSteps(end, formatStart), _this.getOpposeSteps(end, formatStart, opposeData.fitbitId, opposeData.authToken)]).then(__WEBPACK_IMPORTED_MODULE_7_axios___default.a.spread(function (obj1, obj2) {
              var sum1 = 0;
              console.log('comp1: ' + obj1);
              obj1 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj1.data);
              obj1 = JSON.parse(obj1.split('steps\":')[1].split(']}')[0] + ']');
              for (var j in obj1) {
                sum1 += parseInt(obj1[j].value);
              }
              console.log('Sum1: ' + sum1);

              var sum2 = 0;
              console.log('comp2: ' + obj2);
              obj2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj2.data);
              obj2 = JSON.parse(obj2.split('steps\":')[1].split(']}')[0] + ']');
              for (var j in obj2) {
                sum2 += parseInt(obj2[j].value);
              }
              console.log('sum2: ' + sum2);

              var win = '';
              var win2 = '';
              if (sum1 > sum2) {
                win = 'WON';
                win2 = 'LOST';
              } else if (sum2 > sum1) {
                win = 'LOST';
                win2 = 'WON';
              } else {
                win = 'TIED';
                win2 = 'TIED';
              }

              console.log('win: ' + win);
              console.log('win2: ' + win2);

              //add to current users challenge history
              __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users').child(currentId).child('challengeHistory').child(key).update({
                opponentId: opposeId,
                winnerId: win,
                opponentFirstName: opposeName,
                opponentRank: opposeRank
              }).catch(function (error) {
                console.log(error);
              });

              //add to opposing users challenge history
              __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users').child(opposeId).child('challengeHistory').child(key).update({
                opponentId: currentId,
                winnerId: win2,
                opponentFirstName: currentName,
                opponentRank: currentRank
              }).catch(function (error) {
                console.log(error);
              });
            }));
            //Delete challenge from challenges array
            _this.$store.dispatch('deleteChallenge', key);
          }).catch(function (error) {
            console.log(error);
          });
        }
      };

      for (var val in challenges) {
        _loop(val);
      }
    },
    getLoggedInSteps: function getLoggedInSteps(end, start) {
      if (this.$cookies.isKey('oauth_access_token')) {
        var AuthString = 'Bearer ' + this.$cookies.get('oauth_access_token');
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.headers.common['Authorization'] = AuthString;

        //Call for steps of current user logged in
        return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('https://api.fitbit.com/1/user/-/activities/tracker/steps/date/' + start + '/' + end + '.json');
      }
    },
    getOpposeSteps: function getOpposeSteps(end, start, opposeFitbitId, opposeAuthToken) {
      if (opposeAuthToken !== null) {
        var AuthString = 'Bearer ' + opposeAuthToken;
        __WEBPACK_IMPORTED_MODULE_7_axios___default.a.defaults.headers.common['Authorization'] = AuthString;

        //Call for steps of other user invovled in challenge
        return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get('https://api.fitbit.com/1/user/' + opposeFitbitId + '/activities/tracker/steps/date/' + start + '/' + end + '.json');
      }
    },
    formatDate: function formatDate(d, sub) {
      var end = '';
      var endD = new Date(d);
      endD.setDate(endD.getDate() + sub);

      //Convert date format to fitbit friendly YYYY-MM-DD
      if (endD.getMonth() + 1 < 10) {
        if (endD.getDate() < 10) {
          end = endD.getFullYear() + '-0' + (endD.getMonth() + 1) + '-0' + endD.getDate();
        } else {
          end = endD.getFullYear() + '-0' + (endD.getMonth() + 1) + '-' + endD.getDate();
        }
      } else {
        if (endD.getDate() < 10) {
          end = endD.getFullYear() + '-' + (endD.getMonth() + 1) + '-0' + endD.getDate();
        } else {
          end = endD.getFullYear() + '-' + (endD.getMonth() + 1) + '-' + endD.getDate();
        }
      }
      return end;
    },


    //Call challenge modal and emit the chosen user to be challenged
    showModal: function showModal(n, r, i) {
      this.searchedUser.firstName = n;
      this.searchedUser.rank = r;
      this.searchedUser.id = i;
      this.$root.$emit('selectOpponent', this.searchedUser);
      this.showChallengeModal = true;

      this.searchedUser.firstName = null;
      this.searchedUser.rank = null;
      this.searchedUser.id = null;
    },


    // Creates a toggle button for the map or list views.
    show: function show() {
      if (this.showMap) {
        document.getElementsByClassName('toggle').innerHTML = 'Map View';
      } else {
        document.getElementsByClassName('toggle').innerHTML = 'List View';
      }
      this.showMap = !this.showMap;
    },


    // search for user by email
    //----------------------------------------------------------
    // future implementation will search by username
    //----------------------------------------------------------
    searchForUser: function searchForUser() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users').once('value').then(function (data) {
        var obj = data.val(); // store all objects
        for (var _key in obj) {
          // for each key in the group
          var tempId = _key;
          var tempEmail = obj[_key].email;
          var firstName = obj[_key].firstName;
          var lastName = obj[_key].lastName;
          var rank = obj[_key].rank;

          if (_this2.email === tempEmail) {
            _this2.foundEmail = true;
            _this2.searchedUser.id = tempId;
            _this2.searchedUser.email = tempEmail;
            _this2.searchedUser.firstName = firstName;
            _this2.searchedUser.rank = rank;
          }
        }
        if (_this2.foundEmail) {
          _this2.$root.$emit('selectOpponent', _this2.searchedUser); // emit the event that we found a match
          _this2.showChallengeModal = true;
          _this2.foundEmail = false;
        } else {
          _this2.showChallengeModal = false;
          _this2.$toasted.show("User not found. Check entry and try again.", {
            theme: "outline",
            position: "top-center",
            duration: 3000,
            fitToScreen: true
          });
        }

        _this2.searchedUser.id = '';
        _this2.searchedUser.email = '';
        _this2.searchedUser.firstName = '';
        _this2.searchedUser.rank = '';
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user__ = __webpack_require__("6EED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__challenge__ = __webpack_require__("y1TV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__avatar__ = __webpack_require__("p6ZZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__admin__ = __webpack_require__("phKf");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);






var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_3__user__["a" /* default */],
    challenge: __WEBPACK_IMPORTED_MODULE_4__challenge__["a" /* default */],
    avatar: __WEBPACK_IMPORTED_MODULE_5__avatar__["a" /* default */],
    admin: __WEBPACK_IMPORTED_MODULE_6__admin__["a" /* default */]
  }
});

/***/ }),

/***/ "JKjj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Terms & Conditions")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body",attrs:{"id":"top"}},[_vm._m(0,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("AGREEMENT TO TERMS")]),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("INTELLECTUAL PROPERTY RIGHTS")]),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("USER REPRESENTATIONS")]),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("USER REGISTRATION")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n          You are required to register with the Site. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.\r\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("PROHIBITED ACTIVITIES")]),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("USER GENERATED CONTRIBUTIONS")]),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("CONTRIBUTION LICENSE")]),_vm._v(" "),_vm._m(6,false,false),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("GUIDELINES FOR REVIEWS")]),_vm._v(" "),_vm._m(7,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("MOBILE APPLICATION LICENSE")]),_c('h4',{staticClass:"section-header"},[_vm._v("Use License")]),_vm._v(" "),_vm._m(8,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Apple and Android Devices")]),_vm._v(" "),_vm._m(9,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("SOCIAL MEDIA")]),_vm._v(" "),_vm._m(10,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("SUBMISSIONS")]),_vm._v(" "),_vm._m(11,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("THIRD-PARTY WEBSITES AND CONTENT")]),_vm._v(" "),_vm._m(12,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("ADVERTISERS")]),_vm._v(" "),_vm._m(13,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("SITE MANAGEMENT")]),_vm._v(" "),_vm._m(14,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("PRIVACY POLICY")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We care about data privacy and security. Please review our Privacy Policy "),_c('button',{staticClass:"as-text",on:{"click":function($event){_vm.showPrivacyModal=true}}},[_vm._v("[CLICK HERE]")]),_vm._v(". By using the Site, you agree to be bound by our Privacy Policy, which is incorporated into these Terms of Use.  Please be advised the Site is hosted in the United States.  If you access the Site from the European Union, Asia, or any other region of the world with laws or other requirements governing personal data collection, use, or disclosure that differ from applicable laws in the United States, then through your continued use of the Site or Services, you are transferring your data to the United States, and you expressly consent to have your data transferred to and processed in the United States. [Further, we do not knowingly accept, request, or solicit information from children or knowingly market to children.  Therefore, in accordance with the U.S. Children’s Online Privacy Protection Act, if we receive actual knowledge that anyone under the age of 13 has provided personal information to us without the requisite and verifiable parental consent, we will delete that information from the Site as quickly as is reasonably practical.]\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("DIGITAL MILLENNIUM COPYRIGHT ACT (DMCA) NOTICE AND POLICY")]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Notifications")]),_vm._v(" "),_vm._m(15,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Counter Notification")]),_vm._v(" "),_vm._m(16,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("COPYRIGHT INFRINGEMENTS")]),_vm._v(" "),_vm._m(17,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("TERM AND TERMINATION")]),_vm._v(" "),_vm._m(18,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("MODIFICATIONS AND INTERRUPTIONS")]),_vm._v(" "),_vm._m(19,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("GOVERNING LAW")]),_vm._v(" "),_vm._m(20,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("DISPUTE RESOLUTION")]),_vm._v(" "),_vm._m(21,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Option 2: Informal Negotiations")]),_vm._v(" "),_vm._m(22,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Binding Arbitration")]),_vm._v(" "),_vm._m(23,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Option 3: Binding Arbitration")]),_vm._v(" "),_vm._m(24,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Option 2/Option 3: Restrictions")]),_vm._v(" "),_vm._m(25,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Option 2/Option 3: Exceptions to [Informal Negotiations and] Arbitration")]),_vm._v(" "),_vm._m(26,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("CORRECTIONS")]),_vm._v(" "),_vm._m(27,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("DISCLAIMER")]),_vm._v(" "),_vm._m(28,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("LIMITATIONS OF LIABILITY")]),_vm._v(" "),_vm._m(29,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("INDEMNIFICATION")]),_vm._v(" "),_vm._m(30,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("USER DATA")]),_vm._v(" "),_vm._m(31,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES")]),_vm._v(" "),_vm._m(32,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("CALIFORNIA USERS AND RESIDENTS")]),_vm._v(" "),_vm._m(33,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("MISCELLANEOUS")]),_vm._v(" "),_vm._m(34,false,false),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("CONTACT US")]),_vm._v(" "),_vm._m(35,false,false),_vm._v(" "),_c('PrivacyModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPrivacyModal),expression:"showPrivacyModal"}],on:{"close":function($event){_vm.showPrivacyModal = false}}})],1),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"field is-grouped"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-medium",on:{"click":function($event){_vm.$emit('event_TOC', true)}}},[_vm._v("Accept")]),_vm._v(" "),_c('button',{staticClass:"button is-medium",on:{"click":function($event){_vm.$emit('event_TOC', false)}}},[_vm._v("Decline")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"body-header"},[_vm._v("WWW.KNOSISHEALTH.COM"),_c('br'),_vm._v("\r\n          PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY"),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n          These Terms and Conditions constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”) and KNOSIS Health ​(“we,” “us” or “our”), concerning your access to and use of the www.knosishealth.com website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the “Site”). You agree that by accessing the Site, you have read, understood, and agree to be bound by all of these Terms and Conditions Use. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS and CONDITIONS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.\r\n          "),_c('br'),_c('br'),_vm._v("\r\n          Supplemental terms and conditions or documents that may be posted on the Site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Terms and Conditions at any time and for any reason. We will alert you about any changes by updating the “Last updated” date of these Terms and Conditions and you waive any right to receive specific notice of each such change. It is your responsibility to periodically review these Terms and Conditions to stay informed of updates. You will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Terms and Conditions by your continued use of the Site after the date such revised Terms are posted.\r\n          "),_c('br'),_c('br'),_vm._v("\r\n          The information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons who choose to access the Site from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable.\r\n          "),_c('br'),_c('br'),_vm._v("\r\n          [The Site is intended for users who are at least 13 years of age.] All users who are minors in the jurisdiction in which they reside (generally under the age of 18) must have the permission of, and be directly supervised by, their parent or guardian to use the Site. If you are a minor, you                   must have your parent or guardian read and agree to these Terms of Use prior to you using the Site.\r\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n          Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the “Marks”) are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of the United States, foreign jurisdictions, and international conventions.  The Content and the Marks are provided on the Site “AS IS” for your information and personal use only.  Except as expressly provided in these Terms of Use, no part of the Site and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.\r\n          "),_c('br'),_c('br'),_vm._v("\r\n          Provided that you are eligible to use the Site, you are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which you have properly gained access solely for your personal, non-commercial use. We reserve all rights not expressly granted to you in and to the Site, Content and the Marks.\r\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n          By using the Site, you represent and warrant that: [(1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and promptly update such registration information as necessary;] (3) you have the legal capacity and you agree to comply with these Terms of Use; [(4) you are not under the age of 13;] (5) not a minor in the jurisdiction in which you reside[, or if a minor, you have received parental permission to use the Site]; (6) you will not access the Site through automated or non-human means, whether through a bot, script or otherwise; (7) you will not use the Site for any illegal or unauthorized purpose;  and (8) your use of the Site will not violate any applicable law or regulation.\r\n          "),_c('br'),_c('br'),_vm._v("\r\n          If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate your account and refuse any and all current or future use of the Site (or any portion thereof).\r\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n          You may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.\r\n          "),_c('br'),_c('br'),_vm._v("\r\n          As a user of the Site, you agree not to:\r\n          "),_c('ol',{staticClass:"listed-values"},[_c('li',[_vm._v("systematically retrieve data or other content from the Site to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.")]),_vm._v(" "),_c('li',[_vm._v("make any unauthorized use of the Site, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.")]),_vm._v(" "),_c('li',[_vm._v("use a buying agent or purchasing agent to make purchases on the Site.")]),_vm._v(" "),_c('li',[_vm._v("use the Site to advertise or offer to sell goods and services.")]),_vm._v(" "),_c('li',[_vm._v("circumvent, disable, or otherwise interfere with security-related features of the Site, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Site and/or the Content contained therein.")]),_vm._v(" "),_c('li',[_vm._v("engage in unauthorized framing of or linking to the Site.")]),_vm._v(" "),_c('li',[_vm._v("trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords;")]),_vm._v(" "),_c('li',[_vm._v("make improper use of our support services or submit false reports of abuse or misconduct.")]),_vm._v(" "),_c('li',[_vm._v("engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.")]),_vm._v(" "),_c('li',[_vm._v("interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.")]),_vm._v(" "),_c('li',[_vm._v("attempt to impersonate another user or person or use the username of another user.")]),_vm._v(" "),_c('li',[_vm._v("sell or otherwise transfer your profile.")]),_vm._v(" "),_c('li',[_vm._v("use any information obtained from the Site in order to harass, abuse, or harm another person.")]),_vm._v(" "),_c('li',[_vm._v("use the Site as part of any effort to compete with us or otherwise use the Site and/or the Content for any revenue-generating endeavor or commercial enterprise.")]),_vm._v(" "),_c('li',[_vm._v("decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Site.")]),_vm._v(" "),_c('li',[_vm._v("attempt to bypass any measures of the Site designed to prevent or restrict access to the Site, or any portion of the Site.")]),_vm._v(" "),_c('li',[_vm._v("harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Site to you.")]),_vm._v(" "),_c('li',[_vm._v("delete the copyright or other proprietary rights notice from any Content.")]),_vm._v(" "),_c('li',[_vm._v("copy or adapt the Site’s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.")]),_vm._v(" "),_c('li',[_vm._v("upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Site.")]),_vm._v(" "),_c('li',[_vm._v("upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear graphics interchange formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as “spyware” or “passive collection mechanisms” or “pcms”).")]),_vm._v(" "),_c('li',[_vm._v("except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Site, or using or launching any unauthorized script or other software.")]),_vm._v(" "),_c('li',[_vm._v("disparage, tarnish, or otherwise harm, in our opinion, us and/or the Site.")]),_vm._v(" "),_c('li',[_vm._v("use the Site in a manner inconsistent with any applicable laws or regulations.")]),_vm._v(" "),_c('li',[_vm._v("[other]")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n          The Site may invite you to chat, contribute to, or participate in blogs, message boards, online forums, feedback submission, and other functionality, and may provide you with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or on the Site, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, \"Contributions\"). Contributions may be viewable by other users of the Site and through third-party websites. Uploaded photos to create the KNOSIS Avatar are stored and managed by MyDidimo, Inc. a Delaware Company. As such, any Contributions you transmit may be treated as non-confidential and non-proprietary.  When you create or make available any Contributions, you thereby represent and warrant that:\r\n          "),_c('br'),_vm._v(" "),_c('ol',{staticClass:"listed-values"},[_c('li',[_vm._v("the creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of your Contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party.")]),_vm._v(" "),_c('li',[_vm._v("you are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the Site, and other users of the Site to use your Contributions in any manner contemplated by the Site and these Terms of Use.")]),_vm._v(" "),_c('li',[_vm._v("you have the written consent, release, and/or permission of each and every identifiable individual person in your Contributions to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of your Contributions in any manner contemplated by the Site and these Terms of Use.")]),_vm._v(" "),_c('li',[_vm._v("your Contributions are not false, inaccurate, or misleading.")]),_vm._v(" "),_c('li',[_vm._v("your Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.")]),_vm._v(" "),_c('li',[_vm._v("your Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as determined by us).")]),_vm._v(" "),_c('li',[_vm._v("your Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.")]),_vm._v(" "),_c('li',[_vm._v("your Contributions do not advocate the violent overthrow of any government or incite, encourage, or threaten physical harm against another.")]),_vm._v(" "),_c('li',[_vm._v("your Contributions do not violate any applicable law, regulation, or rule.")]),_vm._v(" "),_c('li',[_vm._v("your Contributions do not violate the privacy or publicity rights of any third party.")]),_vm._v(" "),_c('li',[_vm._v("your Contributions do not contain any material that solicits personal information from anyone under the age of 18 or exploits people under the age of 18 in a sexual or violent manner.")]),_vm._v(" "),_c('li',[_vm._v("your Contributions do not violate any federal or state law concerning child pornography, or otherwise intended to protect the health or well-being of minors;")]),_vm._v(" "),_c('li',[_vm._v("your Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap.")]),_vm._v(" "),_c('li',[_vm._v("your Contributions do not otherwise violate, or link to material that violates, any provision of these Terms of Use, or any applicable law or regulation.")])]),_vm._v(" "),_c('br'),_vm._v("\r\n          Any use of the Site in violation of the foregoing violates these Terms of Use and may result in, among other things, termination or suspension of your rights to use the Site.\r\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        By posting your Contributions to any part of the Site [or making Contributions accessible to the Site by linking your account from the Site to any of your social networking accounts], you automatically grant, and you represent and warrant that you have the right to grant, to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and license to host, use, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle, archive, store, cache, publicly perform, publicly display, reformat, translate, transmit, excerpt (in whole or in part), and distribute such Contributions (including, without limitation, your image and voice) for any purpose, commercial, advertising, or otherwise, and to prepare derivative works of, or incorporate into other works, such Contributions, and grant and authorize sublicenses of the foregoing. The use and distribution may occur in any media formats and through any media channels.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        This license will apply to any form, media, or technology now known or hereafter developed, and includes our use of your name, company name, and franchise name, as applicable, and any of the trademarks, service marks, trade names, logos, and personal and commercial images you provide.  You waive all moral rights in your Contributions, and you warrant that moral rights have not otherwise been asserted in your Contributions.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        We do not assert any ownership over your Contributions.  You retain full ownership of all of your Contributions and any intellectual property rights or other proprietary rights associated with your Contributions.  We are not liable for any statements or representations in your Contributions provided by you in any area on the Site.  You are solely responsible for your Contributions to the Site and you expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding your Contributions.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        We have the right, in our sole and absolute discretion, (1) to edit, redact, or otherwise change any Contributions; (2) to re-categorize any Contributions to place them in more appropriate locations on the Site; and (3) to pre-screen or delete any Contributions at any time and for any reason, without notice. We have no obligation to monitor your Contributions.\r\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may provide you areas on the Site to leave reviews or ratings. When posting a review, you must comply with the following criteria: (1) you should have firsthand experience with the person/entity being reviewed; (2) your reviews should not contain offensive profanity, or abusive, racist, offensive, or hate language; (3) your reviews should not contain discriminatory references based on religion, race, gender, national origin, age, marital status, sexual orientation, or disability; (4) your reviews should not contain references to illegal activity; (5) you should not be affiliated with competitors if posting negative reviews; (6) you should not make any conclusions as to the legality of conduct; (7) you may not post any false or misleading statements; and (8) you may not organize a campaign encouraging others to post reviews, whether positive or negative.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        We may accept, reject, or remove reviews in our sole discretion. We have absolutely no obligation to screen reviews or to delete reviews, even if anyone considers reviews objectionable or inaccurate.  Reviews are not endorsed by us, and do not necessarily represent our opinions or the views  of any of our affiliates or partners.  We do not assume liability for any review or for any claims, liabilities, or losses resulting from any review. By posting a review, you hereby grant to us a perpetual, non-exclusive, worldwide, royalty-free, fully-paid, assignable, and sublicensable right and license to reproduce, modify, translate, transmit by any means, display, perform, and/or distribute all content relating to reviews.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        If you access the Site via a mobile application, then we grant you a revocable, non-exclusive, non-transferable, limited right to install and use the mobile application on wireless electronic devices owned or controlled by you, and to access and use the mobile application on such devices strictly in accordance with the terms and conditions of this mobile application license contained in these Terms of Use. You shall not: (1) decompile, reverse engineer, disassemble, attempt to derive the source code of, or decrypt the application; (2) make any modification, adaptation, improvement, enhancement, translation, or derivative work from the application; (3) violate any applicable laws, rules, or regulations in connection with your access or use of the application; (4) remove, alter, or obscure any proprietary notice (including any notice of copyright or trademark) posted by us or the licensors of the application; (5) use the application for any revenue generating endeavor, commercial enterprise, or other purpose for which it is not designed or intended; (6) make the application available over a network or other environment permitting access or use by multiple devices or users at the same time; (7) use the application for creating a product, service, or software that is, directly or indirectly, competitive with or in any way a substitute for the application; (8) use the application to send automated queries to any website or to send any unsolicited commercial e-mail; or (9) use any proprietary information or any of our interfaces or our other intellectual property in the design, development, manufacture, licensing, or distribution of any applications, accessories, or devices for use with the application.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        The following terms apply when you use a mobile application obtained from either the Apple Store or Google Play (each an “App Distributor”) to access the Site: (1) the license granted to you for our mobile application is limited to a non-transferable license to use the application on a device that utilizes the Apple iOS or Android operating systems, as applicable, and in accordance with the usage rules set forth in the applicable App Distributor’s terms of service; (2) we are responsible for providing any maintenance and support services with respect to the mobile application as specified in the terms and conditions of this mobile application license contained in these Terms of Use or as otherwise required under applicable law, and you acknowledge that each App Distributor has no obligation whatsoever to furnish any maintenance and support services with respect to the mobile application; (3) in the event of any failure of the mobile application to conform to any applicable warranty, you may notify the applicable App Distributor, and the App Distributor, in accordance with its terms and policies, may refund the purchase price, if any, paid for the mobile application, and to the maximum extent permitted by applicable law, the App Distributor will have no other warranty obligation whatsoever with respect to the mobile application; (4) you represent and warrant that (i) you are not located in a country that is subject to a U.S. government embargo, or that has been designated by the U.S. government as a “terrorist supporting” country and (ii) you are not listed on any U.S. government list of prohibited or restricted parties; (5) you must comply with applicable third-party terms of agreement when using the mobile application, e.g., if you have a VoIP application, then you must not be in violation of their wireless data service agreement when using the mobile application; and (6) you acknowledge and agree that the App Distributors are third-party beneficiaries of the terms and conditions in this mobile application license contained in these Terms of Use, and that each App Distributor will have the right (and will be deemed to have accepted the right) to enforce the terms and conditions in this mobile application license contained in these Terms of Use against you as a third-party beneficiary thereof.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        As part of the functionality of the Site, you may link your account with online accounts you have with third-party service providers (each such account, a “Third-Party Account”) by either: (1) providing your Third-Party Account login information through the Site; or (2) allowing us to access your Third-Party Account, as is permitted under the applicable terms and conditions that govern your use of each Third-Party Account. You represent and warrant that you are entitled to disclose your Third-Party Account login information to us and/or grant us access to your Third-Party Account, without breach by you of any of the terms and conditions that govern your use of the applicable Third-Party Account, and without obligating us to pay any fees or making us subject to any usage limitations imposed by the third-party service provider of the Third-Party Account.  By granting us access to any Third-Party Accounts, you understand that (1) we may access, make available, and store (if applicable) any content that you have provided to and stored in your Third-Party Account (the “Social Network Content”) so that it is available on and through the Site via your account, including without limitation any friend lists and (2) we may submit to and receive from your Third-Party Account additional information to the extent you are notified when you link your account with the Third-Party Account.  Depending on the Third-Party Accounts you choose and subject to the privacy settings that you have set in such Third-Party Accounts, personally identifiable information that you post to your Third-Party Accounts may be available on and through your account on the Site. Please note that if a Third-Party Account or associated service becomes unavailable or our access to such Third-Party Account is terminated by the third-party service provider, then Social Network Content may no longer be available on and through the Site. You will have the ability to disable the connection between your account on the Site and your Third-Party Accounts at any time. PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH YOUR THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS.  We make no effort to review any Social Network Content for any purpose, including but not limited to, for accuracy, legality, or non-infringement, and we are not responsible for any Social Network Content. You acknowledge and agree that we may access your email address book associated with a Third-Party Account and your contacts list stored on your mobile device or tablet computer solely for purposes of identifying and informing you of those contacts who have also registered to use the Site. You can deactivate the connection between the Site and your Third-Party Account by contacting us using the contact information below or through your account settings (if applicable). We will attempt to delete any information stored on our servers that was obtained through such Third-Party Account, except the username and profile picture that become associated with your account.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        You acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other information regarding the Site (\"Submissions\") provided by you to us are non-confidential and shall become our sole property.  We shall own exclusive rights, including all intellectual property rights, and shall be entitled to the unrestricted use and dissemination of these Submissions for any lawful purpose, commercial or otherwise, without acknowledgment or compensation to you.  You hereby waive all moral rights to any such Submissions, and you hereby warrant that any such Submissions are original with you or that you have the right to submit such Submissions.  You agree there shall be no recourse against us for any alleged or actual infringement or misappropriation of any proprietary right in your Submissions.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        The Site may contain (or you may be sent via the Site) links to other websites (\"Third-Party Websites\") as well as articles, photographs, text, graphics, pictures, designs, music, sound, video, information, applications, software, and other content or items belonging to or originating from third parties (\"Third-Party Content\"). Such Third-Party Websites and Third-Party Content are not investigated, monitored, or checked for accuracy, appropriateness, or completeness by us, and we are not responsible for any Third-Party Websites accessed through the Site or any Third-Party Content posted on, available through, or installed from the Site, including the content, accuracy, offensiveness, opinions, reliability, privacy practices, or other policies of or contained in the Third-Party Websites or the Third-Party Content.  Inclusion of, linking to, or permitting the use or installation of any Third-Party Websites or any Third-Party Content does not imply approval or endorsement thereof by us.  If you decide to leave the Site and access the Third-Party Websites or to use or install any Third-Party Content, you do so at your own risk, and you should be aware these Terms of Use no longer govern. You should review the applicable terms and policies, including privacy and data gathering practices, of any website to which you navigate from the Site or relating to any applications you use or install from the Site. Any purchases you make through Third-Party Websites will be through other websites and from other companies, and we take no responsibility whatsoever in relation to such purchases which are exclusively between you and the applicable third party.  You agree and acknowledge that we do not endorse the products or services offered on Third-Party Websites and you shall hold us harmless from any harm caused by your purchase of such products or services.  Additionally, you shall hold us harmless from any losses sustained by you or harm caused to you relating to or resulting in any way from any Third-Party Content or any contact with Third-Party Websites.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        We allow advertisers to display their advertisements and other information in certain areas of the Site, such as sidebar advertisements or banner advertisements.  If you are an advertiser, you shall take full responsibility for any advertisements you place on the Site and any services provided on the Site or products sold through those advertisements.  Further, as an advertiser, you warrant and represent that you possess all rights and authority to place advertisements on the Site, including, but not limited to, intellectual property rights, publicity rights, and contractual rights. [As an advertiser, you agree that such advertisements are subject to our Digital Millennium Copyright Act (“DMCA”) Notice and Policy provisions as described below, and you understand and agree there will be no refund or other compensation for DMCA takedown-related issues.]  We simply provide the space to place such advertisements, and we have no other relationship with advertisers.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        We reserve the right, but not the obligation, to: (1) monitor the Site for violations of these Terms of Use; (2) take appropriate legal action against anyone who, in our sole discretion, violates the law or these Terms of Use, including without limitation, reporting such user to law enforcement authorities; (3) in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of your Contributions or any portion thereof; (4) in our sole discretion and without limitation, notice, or liability, to remove from the Site or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; and (5) otherwise manage the Site in a manner designed to protect our rights and property and to facilitate the proper functioning of the Site.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n       We respect the intellectual property rights of others.  If you believe that any material available on or through the Site infringes upon any copyright you own or control, please immediately notify our Designated Copyright Agent using the contact information provided below (a “Notification”).  A copy of your Notification will be sent to the person who posted or stored the material addressed in the Notification.  Please be advised that pursuant to federal law you may be held liable for damages if you make material misrepresentations in a Notification. Thus, if you are not sure that material located on or linked to by the Site infringes your copyright, you should consider first contacting an attorney.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        All Notifications should meet the requirements of DMCA 17 U.S.C. § 512(c)(3) and include the following information: (1) A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed; (2) identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works on the Site are covered by the Notification, a representative list of such works on the Site; (3) identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit us to locate the material; (4) information reasonably sufficient to permit us to contact the complaining party, such as an address, telephone number, and, if available, an email address at which the complaining party may be contacted; (5) a statement that the complaining party has a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent, or the law; and (6)  a statement that the information in the notification is accurate, and under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed upon.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n       If you believe your own copyrighted material has been removed from the Site as a result of a mistake or misidentification, you may submit a written counter notification to [us/our Designated Copyright Agent] using the contact information provided below (a “Counter Notification”). To be an effective Counter Notification under the DMCA, your Counter Notification must include substantially the following: (1) identification of the material that has been removed or disabled and the location at which the material appeared before it was removed or disabled; (2) a statement that you consent to the jurisdiction of the Federal District Court in which your address is located, or if your address is outside the United States, for any judicial district in which we are located; (3) a statement that you will accept service of process from the party that filed the Notification or the partys agent; (4) your name, address, and telephone number; (5) a statement under penalty of perjury that you have a good faith belief that the material in question was removed or disabled as a result of a mistake or misidentification of the material to be removed or disabled; and (6) your physical or electronic signature.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        If you send us a valid, written Counter Notification meeting the requirements described above, we will restore your removed or disabled material, unless we first receive notice from the party filing the Notification informing us that such party has filed a court action to restrain you from engaging in infringing activity related to the material in question. Please note that if you materially misrepresent that the disabled or removed content was removed by mistake or misidentification, you may be liable for damages, including costs and attorneys fees. Filing a false Counter Notification constitutes perjury.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        Designated Copyright Agent "),_c('br'),_vm._v("\r\n        [Name]"),_c('br'),_vm._v("\r\n        Attn: Copyright Agent "),_c('br'),_vm._v("\r\n        [Address]"),_c('br'),_vm._v("\r\n        [City, State Zip]"),_c('br'),_vm._v("\r\n        [email]"),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        We respect the intellectual property rights of others.  If you believe that any material available on or through the Site infringes upon any copyright you own or control, please immediately notify us using the contact information provided below (a “Notification”).  A copy of your Notification will be sent to the person who posted or stored the material addressed in the Notification.  Please be advised that pursuant to federal law you may be held liable for damages if you make material misrepresentations in a Notification. Thus, if you are not sure that material located on or linked to by the Site infringes your copyright, you should consider first contacting an attorney.]\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        These Terms of Use shall remain in full force and effect while you use the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF USE, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OF USE OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SITE OR DELETE [YOUR ACCOUNT AND] ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        If we terminate or suspend your account for any reason, you are prohibited from registering and creating a new account under your name, a fake or borrowed name, or the name of any third party, even if you may be acting on behalf of the third party. In addition to terminating or suspending your account, we reserve the right to take appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        We reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole discretion without notice.  However, we have no obligation to update any information on our Site.  We also reserve the right to modify or discontinue all or part of the Site without notice at any time.  We will not be liable to you or any third party for any modification, price change, suspension, or discontinuance of the Site.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        We cannot guarantee the Site will be available at all times.  We may experience hardware, software, or other problems or need to perform maintenance related to the Site, resulting in interruptions, delays, or errors.  We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Site at any time or for any reason without notice to you.  You agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by your inability to access or use the Site during any downtime or discontinuance of the Site.  Nothing in these Terms of Use will be construed to obligate us to maintain and support the Site or to supply any corrections, updates, or releases in connection therewith.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        These Terms of Use and your use of the Site are governed by and construed in accordance with the laws of the State of [name of state] applicable to agreements made and to be entirely performed within the State/Commonwealth of [name of state], without regard to its conflict of law principles.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_c('b',[_vm._v("Option 1:")]),_vm._v(" Any legal action of whatever nature brought by either you or us (collectively, the “Parties” and individually, a “Party”) shall be commenced or prosecuted in the state and federal courts located in Maricopa County, Arizona, and the Parties hereby consent to, and waive all defenses of lack of personal jurisdiction and forum non conveniens with respect to venue and jurisdiction in such state and federal courts.  Application of the United Nations Convention on Contracts for the International Sale of Goods and the Uniform Computer Information Transaction Act (UCITA) are excluded from these Terms of Use.  In no event shall any claim, action, or proceeding brought by either Party related in any way to the Site be commenced more than 1 year after the cause of action arose.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        To expedite resolution and control the cost of any dispute, controversy, or claim related to these Terms of Use (each a \"Dispute\" and collectively, the “Disputes”) brought by either you or us (individually, a “Party” and collectively, the “Parties”), the Parties agree to first attempt to negotiate any Dispute (except those Disputes expressly provided below) informally for at least "),_c('b',[_vm._v("90")]),_vm._v(" days before initiating arbitration. Such informal negotiations commence upon written notice from one Party to the other Party.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        If the Parties are unable to resolve a Dispute through informal negotiations, the Dispute (except those Disputes expressly excluded below) will be finally and exclusively resolved by binding arbitration. YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. The arbitration shall be commenced and conducted under the Commercial Arbitration Rules of the American Arbitration Association (\"AAA\") and, where appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes (\"AAA Consumer Rules\"), both of which are available at the AAA website www.adr.org. Your arbitration fees and your share of arbitrator compensation shall be governed by the AAA Consumer Rules and, where appropriate, limited by the AAA Consumer Rules. [If such costs are determined to by the arbitrator to be excessive, we will pay all arbitration fees and expenses.] The arbitration may be conducted in person, through the submission of documents, by phone, or online. The arbitrator will make a decision in writing, but need not provide a statement of reasons unless requested by either Party. The arbitrator must follow applicable law, and any award may be challenged if the arbitrator fails to do so. Except where otherwise required by the applicable AAA rules or applicable law, the arbitration will take place in Maricopa County, Arizona. Except as otherwise provided herein, the Parties may litigate in court to compel arbitration, stay proceedings pending arbitration, or to confirm, modify, vacate, or enter judgment on the award entered by the arbitrator.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        If for any reason, a Dispute proceeds in court rather than arbitration, the Dispute shall be commenced or prosecuted in the state and federal courts located in [name of county] County, [name of state], and the Parties hereby consent to, and waive all defenses of lack of personal jurisdiction, and forum non conveniens with respect to venue and jurisdiction in such state and federal courts. Application of the United Nations Convention on Contracts for the International Sale of Goods and the Uniform Computer Information Transaction Act (UCITA) are excluded from these Terms of Use.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        In no event shall any Dispute brought by either Party related in any way to the Site be commenced more than 1 year after the cause of action arose. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        To expedite resolution and control the cost of any dispute, controversy or claim related to these Terms of Use (each a \"Dispute\" and collectively, “Disputes”), any Dispute brought by either you or us (individually, a “Party” and collectively, the “Parties”) shall be finally and exclusively resolved by binding arbitration. YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. The arbitration shall be commenced and conducted under the Commercial Arbitration Rules of the American Arbitration Association (\"AAA\") and, where appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes (\"AAA Consumer Rules\"), both of which are available at the AAA website www.adr.org. Your arbitration fees and your share of arbitrator compensation shall be governed by the AAA Consumer Rules and, where appropriate, limited by the AAA Consumer Rules. [If such costs are determined to by the arbitrator to be excessive, we will pay all arbitration fees and expenses.] The arbitration may be conducted in person, through the submission of documents, by phone, or online. The arbitrator will make a decision in writing, but need not provide a statement of reasons unless requested by either Party. The arbitrator must follow applicable law, and any award may be challenged if the arbitrator fails to do so. Except where otherwise required by the applicable AAA rules or applicable law, the arbitration will take place in Maricopa County, Arizona. Except as otherwise provided herein, the Parties may litigate in court to compel arbitration, stay proceedings pending arbitration, or to confirm, modify, vacate, or enter judgment on the award entered by the arbitrator.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        If for any reason, a Dispute proceeds in court rather than arbitration, the Dispute shall be commenced or prosecuted in the state and federal courts located in Maricopa County, Arizona, and the Parties hereby consent to, and waive all defenses of lack of, personal jurisdiction, and forum non conveniens with respect to venue and jurisdiction in such state and federal courts. Application of the United Nations Convention on Contracts for the International Sale of Goods and the Uniform Computer Information Transaction Act (UCITA) are excluded from these Terms of Use.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        In no event shall any Dispute brought by either Party related in any way to the Site or Services be commenced more than 1 years after the cause of action arose. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        The Parties agree that any arbitration shall be limited to the Dispute between the Parties individually. To the full extent permitted by law, (a) no arbitration shall be joined with any other proceeding; (b) there is no right or authority for any Dispute to be arbitrated on a class-action basis or to utilize class action procedures; and (c) there is no right or authority for any Dispute to be brought in a purported representative capacity on behalf of the general public or any other persons.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        The Parties agree that the following Disputes are not subject to the above provisions concerning [informal negotiations and] binding arbitration: (a) any Disputes seeking to enforce or protect, or concerning the validity of, any of the intellectual property rights of a Party; (b) any Dispute related to, or arising from, allegations of theft, piracy, invasion of privacy, or unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        There may be information on the Site that contains typographical errors, inaccuracies, or omissions that may relate to the Site, including descriptions, pricing, availability, and various other information.  We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the Site at any time, without prior notice.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS.  YOU AGREE THAT YOUR USE OF THE SITE SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THIS SITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES.  AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. [NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO [THE LESSER OF] [THE AMOUNT PAID, IF ANY, BY YOU TO US DURING THE [12] MONTH PERIOD PRIOR TO ANY CAUSE OF ACTION ARISING.  CERTAIN STATE LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.]\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorneys’ fees and expenses, made by any third party due to or arising out of: (1) [your Contributions]; (2) use of the Site;  (3) breach of these Terms of Use; (4) any breach of your representations and warranties set forth in these Terms of Use; (5) your violation of the rights of a third party, including but not limited to intellectual property rights; or (6) any overt harmful act toward any other user of the Site with whom you connected via the Site. Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        We will maintain certain data that you transmit to the Site for the purpose of managing the Site, as well as data relating to your use of the Site.  Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that relates to any activity you have undertaken using the Site.  You agree that we shall have no liability to you for any loss or corruption of any such data, and you hereby waive any right of action against us arising from any such loss or corruption of such data.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        Visiting the Site, sending us emails, and completing online forms constitute electronic communications.  You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE.  You hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        These Terms of Use and any policies or operating rules posted by us on the Site constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms of Use shall not operate as a waiver of such right or provision.  These Terms of Use operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time.  We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control.  If any provision or part of a provision of these Terms of Use is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Terms of Use and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment or agency relationship created between you and us as a result of these Terms of Use or use of the Site.  You agree that these Terms of Use will not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Terms of Use and the lack of signing by the parties hereto to execute these Terms of Use.\r\n        "),_c('br'),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"section-text"},[_vm._v("\r\n        In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        KNOSIS Health, LLC "),_c('br'),_vm._v("\r\n        Gilbert, Arizona "),_c('br'),_vm._v("\r\n        (480) 559- 9677 "),_c('br'),_vm._v("\r\n        info@knosishealth.com "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KQCA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToCModal_vue__ = __webpack_require__("ulJq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d529a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToCModal_vue__ = __webpack_require__("JKjj");
function injectStyle (ssrContext) {
  __webpack_require__("zjAN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d529a7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToCModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d529a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToCModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KYxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"back-to-top-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"vue-back-to-top",style:(("bottom:" + (this.bottom) + ";right:" + (this.right) + ";")),on:{"click":_vm.backToTop}},[_vm._t("default",[_c('div',{staticClass:"default"},[_c('span',{staticClass:"icon is-medium"},[_c('i',{staticClass:"fas fa-angle-double-up"}),_c('br')])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Kbp6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ApolloBadgeGold.992ac0b.png";

/***/ }),

/***/ "KrRW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ktu6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadialProgressBar_vue__ = __webpack_require__("kkW7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadialProgressBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadialProgressBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_540e3d16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadialProgressBar_vue__ = __webpack_require__("+dVs");
function injectStyle (ssrContext) {
  __webpack_require__("QqDy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RadialProgressBar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_540e3d16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RadialProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "L0tu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avatar_vue__ = __webpack_require__("5CKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d26f4d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avatar_vue__ = __webpack_require__("TPyJ");
function injectStyle (ssrContext) {
  __webpack_require__("zo0N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d26f4d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d26f4d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LTTF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BackToTop',
  props: {
    text: {
      type: String,
      default: 'TOP'
    },
    visibleOffset: {
      type: [String, Number],
      default: 600
    },
    right: {
      type: String,
      default: '30px'
    },
    bottom: {
      type: String,
      default: '40px'
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },

  /**
   * Catch window scroll event
   * @return {void}
   */
  created: function created() {
    var _this = this;

    var catchScroll = function catchScroll() {
      _this.visible = window.pageYOffset > parseInt(_this.visibleOffset);
    };
    window.smoothscroll = function () {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(window.smoothscroll);
        window.scrollTo(0, Math.floor(currentScroll - currentScroll / 5));
      }
    };
    window.onscroll = catchScroll;
  },

  methods: {
    /**
     * The function who make the magics
     * @return {void}
     */
    backToTop: function backToTop() {
      window.smoothscroll();
    }
  }
});

/***/ }),

/***/ "M64J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f7c162_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("bqaB");
function injectStyle (ssrContext) {
  __webpack_require__("GBBf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55f7c162_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MU/q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar is-black"},[_c('div',{staticClass:"navbar-brand"},[_vm._m(0,false,false),_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":function($event){_vm.showDeviceSyncModal = true}}},[_vm._v("SYNC DEVICE")]),_vm._v(" "),_c('div',{staticClass:"navbar-burger burger",class:{ 'is-active': _vm.showNav },on:{"click":function($event){_vm.showNav = !_vm.showNav}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{ 'is-active': _vm.showNav }},[_c('div',{staticClass:"navbar-start"}),_vm._v(" "),_c('div',{staticClass:"navbar-end"},[_c('br'),_c('br'),_c('br'),_c('a',{staticClass:"navbar-item is-active",on:{"click":_vm.goToHomePage}},[_vm._v("HOME")]),_vm._v(" "),_c('a',{staticClass:"navbar-item is-active",on:{"click":_vm.goToChallengePage}},[_vm._v("CHALLENGE")]),_vm._v(" "),_c('a',{staticClass:"navbar-item is-active",on:{"click":_vm.goToAvatarPage}},[_vm._v("AVATAR")]),_vm._v(" "),_c('a',{staticClass:"navbar-item is-active",on:{"click":_vm.goToFitnessHistoryPage}},[_vm._v("FITNESS HISTORY")]),_vm._v(" "),_c('div',{staticClass:"navbar-item has-dropdown is-hoverable"},[_c('a',{staticClass:"navbar-link"},[_vm._v("More")]),_vm._v(" "),_c('div',{staticClass:"navbar-dropdown is-boxed is-right"},[_c('a',{staticClass:"navbar-item",on:{"click":_vm.goToInboxPage}},[_vm._v("INBOX "),(_vm.newMessage)?_c('img',{attrs:{"src":"https://cdn3.iconfinder.com/data/icons/eightyshades/512/16_Exclamation-16.png"}}):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":_vm.goToMarketPage}},[_vm._v("MARKET")]),_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":_vm.goToAccountPage}},[_vm._v("ACCOUNT")]),_vm._v(" "),_c('hr',{staticClass:"navbar-divider"}),_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":_vm.logout}},[_vm._v("LOGOUT")])])])])]),_vm._v(" "),_c('deviceSyncModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDeviceSyncModal),expression:"showDeviceSyncModal"}],on:{"close":function($event){_vm.showDeviceSyncModal = false}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item",attrs:{"href":"http://www.knosishealth.com","title":"KNOSIS Website Home"}},[_c('img',{attrs:{"src":__webpack_require__("QOPg"),"alt":"KNOSIS"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NEe7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Privacy Policy")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"field is-grouped"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-medium",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Close")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal-card-body",attrs:{"id":"top"}},[_c('h1',{staticClass:"body-header"},[_vm._v("KNOSIS Health Mobile"),_c('br'),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n          KNOSIS Health, LLC (“we” or “us” or “our”) respects the privacy of our users (“user” or “you”). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our mobile application (the “Application”).   Please read this Privacy Policy carefully.  IF YOU DO NOT AGREE WITH THE TERMS OF THIS PRIVACY POLICY, PLEASE DO NOT ACCESS THE APPLICATION\r\n          "),_c('br'),_c('br'),_vm._v("\r\n          We reserve the right to make changes to this Privacy Policy at any time and for any reason.  We will alert you about any changes by updating the “Last updated” date of this Privacy Policy.  You are encouraged to periodically review this Privacy Policy to stay informed of updates. You will be deemed to have been made aware of, will be subject to, and will be deemed to have accepted the changes in any revised Privacy Policy by your continued use of the Application after the date such revised Privacy Policy is posted.\r\n          "),_c('br'),_c('br'),_vm._v("\r\n          This Privacy Policy does not apply to the third-party online/mobile store from which you install the Application or make payments, including any in-game virtual items, which may also collect and use data about you.  We are not responsible for any of the data collected by any such third party.\r\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("COLLECTION OF YOUR INFORMATION")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n          We may collect information about you in a variety of ways.  The information we may collect via the Application depends on the content and materials you use, and includes:\r\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Personal Data")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n          Demographic and other personally identifiable information (such as your name and email address) that you voluntarily give to us when choosing to participate in various activities related to the Application, such as chat, posting messages in comment sections or in our forums, liking posts, sending feedback, and responding to surveys.  If you choose to share data about yourself via your profile, online chat, or other interactive areas of the Application, please be advised that all data you disclose in these areas is public and your data will be accessible to anyone who accesses the Application.\r\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Derivative Data")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n          Information our servers automatically collect when you access the Application, such as your native actions that are integral to the Application, including liking, re-blogging, or replying to a post, as well as other interactions with the Application and other users via server log files.\r\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Financial Data")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n          Financial information, such as data related to your payment method (e.g. valid credit card number, card brand, expiration date) that we may collect when you purchase, order, return, exchange, or request information about our services from the Application. [We store only very limited, if any, financial information that we collect. Otherwise, all financial information is stored by our payment processor,  "),_c('a',{attrs:{"href":"https://pay.amazon.com/us/help/201491260"}},[_vm._v("[Amazon Payments]")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.authorize.net/company/privacy/"}},[_vm._v("[Authornize.Net]")]),_vm._v(",  "),_c('a',{attrs:{"href":"https://www.braintreepayments.com/legal"}},[_vm._v("[Braintree Payments]")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.chargify.com/privacy-policy/"}},[_vm._v("[Chargify]")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.dwolla.com/legal/privacy/"}},[_vm._v("[Dwolla]")]),_vm._v(", "),_c('a',{attrs:{"href":"https://payments.google.com/payments/apis-secure/get_legal_document?ldo=0&ldt=privacynotice"}},[_vm._v("[Google Checkout]")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.paypal.com/us/webapps/mpp/ua/privacy-full"}},[_vm._v("[Paypal]")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.safecharge.com/privacy-cookies-policy/"}},[_vm._v("[SafeCharge]")]),_vm._v(", "),_c('a',{attrs:{"href":"https://stripe.com/us/privacy/"}},[_vm._v("[Stripe]")]),_vm._v(", "),_c('a',{attrs:{"href":"https://go.wepay.com/privacy-policy-us"}},[_vm._v("[WePay]")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.2checkout.com/policies/privacy-policy/"}},[_vm._v("[2Checkout]")]),_vm._v(", [other], and you are encouraged to review their privacy policy and contact them directly for responses to your questions.\r\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Data from Fitness Trackers")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n          User information from social fitness tracking sites, such as Fitbit, Apple Watch (Apple Health), Garmin, Jawbone, etc. via their Application Program Interface (API) including your name, your username, location, gender, birth date, email address, and fitness activity including but not limited to: steps, distance, calories burned, heart rate as well as historical fitness data if you connect your account to such social fitness tracking networks. The information/data transmitted through such entities continues to be owned by the aforementioned entities under their Intellectual Property/Copyright laws. Additionally, the information you (the user) voluntarily provides during the registration process will be stored and administered by KNOSIS Health, LLC for user engagement research.\r\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Data from Social Networks")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        User information from social networking sites, such as [Apple’s Game Center, Facebook, Google+ Instagram, Pinterest, Twitter], including your name, your social network username, location, gender, birth date, email address, profile picture, and public data for contacts, if you connect your account to such social networks. This information may also include the contact information of anyone you invite to use and/or join the Application.\r\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Geo-Location Information")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may request access or permission to and track location-based information from your mobile device, either continuously or while you are using the Application, to provide location-based services. If you wish to change our access or permissions, you may do so in your device’s settings.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Mobile Device Access")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may request access or permission to certain features from your mobile device, including your mobile device’s [bluetooth, calendar, camera, contacts, microphone, reminders, sensors, SMS messages, social media accounts, storage,] and other features. If you wish to change our access or permissions, you may do so in your device’s settings.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Mobile Device Data")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        Device information such as your mobile device ID number, model, and manufacturer, version of your operating system, phone number, country, location, and any other data you choose to provide.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Push Notifications ")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may request to send you push notifications regarding your account or the Application. If you wish to opt-out from receiving these types of communications, you may turn them off in your device’s settings.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Third-Party Data")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        Information from third parties, such as personal information or network friends, if you connect your account to the third party and grant the Application permission to access this information.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Data From Contests, Giveaways, and Surveys")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        Personal and other information you may provide when entering contests or giveaways and/or responding to surveys.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("USE OF YOUR INFORMATION")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience.  Specifically, we may use information collected about you via the Application to:\r\n        "),_c('br'),_c('br'),_vm._v(" "),_c('ol',{staticClass:"listed-values"},[_c('li',[_vm._v("Administer sweepstakes, promotions, and contests.")]),_vm._v(" "),_c('li',[_vm._v("Assist law enforcement and respond to subpoena.")]),_vm._v(" "),_c('li',[_vm._v("Compile anonymous statistical data and analysis for use internally or with third parties.")]),_vm._v(" "),_c('li',[_vm._v("Create and manage your account.")]),_vm._v(" "),_c('li',[_vm._v("Deliver targeted advertising, coupons, newsletters, and other information regarding promotions and the Application to you.")]),_vm._v(" "),_c('li',[_vm._v("Email you regarding your account or order.")]),_vm._v(" "),_c('li',[_vm._v("Enable user-to-user communications.")]),_vm._v(" "),_c('li',[_vm._v("Fulfill and manage purchases, orders, payments, and other transactions related to the Application.")]),_vm._v(" "),_c('li',[_vm._v("Generate a personal profile about you to make future visits to the Application more personalized.")]),_vm._v(" "),_c('li',[_vm._v("Increase the efficiency and operation of the Application.")]),_vm._v(" "),_c('li',[_vm._v("Monitor and analyze usage and trends to improve your experience with the Application.")]),_vm._v(" "),_c('li',[_vm._v("Notify you of updates to the Application.")]),_vm._v(" "),_c('li',[_vm._v("Offer new products, services, mobile applications, and/or recommendations to you.")]),_vm._v(" "),_c('li',[_vm._v("Perform other business activities as needed.")]),_vm._v(" "),_c('li',[_vm._v("Prevent fraudulent transactions, monitor against theft, and protect against criminal activity.")]),_vm._v(" "),_c('li',[_vm._v("Process payments and refunds.")]),_vm._v(" "),_c('li',[_vm._v("Request feedback and contact you about your use of the Application.")]),_vm._v(" "),_c('li',[_vm._v("Resolve disputes and troubleshoot problems.")]),_vm._v(" "),_c('li',[_vm._v("Respond to product and customer service requests.")]),_vm._v(" "),_c('li',[_vm._v("Send you a newsletter.")]),_vm._v(" "),_c('li',[_vm._v("Solicit support for the Application.")])]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("DISCLOSURE OF YOUR INFORMATION")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may share information we have collected about you in certain situations. Your information may be disclosed as follows:\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("By Law or to Protect Rights")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        If we believe the release of information about you is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others, we may share your information as permitted or required by any applicable law, rule, or regulation.  This includes exchanging information with other entities for fraud protection and credit risk reduction.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Third-Party Service Providers ")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may share your information with third parties that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, customer service, and marketing assistance.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Marketing Communications")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        With your consent, or with an opportunity for you to withdraw consent, we may share your information with third parties for marketing purposes, as permitted by law.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Interactions with Other Users")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        If you interact with other users of the Application, those users may see your name, profile photo, and descriptions of your activity, including sending invitations to other users, chatting with other users, liking posts, following blogs.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Online Postings")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        When you post comments, contributions or other content to the Applications, your posts may be viewed by all users and may be publicly distributed outside the Application in perpetuity\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Third-Party Advertisers ")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may use third-party advertising companies to serve ads when you visit the Application. These companies may use information about your visits to the Application and other websites that are contained in web cookies in order to provide advertisements about goods and services of interest to you.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Affiliates")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may share your information with our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include our parent company and any subsidiaries, joint venture partners or other companies that we control or that are under common control with us.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Business Partners")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may share your information with our business partners to offer you certain products, services or promotions.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Offer Wall")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        The Application may display a third-party-hosted “offer wall.”  Such an offer wall allows third-party advertisers to offer virtual currency, gifts, or other items to users in return for acceptance and completion of an advertisement offer.  Such an offer wall may appear in the Application and be displayed to you based on certain data, such as your geographic area or demographic information.  When you click on an offer wall, you will leave the Application.  A unique identifier, such as your user ID, will be shared with the offer wall provider in order to prevent fraud and properly credit your account.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Social Media Contacts")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        If you connect to the Application through a social network, your contacts on the social network will see your name, profile photo, and descriptions of your activity.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Other Third Parties")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may share your information with advertisers and investors for the purpose of conducting general business analysis. We may also share your information with such third parties for marketing purposes, as permitted by law.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Sale or Bankruptcy")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        If we reorganize or sell all or a portion of our assets, undergo a merger, or are acquired by another entity, we may transfer your information to the successor entity.  If we go out of business or enter bankruptcy, your information would be an asset transferred or acquired by a third party.  You acknowledge that such transfers may occur and that the transferee may decline honor commitments we made in this Privacy Policy.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        We are not responsible for the actions of third parties with whom you share personal or sensitive data, and we have no authority to manage or control third-party solicitations.  If you no longer wish to receive correspondence, emails or other communications from third parties, you are responsible for contacting the third party directly.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("TRACKING TECHNOLOGIES")]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Cookies and Web Beacons")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may use cookies, web beacons, tracking pixels, and other tracking technologies on the Application to help customize the Application and improve your experience. When you access the Application, your personal information is not collected through the use of tracking technology. Most browsers are set to accept cookies by default. You can remove or reject cookies, but be aware that such action could affect the availability and functionality of the Application. You may not decline web beacons. However, they can be rendered ineffective by declining all cookies or by modifying your web browser’s settings to notify you each time a cookie is tendered, permitting you to accept or decline cookies on an individual basis.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Internet-Based Advertising")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        Additionally, we may use third-party software to serve ads on the Application, implement email marketing campaigns, and manage other interactive marketing initiatives.  This third-party software may use cookies or similar tracking technology to help manage and optimize your online experience with us.  For more information about opting-out of interest-based ads, visit the "),_c('u',[_vm._v("Network Advertising Initiative Opt-Out Tool")]),_vm._v(" or"),_c('u',[_vm._v(" Digital Advertising Alliance Opt-Out Tool")]),_vm._v(".\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Website Analytics")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We may also partner with selected third-party vendors[, such as [Adobe Analytics,] [Clicktale,] [Clicky,] [Cloudfare,] [Crazy Egg,] [Flurry Analytics,] [Google Analytics,] [Heap Analytics,] [Inspectlet,] [Kissmetrics,] [Mixpanel,] [Piwik,] and others], to allow tracking technologies and remarketing services on the Application through the use of first party cookies and third-party cookies, to, among other things, analyze and track users’ use of the Application, determine the popularity of certain content, and better understand online activity. By accessing the Application, you consent to the collection and use of your information by these third-party vendors. You are encouraged to review their privacy policy and contact them directly for responses to your questions. We do not transfer personal information to these third-party vendors. However, if you do not want any information to be collected and used by tracking technologies, you can install and/or update your settings for one of the following:"),_c('br'),_c('u',[_c('br'),_vm._v("[Adobe Privacy Choices Page]\r\n        "),_c('br'),_vm._v("[Clicktale Opt-Out Feature]\r\n        "),_c('br'),_vm._v("[Crazy Egg Opt-Out Feature]\r\n        "),_c('br'),_vm._v("Digital Advertising Alliance Opt-Out Tool\r\n        "),_c('br'),_vm._v("[Flurry Analytics Yahoo Opt-Out Manager]\r\n        "),_c('br'),_vm._v("[Google Analytics Opt-Out Plugin]\r\n        "),_c('br'),_vm._v("[Google Ads Settings Page]\r\n        "),_c('br'),_vm._v("[Inspectlet Opt-Out Cookie]\r\n        "),_c('br'),_vm._v("[Kissmetrics Opt-Out Feature]\r\n        "),_c('br'),_vm._v("[Mixpanel Opt-Out Cookie]\r\n        "),_c('br'),_vm._v("Network Advertising Initiative Opt-Out Tool\r\n        "),_c('br')]),_c('br'),_vm._v("\r\n        You should be aware that getting a new computer, installing a new browser, upgrading an existing browser, or erasing or otherwise altering your browser’s cookies files may also clear certain opt-out cookies, plug-ins, or settings.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("THIRD-PARTY WEBSITES")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        The Application may contain links to third-party websites and applications of interest, including advertisements and external services, that are not affiliated with us. Once you have used these links to leave the Application, any information you provide to these third parties is not covered by this Privacy Policy, and we cannot guarantee the safety and privacy of your information. Before visiting and providing any information to any third-party websites, you should inform yourself of the privacy policies and practices (if any) of the third party responsible for that website, and should take those steps necessary to, in your discretion, protect the privacy of your information. We are not responsible for the content or privacy and security practices and policies of any third parties, including other sites, services or applications that may be linked to or from the Application.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("SECURITY OF YOUR INFORMATION")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We use administrative, technical, and physical security measures to help protect your personal information.  While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.  Any information disclosed online is vulnerable to interception and misuse by unauthorized parties.  Therefore, we cannot guarantee complete security if you provide personal information.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("POLICY FOR CHILDREN")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        We do not knowingly solicit information from or market to children under the age of 13. If you become aware of any data we have collected from children under age 13, please contact us using the contact information provided below.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("CONTROLS FOR DO-NOT-TRACK FEATURES")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        Most web browsers and some mobile operating systems [and our mobile applications] include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected.  No uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online.  If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy Policy.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("OPTIONS REGARDING YOUR INFORMATION")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        These Terms of Use and any policies or operating rules posted by us on the Site constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms of Use shall not operate as a waiver of such right or provision.  These Terms of Use operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time.  We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control.  If any provision or part of a provision of these Terms of Use is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Terms of Use and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment or agency relationship created between you and us as a result of these Terms of Use or use of the Site.  You agree that these Terms of Use will not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Terms of Use and the lack of signing by the parties hereto to execute these Terms of Use.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("[Account Information]")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        You may at any time review or change the information in your account or terminate your account by:\r\n        "),_c('br'),_vm._v(" "),_c('ul',{staticClass:"listed-values",staticStyle:{"list-style-type":"disc"}},[_c('li',[_vm._v("Logging into your account settings and updating your account")]),_vm._v(" "),_c('li',[_vm._v("Contacting us using the contact information provided below")])]),_vm._v(" "),_c('br'),_vm._v("\r\n        Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, some information may be retained in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of Use and/or comply with legal requirements.]\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header"},[_vm._v("Emails and Communications")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        If you no longer wish to receive correspondence, emails, or other communications from us, you may opt-out by:\r\n        "),_c('br'),_vm._v(" "),_c('ul',{staticClass:"listed-values",staticStyle:{"list-style-type":"disc"}},[_c('li',[_vm._v("Noting your preferences at the time you register your account with the Application")]),_vm._v(" "),_c('li',[_vm._v("Logging into your account settings and updating your preferences.")]),_vm._v(" "),_c('li',[_vm._v("Contacting us using the contact information provided below")])]),_vm._v("\r\n        If you no longer wish to receive correspondence, emails, or other communications from third parties, you are responsible for contacting the third party directly.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("CALIFORNIA PRIVACY RIGHTS")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        California Civil Code Section 1798.83, also known as the “Shine The Light” law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        If you are under 18 years of age, reside in California, and have a registered account with the Application, you have the right to request removal of unwanted data that you publicly post on the Application. To request removal of such data, please contact us using the contact information provided below, and include the email address associated with your account and a statement that you reside in California.  We will make sure the data is not publicly displayed on the Application, but please be aware that the data may not be completely or comprehensively removed from our systems.\r\n        "),_c('br'),_c('br')]),_vm._v(" "),_c('h4',{staticClass:"section-header",staticStyle:{"font-size":"150%"}},[_vm._v("CONTACT US")]),_vm._v(" "),_c('p',{staticClass:"section-text"},[_vm._v("\r\n        If you have questions or comments about this Privacy Policy, please contact us at:\r\n        "),_c('br'),_c('br'),_vm._v("\r\n        KNOSIS Health, LLC "),_c('br'),_vm._v("\r\n        Gilbert, Arizona "),_c('br'),_vm._v("\r\n        (480) 559- 9677 "),_c('br'),_vm._v("\r\n        info@knosishealth.com "),_c('br')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_radial_progress__ = __webpack_require__("Q0AL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_radial_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_radial_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookies__ = __webpack_require__("ppUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_localstorage__ = __webpack_require__("UnSZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_localstorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_localstorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_cors__ = __webpack_require__("h2tb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_cors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_cors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_js_sha256__ = __webpack_require__("BUS2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_js_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_js_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_toasted__ = __webpack_require__("IZMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_FBXLoader_modified_js__ = __webpack_require__("YUiw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_FBXLoader_modified_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__static_FBXLoader_modified_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_trackballcontrols_js__ = __webpack_require__("v1zE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_trackballcontrols_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_trackballcontrols_js__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__webpack_require__("CuRo");

//Import router for page navigation


//Import third party resources














//Declare all global components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('radial-progress-bar', __WEBPACK_IMPORTED_MODULE_4_vue_radial_progress___default.a);

//Declare all global plugins

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14__static_FBXLoader_modified_js___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15__static_trackballcontrols_js___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_localstorage___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_cors___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBIgWkXLfO8bgbBfQF_N-r7Ut0SK0DRzRE',
    libraries: 'places'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_toasted___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.initializeApp({
      apiKey: "AIzaSyAPJ2y2IMg66YFcwhJQdE2mV7tjlDVTlgk",
      authDomain: "knosis-beta.firebaseapp.com",
      databaseURL: "https://knosis-beta.firebaseio.com",
      projectId: "knosis-beta",
      storageBucket: "knosis-beta.appspot.com",
      messagingSenderId: "1019416557389"
    });
    __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {
        var permission = null;
        __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref('/admin/').once('value').then(function (data) {
          var obj = data.val();
          for (var key in data.val()) {
            if (key == user.uid) {
              _this.$store.dispatch('autoAdminSignIn', user);
              _this.$store.dispatch('fetchAdminData');
            }
          }
        });
        __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.database().ref('/users/').once('value').then(function (data) {
          var obj = data.val();
          for (var key in data.val()) {
            if (key == user.uid) {
              _this.$store.dispatch('autoSignIn', user);
              _this.$store.dispatch('fetchUserData');
              _this.$store.dispatch('fetchUserPosition');
              _this.$store.dispatch('fetchAvatarData');
              _this.$store.dispatch('loadChallenges');
              _this.$store.dispatch('loadPastChallenges', user);
              _this.$store.dispatch('loadAvailableChallengers', user);
              _this.$store.dispatch('loadMapCenter');
            }
          }
        });
      }
    });
  }
});

/***/ }),

/***/ "NYKV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OFEc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar is-black"},[_c('div',{staticClass:"navbar-brand"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"navbar-burger burger",class:{ 'is-active': _vm.showNav },on:{"click":function($event){_vm.showNav = !_vm.showNav}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{ 'is-active': _vm.showNav }},[_c('div',{staticClass:"navbar-start"}),_vm._v(" "),_c('div',{staticClass:"navbar-end"},[_c('br'),_c('br'),_c('br'),_c('a',{staticClass:"navbar-item is-active",on:{"click":_vm.goToMessagingPage}},[_vm._v("MESSAGING")]),_vm._v(" "),_c('a',{staticClass:"navbar-item is-active",on:{"click":_vm.goToGroupDataPage}},[_vm._v("GROUP DATA")]),_vm._v(" "),_c('div',{staticClass:"navbar-item has-dropdown is-hoverable"},[_c('a',{staticClass:"navbar-link"},[_vm._v("More")]),_vm._v(" "),_c('div',{staticClass:"navbar-dropdown is-boxed is-right"},[_c('hr',{staticClass:"navbar-divider"}),_vm._v(" "),_c('a',{staticClass:"navbar-item",on:{"click":_vm.logout}},[_vm._v("LOGOUT")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"navbar-item",attrs:{"href":"http://www.knosishealth.com","title":"KNOSIS Website Home"}},[_c('img',{attrs:{"src":__webpack_require__("QOPg"),"alt":"KNOSIS"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PJX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  methods: {
    goToLogin: function goToLogin() {
      setTimeout(this.toLogin, 5000);
    },
    toLogin: function toLogin() {
      this.$router.push({ path: '/login' });
    }
  },
  mounted: function mounted() {
    this.goToLogin();
  }
});

/***/ }),

/***/ "PQCO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ArtemisBadgeBronze.d38a4ca.png";

/***/ }),

/***/ "Q4j3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LineChart_js__ = __webpack_require__("zPDV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slider_component__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _sliderOptions;

    return {
      sliderValue: 15,
      sliderOptions: (_sliderOptions = {
        eventType: 'auto',
        width: 'auto',
        height: 10,
        dotSize: 16,
        dotHeight: null,
        dotWidth: null,
        min: 0,
        max: 30,
        interval: 1,
        show: true,
        speed: 0.5,
        disabled: false,
        piecewise: false,
        piecewiseStyle: false,
        piecewiseLabel: false,
        tooltip: false,
        tooltipDir: 'top',
        reverse: false,
        data: null,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: null,
        bgStyle: null,
        sliderStyle: null,
        processStyle: null,
        piecewiseActiveStyle: null
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_sliderOptions, 'piecewiseStyle', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_sliderOptions, 'tooltipStyle', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_sliderOptions, 'labelStyle', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_sliderOptions, 'labelActiveStyle', null), _sliderOptions),
      gradient: null,
      datacollection: null,
      chartChangeData: null,
      mountView: true,
      detailView: false,
      stepsColor: "#C0392B",
      distanceColor: "#7D3C98",
      calorieColor: "#27AE60",
      activeColor: "#2980B9",
      hrColor: "#66ff33",
      tileObj: [{ 'sorted': [], 'avg': 0, 'sum': 0 }, { 'sorted': [], 'avg': 0, 'sum': 0 }]
    };
  },

  methods: {
    //Convert data from fitbit response to Chartjs friendly format
    fillData: function fillData(val) {
      val = this.prepareData(val);

      this.datacollection = {
        labels: this.fillXAxis(val),
        datasets: [{
          label: document.getElementById('categ').innerHTML,
          borderColor: '#2a0d45',
          pointBackgroundColor: '#551a8b',
          borderWidth: 1,
          pointBorderColor: 'white',
          backgroundColor: '#9370DB',
          data: this.fillYAxis(val)
        }]
      };
    },


    //Capture data for Y Axis
    fillYAxis: function fillYAxis(val) {
      var yAxis = [];
      for (var key = val.length - this.sliderValue; key < val.length; key++) {
        if (document.getElementById('categ').innerHTML == 'Heart Rate') {
          if (isNaN(val[key].value.restingHeartRate)) {
            yAxis.push(0);
          } else {
            yAxis.push(val[key].value.restingHeartRate);
          }
        } else {
          yAxis.push(val[key].value);
        }
      }
      return yAxis;
    },


    //Capture data for X Axis
    fillXAxis: function fillXAxis(val) {
      var xAxis = [];
      for (var key = val.length - this.sliderValue; key < val.length; key++) {
        xAxis.push(val[key].dateTime);
      }
      return xAxis;
    },


    //Reset page to original state
    reloadPage: function reloadPage() {
      //Reset avg and sum values
      for (var key in this.tileObj) {
        this.tileObj[key].avg = 0;
        this.tileObj[key].sum = 0;
      }
      this.mountView = true;
      this.detailView = false;
      document.getElementById('categ').innerHTML = null;
    },


    //Take fitbit return string and convert it to proper format and return JSON Object
    prepareData: function prepareData(val) {
      var c = '';
      if (document.getElementById('categ').innerHTML == 'Steps' || document.getElementById('categ').innerHTML == 'Distance' || document.getElementById('categ').innerHTML == 'Calories Burned' || document.getElementById('categ').innerHTML == 'Active Minutes') {
        c = this.convertVal(document.getElementById('categ').innerHTML).split('/')[1];
        val = val.split(c + '\":')[1].split(']}')[0] + ']';
      } else {
        c = this.convertVal(document.getElementById('categ').innerHTML);
        val = val.split(c + '\":')[1].split('}}]}')[0] + '}}]';
      }
      return JSON.parse(val);
    },


    //Convert val to format Fitbit Web API will recognize
    convertVal: function convertVal(val) {
      switch (val) {
        case 'Steps':
          return val = 'tracker/steps';
          break;
        case 'Distance':
          return val = 'tracker/distance';
          break;
        case 'Calories Burned':
          return val = 'tracker/activityCalories';
          break;
        case 'Active Minutes':
          return val = 'tracker/minutesFairlyActive';
          break;
        case 'Heart Rate':
          return val = 'heart';
          break;
        default:
          console.log('processSelect val does not match any case');
          break;
      }
    },


    //Request category data from Fitbit Web API
    processSelect: function processSelect(val) {
      var _this = this;

      var convert = '';
      convert = this.convertVal(val);

      document.getElementById('categ').innerHTML = val;
      //Check for oauth access token stored in local cookies and
      //make axios http call for fitbit tracker data category
      //Else tell user to sync device
      if (this.$cookies.isKey('oauth_access_token')) {
        this.mountView = false;
        this.detailView = true;
        var AuthString = 'Bearer ' + this.$cookies.get('oauth_access_token');
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'] = AuthString;

        //Call for 1 month of data
        __WEBPACK_IMPORTED_MODULE_2_axios___default()({ method: 'get',
          url: 'https://api.fitbit.com/1/user/-/activities/' + convert + '/date/today/1m.json'
        }).then(function (response) {
          _this.chartChangeData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data);
          _this.findTileData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data), 'month');
          _this.fillData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        }).catch(function (error) {
          console.log(error);
        });

        //Call for 1 year of data
        __WEBPACK_IMPORTED_MODULE_2_axios___default()({ method: 'get',
          url: 'https://api.fitbit.com/1/user/-/activities/' + convert + '/date/today/1y.json'
        }).then(function (response) {
          _this.findTileData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data), 'year');
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        document.getElementById('categ').innerHTML = 'Please Sync Device To View Fitbit History';
      }
    },


    //Find all data to fill tile elements
    findTileData: function findTileData(val, tFrame) {
      var temp = 0;
      var index = 4;
      val = this.prepareData(val);

      //Set proper index in tile obj data element
      if (tFrame == 'month') {
        index = 0;
      } else if (tFrame == 'year') {
        index = 1;
      } else {
        console.log("Error in tile data index");
      }

      if (document.getElementById('categ').innerHTML == 'Steps' || document.getElementById('categ').innerHTML == 'Distance' || document.getElementById('categ').innerHTML == 'Calories Burned' || document.getElementById('categ').innerHTML == 'Active Minutes') {
        //Sort fitbit data from high to low and populate top ten
        val.sort(function (a, b) {
          return b.value - a.value;
        });
        for (var i = 0; i < 10; i++) {
          this.tileObj[index].sorted[i] = { "dateTime": val[i].dateTime, "value": Number(parseInt(val[i].value)).toFixed(1) };
        }

        var count = 0;
        //Find fitbit data sum and average
        //Only average days with more than zero
        //Zero assumes device not worn
        for (var key in val) {
          if (parseInt(val[key].value > 0)) {
            this.tileObj[index].sum += parseInt(val[key].value);
            count++;
          }
        }
        this.tileObj[index].avg = Number(this.tileObj[index].sum / count).toFixed(0);
        count = 0;
      } else {
        //Sort fitbit data from high to low and populate top ten
        val.sort(function (a, b) {
          if (!isFinite(b.value.restingHeartRate - a.value.restingHeartRate)) {
            return isFinite(b.value.restingHeartRate) ? 1 : -1;
          } else {
            return b.value.restingHeartRate - a.value.restingHeartRate;
          }
        });
        for (var i = 0; i < 10; i++) {
          this.tileObj[index].sorted[i] = { "dateTime": val[i].dateTime, "value": Number(parseInt(val[i].value.restingHeartRate)).toFixed(1) };
        }

        var count = 0;
        //Find fitbit data sum and average
        //Only average days with data
        //No data assumes device not worn
        for (var key in val) {
          if (isNaN(val[key].value.restingHeartRate)) {} else {
            this.tileObj[index].sum += parseInt(val[key].value.restingHeartRate);
            count++;
          }
        }
        this.tileObj[index].avg = Number(this.tileObj[index].sum / count).toFixed(0);
        this.tileObj[index].sum = 'N/A';
        count = 0;
      }
    }
  },
  components: {
    LineChart: __WEBPACK_IMPORTED_MODULE_3__LineChart_js__["a" /* default */],
    vueSlider: __WEBPACK_IMPORTED_MODULE_4_vue_slider_component___default.a
  }
});

/***/ }),

/***/ "QOPg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/knosisTRANSPARENT.5fafb87.png";

/***/ }),

/***/ "QqDy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RVzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FitnessHistory_vue__ = __webpack_require__("Q4j3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c4dd0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FitnessHistory_vue__ = __webpack_require__("DyPW");
function injectStyle (ssrContext) {
  __webpack_require__("NYKV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67c4dd0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FitnessHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c4dd0e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FitnessHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RWhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_didimoModal_vue__ = __webpack_require__("XIIv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4873a3c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_didimoModal_vue__ = __webpack_require__("wBKc");
function injectStyle (ssrContext) {
  __webpack_require__("SoNF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4873a3c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_didimoModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4873a3c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_didimoModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RcLo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminLogin_vue__ = __webpack_require__("V3xM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5531f38f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminLogin_vue__ = __webpack_require__("ypKJ");
function injectStyle (ssrContext) {
  __webpack_require__("fK5R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5531f38f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5531f38f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "S0ha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      adminPermissionCode: '',
      permCode: '23wqHiou89#',
      usernameAvailable: true,
      company: '',
      email: '',
      password: '',
      confirmPassword: '',
      passwordsNotMatch: false
    };
  },

  methods: {
    toastErr: function toastErr(bool, message) {
      if (!bool) {
        this.$toasted.show(message, {
          theme: "outline",
          position: "bottom-center",
          duration: 3000,
          fitToScreen: true
        });
      }
    },

    //Check password to make sure it is consistent using debounce
    //debounce is a function provided by lodash to limit how
    //often a particularly expensive operation can be run.
    //In this case, we want to limit how often we access
    //the firebase database, waiting until the user has completely
    //finished typing before making the request.
    //Ensure user enters same password in both input fields
    comparePasswords: __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      return this.passwordsNotMatch = this.password == this.confirmPassword;
    }, 500),

    //Register new user with firebase authentication
    register: function register() {
      if (this.adminPermissionCode !== this.permCode) {
        this.toastErr(false, 'Incorrect Admin Permission Code');
      } else {
        if (this.passwordsNotMatch == false) {
          this.toastErr(false, 'Passwords Do Not Match');
        } else {
          this.$store.dispatch('signAdminUp', {
            company: this.company,
            email: this.email,
            password: this.password
          });
        }
      }
    }
  }
});

/***/ }),

/***/ "Sa1c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SoNF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TPyJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"title is-1",attrs:{"align":"center"}},[_vm._v("Avatar")]),_vm._v(" "),(!_vm.hasAvatar2)?_c('p',{staticClass:"title is-6",attrs:{"align":"center"}},[_vm._v("Please begin by creating a new avatar")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-third"}),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('div',{staticClass:"imageplace"},[_c('didimoModal')],1)]),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('p',{staticClass:"title is-3",attrs:{"align":"center"}},[_vm._v("Create New Avatar")]),_vm._v(" "),_c('button',{staticClass:"button is-fullwidth is-medium is-centered",attrs:{"id":"createAvatarButton"},on:{"click":function($event){_vm.showCreateNewAvatarModal=true}}},[_vm._v("Create Avatar")]),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticClass:"title is-5",attrs:{"align":"center"}},[_vm._v("Upgrade Your Avatar")]),_vm._v(" "),_c('p',{staticClass:"title is-3",attrs:{"align":"center"}},[_vm._v("Available points: "+_vm._s(_vm.user.points))]),_vm._v(" "),_c('button',{staticClass:"button is-medium is-fullwidth",on:{"click":_vm.goToMarketplacePage}},[_vm._v("Marketplace")])])])])]),_vm._v(" "),_c('createNewAvatarModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCreateNewAvatarModal),expression:"showCreateNewAvatarModal"}],on:{"close":function($event){_vm.showCreateNewAvatarModal = false},"closeCreateNewAvatarModal":function($event){_vm.closeCreateNewAvatarModal($event);}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U3Ej":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__messageModal_vue__ = __webpack_require__("ozE5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'message-modal': __WEBPACK_IMPORTED_MODULE_1__messageModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showMessageModal: false,
      currentMessage: {
        key: '',
        date: '',
        subject: '',
        message: '',
        dismissed: ''
      },
      text: '',
      messages: []
    };
  },
  mounted: function mounted() {
    this.refreshMessages();
  },


  methods: {

    //If T&C not accepted deliver message to user
    updateMessages: function updateMessages() {
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(this.$store.getters.user.id).child('messages').set(this.messages);
    },
    refreshMessages: function refreshMessages() {
      var _this = this;

      this.messages = [];
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(this.$store.getters.user.id).child('messages').once('value').then(function (data) {
        var obj = data.val();
        for (var key in obj) {
          _this.messages.push({
            key: key,
            date: obj[key].date,
            subject: obj[key].subject,
            message: obj[key].message,
            dismissed: obj[key].dismissed
          });
        }
      });
    },
    dismissMessage: function dismissMessage(message) {
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(this.$store.getters.user.id).child('messages').child(message.key).update({
        dismissed: true
      });
      this.refreshMessages();
    },
    addMessage: function addMessage() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      today = mm + '/' + dd + '/' + yyyy;
      var newMessage = {
        date: today,
        message: this.text
      };
      this.messages.push(newMessage);
    },
    showModal: function showModal(k, d, s, m) {
      this.currentMessage.key = k;
      this.currentMessage.date = d;
      this.currentMessage.subject = s;
      this.currentMessage.message = m;
      this.$root.$emit('currentMessage', this.currentMessage);
      this.showMessageModal = true;
    },
    closeMessageModal: function closeMessageModal() {
      this.showMessageModal = false;
      this.refreshMessages();
    }
  }
});

/***/ }),

/***/ "UCMs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"title is-1",attrs:{"align":"center"}},[_vm._v("Ready for a Challenge?")]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-third"},[_c('p',{staticClass:"title is-4 is-spaced",attrs:{"align":"center"}},[_vm._v("CHALLENGE DATA")]),_vm._v(" "),_c('p',{staticClass:"subtitle is-3",attrs:{"align":"center"}},[_vm._v("Current Challenges")]),_vm._v(" "),_c('table',{staticClass:"table is-striped is-narrow-tablet is-narrow-mobile is-hoverable"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.challenges),function(current,index){return _c('tr',[(current.opponentId == _vm.user.id)?_c('td',[_vm._v(_vm._s(current.challengerFirstName))]):_c('td',[_vm._v(_vm._s(current.opponentFirstName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(current.startDate))]),_vm._v(" "),(current.accepted)?_c('td',[_vm._v(_vm._s(current.duration))]):_c('td'),_vm._v(" "),_c('td',[(!current.accepted && current.opponentId == _vm.user.id)?_c('button',{key:current.key,on:{"click":function($event){_vm.acceptChallenge(current.key, true)}}},[_vm._v("Accept")]):_vm._e(),_vm._v(" "),(!current.accepted && current.opponentId == _vm.user.id)?_c('button',{key:current.key,on:{"click":function($event){_vm.acceptChallenge(current.key, false)}}},[_vm._v("Decline")]):(!current.accepted)?_c('button',[_vm._v("Waiting")]):_vm._e()])])}))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],staticClass:"column is-one-third"},[_c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input",attrs:{"type":"email","id":"SearchEmail","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchForUser($event)},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('a',{staticClass:"button is-dark",on:{"click":_vm.searchForUser}},[_vm._v("Search")])])]),_vm._v(" "),_c('gmap-map',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.mapCenter,"zoom":8}},_vm._l((_vm.availableChallengers),function(c,index){return _c('gmap-marker',{key:index,attrs:{"position":c.position,"clickable":true,"draggable":false,"icon":{ url: 'https://image.ibb.co/cReVdx/rsz_logo.png'}},on:{"click":function($event){_vm.showModal(c.name, c.rank, c.id)}}})})),_vm._v(" "),_c('button',{staticClass:"button is-dark is-fullwidth toggle",on:{"click":_vm.show}},[_vm._v("List View")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMap),expression:"!showMap"}],staticClass:"column is-one-third"},[_vm._m(1,false,false),_vm._v(" "),_c('table',{staticClass:"table is-striped is-narrow-tablet is-narrow-mobile is-hoverable"},[_vm._m(2,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.availableChallengers),function(c,index){return _c('tr',[_c('td',[_vm._v(_vm._s(c.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(c.rank))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"button is-small",on:{"click":function($event){_vm.showModal(c.name, c.rank, c.id)}}},[_vm._v("Challenge!")])])])}))]),_vm._v(" "),_c('button',{staticClass:"button is-dark is-fullwidth toggle",on:{"click":_vm.show}},[_vm._v("Map View")])]),_vm._v(" "),_c('div',{staticClass:"column is-one-third"},[_c('p',{staticClass:"title is-4",attrs:{"align":"center"}},[_vm._v("RECENT CHALLENGES")]),_vm._v(" "),_c('table',{staticClass:"table is-striped is-narrow-tablet is-narrow-mobile is-hoverable"},[_vm._m(3,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.pastChallenges),function(challenge){return _c('tr',[_c('td',[_vm._v(_vm._s(challenge.user))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(challenge.outcome))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"button is-small",on:{"click":function($event){_vm.showModal(challenge.user, null, challenge.key)}}},[_vm._v("Challenge Again!")])])])}))])])])])]),_vm._v(" "),_c('challenge-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showChallengeModal),expression:"showChallengeModal"}],on:{"close":function($event){_vm.showChallengeModal = false}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Challenging")]),_vm._v(" "),_c('th',[_vm._v("Challenge Start")]),_vm._v(" "),_c('th',[_vm._v("Duration")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control is-expanded"},[_c('input',{staticClass:"input",attrs:{"type":"text","placeholder":"Email"}})]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('a',{staticClass:"button is-dark"},[_vm._v("Search")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("User")]),_vm._v(" "),_c('th',[_vm._v("Rank")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("User")]),_vm._v(" "),_c('th',[_vm._v("Outcome")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UFh7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ueqq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hair.3115b9d.png";

/***/ }),

/***/ "V3xM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adminRegister_vue__ = __webpack_require__("EetY");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'adminLogin',
  data: function data() {
    return {
      showAdminRegisterModal: false,
      email: '',
      password: ''
    };
  },

  components: {
    adminRegisterModal: __WEBPACK_IMPORTED_MODULE_1__adminRegister_vue__["a" /* default */]
  },
  computed: {
    admin: function admin() {
      return this.$store.getters.admin;
    }
  },
  watch: {
    admin: function admin(value) {
      if (value !== null && value !== undefined) {
        if (value) {
          this.$router.push('/adminMessaging');
        }
      }
    }
  },
  methods: {
    //Login calls for firebase to authenticate login credentials
    login: function login() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('/admin/').once('value').then(function (data) {
        var adminAccept = false;
        var obj = data.val();
        for (var key in obj) {
          if (obj[key].email == _this.email) {
            _this.$store.dispatch('signAdminIn', { email: _this.email, password: _this.password });
            adminAccept = true;
          }
        }
        if (!adminAccept) {
          _this.$toasted.show("Admin Privileges Not Available for Email Entered", {
            theme: "outline",
            position: "bottom-center",
            duration: 3000,
            fitToScreen: true
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "WVXU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      messageBody: '',
      messageSubject: '',
      messageDate: ''
    };
  },

  methods: {
    updateMessages: function updateMessages(userId, key, message) {
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(userId).child('messages/' + key).set(message);
    },
    setNewMessage: function setNewMessage(userId) {
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(userId).update({
        newMessage: true
      });
    },
    getDate: function getDate() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();

      if (dd < 10) {
        dd = '0' + dd;
      }

      if (mm < 10) {
        mm = '0' + mm;
      }

      today = mm + '/' + dd + '/' + yyyy;
      return today;
    },
    addMessage: function addMessage() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').once('value').then(function (data) {
        var obj = data.val(); // store all objects
        for (var key in obj) {
          // for each key in the group
          var tempId = key;
          var tempEmail = obj[key].email;
          var tempLength = 0;
          for (var mess in obj[key].messages) {
            tempLength++;
          }
          var newMessage = {
            date: _this.getDate(),
            subject: _this.messageSubject,
            message: _this.messageBody
          };
          _this.updateMessages(tempId, tempLength, newMessage);
          _this.setNewMessage(tempId);
        }
        _this.messageBody = '';
        _this.messageSubject = '';
        _this.messageDate = '';
        _this.$toasted.show("Your message has been sent!", {
          theme: "outline",
          position: "bottom-center",
          duration: 3000,
          fitToScreen: true
        });
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),

/***/ "Wmlc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      groupView: true,
      individualView: false
    };
  },

  methods: {
    detailView: function detailView() {
      this.groupView = false;
      this.individualView = true;
    },
    reloadPage: function reloadPage() {
      this.groupView = true;
      this.individualView = false;
    }
  }
});

/***/ }),

/***/ "X4if":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__("PJX0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b6071a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__("myNo");
function injectStyle (ssrContext) {
  __webpack_require__("Sa1c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b6071a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b6071a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XH1l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XIIv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_getusermedia__ = __webpack_require__("PlqT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_getusermedia___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_getusermedia__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createNewAvatarModal_vue__ = __webpack_require__("7f5Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cameraModal_vue__ = __webpack_require__("GEU/");

//
//
//
//
//
//
//
//
//
//
//



/* Package for using camera */


/* Modal to use camera */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'didimoModal',
  data: function data() {
    return {
      avatar: '',

      /* Data needed to Authorization string */
      secret_key: 'test_secret_key_eval253498',
      realm: 'Avatar',
      auth_method: "sha256",
      auth_key: "test_api_key_eval253498",
      auth_nonce: '',
      auth_digest: '',

      /* auth_uri must be exactly same as request for algorithm to work */
      auth_uri: '/api/latest/didimo/"' + this.$store.getters.avatar.didimoKey + '"/download/fbx"'

    };
  },
  mounted: function mounted() {
    if (this.$store.getters.avatar.hasAvatar) {
      this.getDidimoFBX('https://mydidimo.com/api/latest/didimo/' + this.$store.getters.avatar.didimoKey + '/download/fbx');
    }
  },

  methods: {
    changeHasAvatarBoolean: function changeHasAvatarBoolean(boolean) {
      this.$store.dispatch('changeHasAvatar', boolean);
    },
    changeDidimoKey: function changeDidimoKey(key) {
      this.$store.dispatch('changeDidimoKey', key);
    },


    /* Need this function for the getDidimoImage function to use out of range characters for encoding/decoding */
    Uint8ToString: function Uint8ToString(u8a) {
      var CHUNK_SZ = 0x8000;
      var c = [];
      for (var i = 0; i < u8a.length; i += CHUNK_SZ) {
        c.push(String.fromCharCode.apply(null, u8a.subarray(i, i + CHUNK_SZ)));
      }
      return c.join("");
    },


    /* Method that gets the FBX file from server and then renders the avatar.
       Using nearly same exact code as on the eval.mydidimo.com page
    */
    getDidimoFBX: function getDidimoFBX(newsrc) {
      var self = this;

      /* Authorization string must take a new Nonce and digest every call */
      var AuthString = 'DidimoDigest '.concat('realm="Avatar",').concat(" ").concat('auth_method="sha256",').concat(" ").concat('auth_key="test_api_key_eval253498",').concat(" ").concat('auth_nonce="' + self.randomNonce + '",').concat(" ").concat('auth_digest="' + self.randomDigest + '"');

      var xhr = new XMLHttpRequest();
      xhr.open('GET', newsrc, true);
      xhr.setRequestHeader('Authorization', AuthString);
      xhr.setRequestHeader('Accept', '*/*');
      xhr.responseType = 'arraybuffer';
      xhr.onload = function () {
        /* Packages needed to render avatar on WebGLRenderer */
        var THREE = __webpack_require__("Ml+6");

        var fbxFile = 'data:' + xhr.getResponseHeader('content-type') + ';base64,' + btoa(self.Uint8ToString(new Uint8Array(xhr.response)));
        var innerSelf = this;

        /* PerspectiveCamera sets the initial render position of the avatar when page loads */
        var camera = new THREE.PerspectiveCamera(35, 1, 1, 2000);

        var scene = new THREE.Scene();
        // scene.background = new THREE.Color( 0x000000 );

        var mixers = [];
        var renderer;

        //defalt options, settable by url
        var options = {
          audiourl: 'audio.pcm',
          visemesurl: 'visemes.txt',
          controls3d: true,
          controlsAudio: true,
          initialDistance: 60,
          autoplay: false,
          camTarget: "head",
          camAdjust: "0,0,0",
          fbxfile: 'avatar_model.fbx',
          posesfile: null, //"poses_diff_auto.json",
          clearColor: 0x222222,
          animSyncMillis: -100,
          maxBlendMillis: 150,
          // didimo:null,
          sceneInfoFile: null
        };

        if (!Detector.webgl) Detector.addGetWebGLMessage();

        window._getvar = window._getvar || function (n) {
          var r;if (r = new RegExp("[?&]" + String(n).replace(/[\[\]]/g, "\\$&") + "(=([^&#]*)|&|#|$)").exec(window.location.href)) r = r[2] && decodeURIComponent(r[2].replace(/\+/g, " ")) || '';return r;
        };

        function parseUrl(query) {
          var urlParams;
          var match,
              pl = /\+/g,
              // Regex for replacing addition symbol with a space
          search = /([^&=]+)=?([^&]*)/g,
              decode = function decode(s) {
            return decodeURIComponent(s.replace(pl, " "));
          };
          urlParams = {};
          while (match = search.exec(query)) {
            var decoded = decode(match[2]);
            try {
              decoded = JSON.parse(decoded);
            } catch (e) {}
            urlParams[decode(match[1])] = decoded;
          }
          return urlParams;
        }
        var urlParams = parseUrl(window.location.search.substring(1));

        for (var i in urlParams) {
          options[i] = urlParams[i];
        }

        if (options.didimo !== null) {
          var didimodir = 'https://' + 'mydidimo.com/api/latest/didimo/' + self.$store.getters.avatar.didimoKey + '/preview';
          options.fbxfile = didimodir + '/avatar_model.fbx';
          options.sceneInfoFile = didimodir + "/scene_info.json";
        }

        var previewcanvas = document.getElementById("previewcanvas") || document.body;

        function getRenderHeight() {
          // return previewcanvas.clientHeight;
          return window.innerHeight * 0.7;
        }
        function getRenderWidth() {
          // return previewcanvas.clientWidth;
          return window.innerWidth * 0.7;
        }
        function halfway(a, b) {
          return a + (b - a) / 2;
        }

        var helpers = [];
        function addHelper(helper) {
          helpers.push(helper);
          scene.add(helper);
        }
        function updateHelpers() {
          for (var i = 0; i < helpers.length; i++) {
            helpers[i].update();
          }
        }

        var mesh;
        var controls;

        var poses = {};
        var visemeList = [];

        var pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
        var antialias = pixelRatio == 1;

        // model
        var manager = new THREE.LoadingManager();
        manager.onStart = function (url, itemsLoaded, itemsTotal) {
          console.log('Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
        };
        manager.onProgress = function (item, loaded, total) {
          console.log(item, loaded, total);
        };
        manager.onLoad = function () {
          console.log('Loading Complete!');
          // onWindowResize();

          head.add(mesh);
          head.visible = true;

          // if(visemeList && visemeList.length > 0 && audio && audio.src)
          //   setTimeout(function(){ audio.play() },0);
        };
        manager.onError = function (url) {
          console.log('There was an error loading: ' + url);
        };

        var onProgress = function onProgress(xhr) {
          if (xhr.lengthComputable) {
            var percentComplete = xhr.loaded / xhr.total * 100;
            console.log(Math.round(percentComplete, 2) + '% downloaded');
          }
        };
        function onError(error) {
          console.error(error);
        }

        function globalLoadProgressManager(xhr) {
          var xhrp = 0;

          if (xhr.lengthComputable) {
            xhrp = xhr.loaded / xhr.total;
          } else {
            xhrp = 0;
          }

          var percentComplete = (xhrp + manager.loaded) / manager.total * 100;
          var _s = document.getElementById("loading").style;
          _s.transition = "all 100ms";
          _s.width = ~~percentComplete + "%";
        }

        var fbxLoader = new THREE.FBXLoader(manager);
        var imageLoader = new THREE.ImageLoader(manager);
        var fileLoader = new THREE.FileLoader(manager);
        var jsonLoader = new THREE.JSONLoader(manager);
        var objectLoader = new THREE.ObjectLoader(manager);

        /* Need to force local paths for .jpg assets to load correctly */
        THREE.FBXLoader.forceLocalPaths = true;

        var clock = new THREE.Clock();
        clock.start();

        renderer = new THREE.WebGLRenderer({ antialias: antialias, logarithmicDepthBuffer: true, alpha: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(350, 400);
        renderer.setClearColor(0xffffff, 0);
        previewcanvas.appendChild(renderer.domElement);

        var head = new THREE.Group();
        scene.add(head);

        /* TRACKBALL CONTROLS */
        var controls = new THREE.TrackballControls(camera, renderer.domElement);
        controls.rotateSpeed = 1.0;
        controls.zoomSpeed = 0.2;
        controls.panSpeed = 0.8;
        controls.noRotate = false;
        controls.noZoom = false;
        controls.noPan = true;
        controls.dynamicDampingFactor = .4;
        controls.keys = [65, 83, 68];
        controls.target.set(0, 0, 0);
        controls.minDistance = 20;
        controls.maxDistance = 80;
        controls.enabled = options.controls3d;

        var light_ambient = new THREE.AmbientLight(0x606060);
        scene.add(light_ambient);

        var light_camera = new THREE.DirectionalLight(0xFFEFE1, 0.80);
        controls.addEventListener('change', light_update);
        function light_update() {
          light_camera.position.copy(camera.position);
          light_camera.position.y = 0;
        }
        light_camera.position.copy(camera.position);
        scene.add(light_camera);

        if (options.posesfile) fileLoader.load(options.posesfile, function (js) {
          var ps = JSON.parse(js);
          for (var n in ps) {
            if (n != "rest") poses[n] = ps[n];
          }
        }, globalLoadProgressManager);

        function loadFBX(sceneInfo) {
          var bbcenter;
          var bbtarget;

          if (sceneInfo && sceneInfo.eyes_center && sceneInfo.head_center) {
            var eyes_center = new THREE.Vector3().fromArray(sceneInfo.eyes_center);
            var head_center = new THREE.Vector3().fromArray(sceneInfo.head_center);
            bbcenter = new THREE.Vector3().addScaledVector(eyes_center, .5).addScaledVector(head_center, .5);
            bbcenter.z = head_center.z;
            console.log(sceneInfo);
          }

          fbxLoader.load(options.fbxfile, function (m) {
            mesh = m;

            if (!bbcenter) {
              //no scene file, autodetect
              if (bbtarget = mesh.getObjectByName(options.camTarget)) {
                var bb = new THREE.Box3().setFromObject(bbtarget);
                bbcenter = new THREE.Vector3(halfway(bb.min.x, bb.max.x), halfway(bb.min.y, bb.max.y), halfway(bb.min.z, bb.max.z));
              } else {
                console.error("camTarget", options.camTarget, "not found!");
              }
            }

            var camAdjust = options.camAdjust && options.camAdjust.split(',');
            if ((typeof camAdjust === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(camAdjust)) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()([])) {
              bbcenter.x += Number(camAdjust[0]);
              bbcenter.y += Number(camAdjust[1]);
              bbcenter.z += Number(camAdjust[2]);
            }
            camera.lookAt(bbcenter);
            camera.position.x = 0;
            camera.position.y = bbcenter.y;
            camera.position.z = options.initialDistance;

            if (controls) controls.target = bbcenter;

            //generate rest pose
            mesh.skeleton.bones.forEach(function (bone) {
              var name = bone.name;
              if (!poses.rest) poses.rest = {};
              if (!poses.rest[name]) poses.rest[name] = {};
              if (!poses.rest[name].translation) poses.rest[name].translation = [0, 0, 0];
              if (!poses.rest[name].rotation) poses.rest[name].rotation = [0, 0, 0];
              if (!poses.rest[name].scale) poses.rest[name].scale = [1, 1, 1];
              poses.rest[name].translation = bone.position.toArray();
              poses.rest[name].rotation = bone.rotation.toArray();
              poses.rest[name].scale = bone.scale.toArray();
            });

            //regardless of choice of materials
            //force skinning
            mesh.traverse(function (m) {
              if (m.isSkinnedMesh && m.material && !m.material.skinning) {
                m.material.skinning = true;
              }
            });

            if (document.body.classList) document.body.classList.add("hasVisual");else document.body.className += ' ' + "hasVisual";

            // fix z-buffer problems with eyelashes
            var lashesOrder = 10;
            mesh.traverse(function (child) {
              if (child instanceof THREE.Mesh && String(child.name).match("lashes")) {
                child.renderOrder = lashesOrder;
                child.material.side = THREE.DoubleSide;
                child.material.depthWrite = false;
              }
            });
          }, onProgress, onError);
        }

        if (options.sceneInfoFile) fileLoader.load(options.sceneInfoFile, function (sceneInfo) {
          try {
            sceneInfo = JSON.parse(sceneInfo);
          } catch (e) {
            console.log("can't parse scene_info, continue with options/defaults");
            sceneInfo = null;
          }
          loadFBX(sceneInfo);
        }, undefined, function (data) {
          console.log("no scene_info, continue with options/defaults");
          loadFBX(null);
        });

        function animate() {
          requestAnimationFrame(animate);
          render();
        }
        animate();

        var maxFPS = 60;
        var renderPtime = 0;
        var oldposition = 0;
        function render() {

          var ctime = new Date().getTime();
          if (!window.audio || window.audio.paused) if (ctime - renderPtime < 1000 / maxFPS) return;

          renderPtime = ctime;

          var delta = clock.getDelta();

          window.stats && stats.update();

          window.animate_triggers && animate_triggers();

          window.updateHelpers && updateHelpers();

          var controlsAreQuiet = true;

          if (controls) {
            controls && controls.update();

            //throttle
            var co = controls.object;
            co.up.x += (0 - co.up.x) * (delta * 8);
            co.up.y += (1 - co.up.y) * (delta * 8);
            co.up.z += (0 - co.up.z) * (delta * 8);
            var p = Math.abs(co.position.x) + Math.abs(co.position.y) + Math.abs(co.position.z);
            controlsAreQuiet = Math.abs(p - oldposition) < 0.000001;
            oldposition = p;
          }

          var slow = window.audio && audio.paused && controlsAreQuiet;

          maxFPS = slow ? 10 : 50;

          //should not be needed if we don't change cameras, but a bug on some chrome versions
          //create dragging effect
          //renderer.clear();
          renderer.render(scene, camera);
        }

        function populate() {
          var objects = { unnamed: [] };
          mesh.traverse(function (o) {

            if (o.name) {
              if (window[o.name]) console.log("window." + o.name + " already exists");else {
                window[o.name] = o;
              }
            }

            if (o.name) objects[o.name] = o;else objects.unnamed.push(o);
          });
        }

        function setupDatGui() {
          var gui = new dat.GUI();
          var folder = gui.addFolder("BONES");

          var bones = mesh.skeleton.bones;

          var BoneSelect = function BoneSelect(bone) {
            this.bone = bone;
            this.bonename = bone.name;
            this.selectbone = function () {
              tcontrol.attach(this.bone);
            };
          };

          for (var i = 0; i < bones.length; i++) {
            var boneSelect = new BoneSelect(bones[i]);
            folder.add(boneSelect, 'selectbone').name(bones[i].name.replace('Template', ''));
          }

          folder.open();
          scene.add(skeletonHelper = new THREE.SkeletonHelper(scene));
        }

        function seeBones() {
          setTimeout(function () {
            var scriptGui = document.createElement('script');
            scriptGui.onload = setupDatGui;
            scriptGui.src = 'dat.gui.js';
            document.head.appendChild(scriptGui);
          }, 100);
        }
      };
      xhr.send(null);
    },
    requestAnimationFrame: function requestAnimationFrame() {
      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function ( /* function */callback) {
        window.setTimeout(callback, 1000 / 60);
      };
    }
  },
  computed: {
    /* Randomizes each Nonce for each call using Authorization header */
    randomNonce: function randomNonce() {
      var text = "";
      var possible = "abcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 11; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },

    /* Randomizes each Digest for each call using Authorization header */
    randomDigest: function randomDigest() {
      var digest = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.HmacSHA256(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.SHA256(this.auth_key + this.secret_key) + __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.SHA256(this.auth_key + this.randomNonce + this.auth_uri), this.secret_key);
      return digest;
    }
  },
  components: {
    createNewAvatarModal: __WEBPACK_IMPORTED_MODULE_3__createNewAvatarModal_vue__["a" /* default */],
    cameraModal: __WEBPACK_IMPORTED_MODULE_4__cameraModal_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "XxzK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      progress: 0,
      intervalTime: 2000,
      totalSeconds: 0,
      nonce: this.randomNonce,
      digest: this.randomDigest,

      /* Data needed to Authorization string */
      secret_key: 'test_secret_key_eval253498',
      realm: 'Avatar',
      auth_method: "sha256",
      auth_key: "test_api_key_eval253498",
      auth_nonce: '',
      auth_digest: '',

      /* auth_uri must be exactly same as request for algorithm to work */
      auth_uri: '/api/1.2.0/didimo/' + this.$store.getters.didimoKey + '/status'
    };
  },

  methods: {
    goToAvatar: function goToAvatar() {
      /* Make call to API every 2 seconds to update percentage of upload */
      var handle = setInterval(this.getPercentageUploaded, this.intervalTime);
      /* Stop making calls after a minute */
      setTimeout(function () {
        clearInterval(handle);
      }, 60000);
    },
    toAvatar: function toAvatar() {
      this.$router.push({ path: '/avatar' });
    },
    getPercentageUploaded: function getPercentageUploaded() {
      /* Call totalTime method here to change the totalSeconds var which calls the Watcher
         which then call the random Nonce and Digest for every call */
      this.totalTime();
      var self = this;

      var xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://mydidimo.com/api/1.2.0/didimo/' + this.$store.getters.didimoKey + '/status', true);
      /* Authorization string must take a new Nonce and digest every call */
      var AuthString = 'DidimoDigest '.concat('realm="Avatar",').concat(" ").concat('auth_method="sha256",').concat(" ").concat('auth_key="test_api_key_eval253498",').concat(" ").concat('auth_nonce="' + this.nonce + '",').concat(" ").concat('auth_digest="' + this.digest + '"');
      xhr.setRequestHeader('Authorization', AuthString);
      xhr.setRequestHeader('Accept', '*/*');
      xhr.onreadystatechange = function () {
        /* Get the percent from the response for our progress bar */
        var responseText = JSON.parse(xhr.responseText);
        self.progress = responseText['percent'];
      };
      xhr.send(null);
    },

    /* Randomizes each Nonce call after the first randomNonce in computed */
    randomNonceAgain: function randomNonceAgain() {
      var possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
      this.nonce = '';
      for (var i = 0; i < 11; i++) {
        this.nonce += possible.charAt(Math.floor(Math.random() * possible.length));
      }
    },

    /* Randomizes each Digest call after the first randomDigest in computed */
    randomDigestAgain: function randomDigestAgain() {
      this.digest = '';
      this.digest = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.HmacSHA256(__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.SHA256(this.auth_key + this.secret_key) + __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.SHA256(this.auth_key + this.nonce + this.auth_uri), this.secret_key);
    },

    /* This is for the Watcher to determine when to change the Nonce and Digest */
    totalTime: function totalTime() {
      var seconds = this.totalSeconds + this.intervalTime;
      this.totalSeconds = seconds;
    }
  },
  mounted: function mounted() {
    /* Gets the initial Nonce and Digest */
    this.randomNonceAgain();
    this.randomDigestAgain();

    /* Once mounted, start making the API calls */
    this.goToAvatar();
  },

  computed: {
    /* Randomizes each Nonce for first call using Authorization header */
    randomNonce: function randomNonce() {
      var text = "";
      var possible = 'abcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 11; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },

    /* Randomizes each Digest for first call using Authorization header */
    randomDigest: function randomDigest() {
      var digest = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.HmacSHA256(__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.SHA256(this.auth_key + this.secret_key) + __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.SHA256(this.auth_key + this.nonce + this.auth_uri), this.secret_key);
      return digest;
    }
  },
  watch: {
    /* Once the totalSeconds changes, update the nonce and the digest for each new call to API */
    totalSeconds: function totalSeconds(val) {
      this.randomNonceAgain();
      this.randomDigestAgain();
    },
    /* Watches until the progress bar gets to 100% and then reloads the Avatar page */
    progress: function progress(val, oldVal) {
      if (val == 100) {
        setTimeout(this.toAvatar, 2000);
      }
    }
  }
});

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c86d54a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("3y59");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c86d54a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YLc+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cameraModal_vue__ = __webpack_require__("GEU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navbar_vue__ = __webpack_require__("lfLh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'createNewAvatarModal',
  data: function data() {
    return {
      showCameraModal: false,
      Navbar: false
    };
  },

  methods: {
    accessUserMedia: function accessUserMedia() {
      /*
       *  Copyright (c) 2015 The WebRTC project authors. All Rights Reserved.
       *
       *  Use of this source code is governed by a BSD-style license
       *  that can be found in the LICENSE file in the root of the source
       *  tree.
       */

      'use strict';

      this.photoReady = false;

      // // Put variables in global scope to make them available to the browser console.
      var video = document.getElementById('video');
      video.style.display = "block";
      var videoOverlay = document.getElementById('videoOverlay');
      videoOverlay.style.display = "block";
      var canvas = document.getElementById('canvas');
      canvas.style.display = "none";

      if (video != null) {
        var handleSuccess = function handleSuccess(stream) {
          // window.stream = stream; // make stream available to browser console
          video.srcObject = stream;
        };

        var handleError = function handleError(error) {
          console.log('navigator.getUserMedia error: ', error);
        };

        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', true);
        video.setAttribute('controls', true);

        var constraints = {
          audio: false,
          video: {
            facingMode: 'user'
          }
        };

        navigator.mediaDevices.getUserMedia(constraints).then(handleSuccess).catch(handleError);
      } else {
        var _handleSuccess = function _handleSuccess(stream) {
          video.srcObject = stream;
        };

        var _handleError = function _handleError(error) {
          console.log('navigator.getUserMedia error: ', error);
        };

        var video = document.createElement("video");
        video.autoplay = true;

        var camera = document.getElementById('camera');
        camera.insertBefore(video, canvas);

        var canvas = document.getElementById('canvas');
        if (canvas != null) {
          document.getElementById('canvas').style.visibility = "hidden";
        }

        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', true);
        video.setAttribute('controls', true);

        var constraints = {
          audio: false,
          video: {
            facingMode: 'user'
          }
        };

        navigator.mediaDevices.getUserMedia(constraints).then(_handleSuccess).catch(_handleError);
      }
    }
  },
  components: {
    cameraModal: __WEBPACK_IMPORTED_MODULE_0__cameraModal_vue__["a" /* default */],
    Navbar: __WEBPACK_IMPORTED_MODULE_1__Navbar_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "YUiw":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @author Kyle-Larson https://github.com/Kyle-Larson
 * @author Takahiro https://github.com/takahirox
 *
 * Loader loads FBX file and generates Group representing FBX scene.
 * Requires FBX file to be >= 7.0 and in ASCII or to be any version in Binary format.
 *
 * Supports:
 * 	Mesh Generation (Positional Data)
 * 	Normal Data (Per Vertex Drawing Instance)
 *  UV Data (Per Vertex Drawing Instance)
 *  Skinning
 *  Animation
 * 	- Separated Animations based on stacks.
 * 	- Skeletal & Non-Skeletal Animations
 *  NURBS (Open, Closed and Periodic forms)
 *
 * Needs Support:
 * 	Indexed Buffers
 * 	PreRotation support.
 */

 var THREE = window.THREE || __webpack_require__("Ml+6");

( function () {

	/**
	 * Generates a loader for loading FBX files from URL and parsing into
	 * a THREE.Group.
	 * @param {THREE.LoadingManager} manager - Loading Manager for loader to use.
	 */
	THREE.FBXLoader = function ( manager ) {

		this.manager = ( manager !== undefined ) ? manager : THREE.DefaultLoadingManager;

	};

	Object.assign( THREE.FBXLoader.prototype, {

		/**
		 * Loads an ASCII/Binary FBX file from URL and parses into a THREE.Group.
		 * THREE.Group will have an animations property of AnimationClips
		 * of the different animations exported with the FBX.
		 * @param {string} url - URL of the FBX file.
		 * @param {function(THREE.Group):void} onLoad - Callback for when FBX file is loaded and parsed.
		 * @param {function(ProgressEvent):void} onProgress - Callback fired periodically when file is being retrieved from server.
		 * @param {function(Event):void} onError - Callback fired when error occurs (Currently only with retrieving file, not with parsing errors).
		 */
		load: function ( url, onLoad, onProgress, onError ) { //not used for assets/textures
			var self = this;

			var resourceDirectory = url.split( /[\\\/]/ );
			resourceDirectory.pop();
			resourceDirectory = resourceDirectory.join( '/' ) + '/';

			var loader = new THREE.FileLoader( this.manager );
			loader.setResponseType( 'arraybuffer' );
			loader.load( url, function ( buffer ) {

				try {

					var scene = self.parse( buffer, resourceDirectory );

					onLoad( scene );

				} catch ( error ) {

					window.setTimeout( function () {

						if ( onError ) onError( error );

						self.manager.itemError( url );

					}, 0 );

				}

			}, onProgress, onError );

		},

		/**
		 * Parses an ASCII/Binary FBX file and returns a THREE.Group.
		 * THREE.Group will have an animations property of AnimationClips
		 * of the different animations within the FBX file.
		 * @param {ArrayBuffer} FBXBuffer - Contents of FBX file to parse.
		 * @param {string} resourceDirectory - Directory to load external assets (e.g. textures ) from.
		 * @returns {THREE.Group}
		 */
		parse: function ( FBXBuffer, resourceDirectory ) {

			var FBXTree;

			if ( isFbxFormatBinary( FBXBuffer ) ) {

				FBXTree = new BinaryParser().parse( FBXBuffer );

			} else {

				var FBXText = convertArrayBufferToString( FBXBuffer );

				if ( ! isFbxFormatASCII( FBXText ) ) {

					self.manager.itemError( url );
					throw new Error( 'FBXLoader: Unknown format.' );

				}

				if ( getFbxVersion( FBXText ) < 7000 ) {

					self.manager.itemError( url );
					throw new Error( 'FBXLoader: FBX version not supported for file at ' + url + ', FileVersion: ' + getFbxVersion( FBXText ) );

				}

				FBXTree = new TextParser().parse( FBXText );

			}

			// console.log( FBXTree );

			var connections = parseConnections( FBXTree );
			var images = parseImages( FBXTree );
			var textures = parseTextures( FBXTree, new THREE.TextureLoader( this.manager ).setPath( resourceDirectory ), images, connections );
			var materials = parseMaterials( FBXTree, textures, connections );
			var deformers = parseDeformers( FBXTree, connections );
			var geometryMap = parseGeometries( FBXTree, connections, deformers );
			var sceneGraph = parseScene( FBXTree, connections, deformers, geometryMap, materials );

			return sceneGraph;

		}

	} );

	/**
	 * Parses map of relationships between objects.
	 * @param {{Connections: { properties: { connections: [number, number, string][]}}}} FBXTree
	 * @returns {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>}
	 */
	function parseConnections( FBXTree ) {

		/**
		 * @type {Map<number, { parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>}
		 */
		var connectionMap = new Map();

		if ( 'Connections' in FBXTree ) {

			/**
			 * @type {[number, number, string][]}
			 */
			var connectionArray = FBXTree.Connections.properties.connections;
			for ( var connectionArrayIndex = 0, connectionArrayLength = connectionArray.length; connectionArrayIndex < connectionArrayLength; ++ connectionArrayIndex ) {

				var connection = connectionArray[ connectionArrayIndex ];

				if ( ! connectionMap.has( connection[ 0 ] ) ) {

					connectionMap.set( connection[ 0 ], {
						parents: [],
						children: []
					} );

				}

				var parentRelationship = { ID: connection[ 1 ], relationship: connection[ 2 ] };
				connectionMap.get( connection[ 0 ] ).parents.push( parentRelationship );

				if ( ! connectionMap.has( connection[ 1 ] ) ) {

					connectionMap.set( connection[ 1 ], {
						parents: [],
						children: []
					} );

				}

				var childRelationship = { ID: connection[ 0 ], relationship: connection[ 2 ] };
				connectionMap.get( connection[ 1 ] ).children.push( childRelationship );

			}

		}

		return connectionMap;

	}

	/**
	 * Parses map of images referenced in FBXTree.
	 * @param {{Objects: {subNodes: {Texture: Object.<string, FBXTextureNode>}}}} FBXTree
	 * @returns {Map<number, string(image blob URL)>}
	 */
	function parseImages( FBXTree ) {

		/**
		 * @type {Map<number, string(image blob URL)>}
		 */
		var imageMap = new Map();

		if ( 'Video' in FBXTree.Objects.subNodes ) {

			var videoNodes = FBXTree.Objects.subNodes.Video;

			for ( var nodeID in videoNodes ) {

				var videoNode = videoNodes[ nodeID ];

				// raw image data is in videoNode.properties.Content
				if ( 'Content' in videoNode.properties ) {

					var image = parseImage( videoNodes[ nodeID ] );
					imageMap.set( parseInt( nodeID ), image );

				}

			}

		}

		return imageMap;

	}

	/**
	 * @param {videoNode} videoNode - Node to get texture image information from.
	 * @returns {string} - image blob URL
	 */
	function parseImage( videoNode ) {

		var buffer = videoNode.properties.Content;
		var array = new Uint8Array( buffer );
		var fileName = videoNode.properties.RelativeFilename || videoNode.properties.Filename;
		var extension = fileName.slice( fileName.lastIndexOf( '.' ) + 1 ).toLowerCase();

		if(THREE.FBXLoader.forceLocalPaths){
			var o = fileName;
			fileName = fileName.replace(/^.*[\\\/]/, '');
			if(o!=fileName)
				console.log('forcing local path of',fileName);
		}


		var type;

		switch ( extension ) {

			case 'bmp':

				type = 'image/bmp';
				break;

			case 'jpg':

				type = 'image/jpeg';
				break;

			case 'png':

				type = 'image/png';
				break;

			case 'tif':

				type = 'image/tiff';
				break;

			default:

				console.warn( 'FBXLoader: No support image type ' + extension );
				return;

		}

		return window.URL.createObjectURL( new Blob( [ array ], { type: type } ) );

	}

	/**
	 * Parses map of textures referenced in FBXTree.
	 * @param {{Objects: {subNodes: {Texture: Object.<string, FBXTextureNode>}}}} FBXTree
	 * @param {THREE.TextureLoader} loader
	 * @param {Map<number, string(image blob URL)>} imageMap
	 * @param {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>} connections
	 * @returns {Map<number, THREE.Texture>}
	 */
	function parseTextures( FBXTree, loader, imageMap, connections ) {

		/**
		 * @type {Map<number, THREE.Texture>}
		 */
		var textureMap = new Map();

		if ( 'Texture' in FBXTree.Objects.subNodes ) {

			var textureNodes = FBXTree.Objects.subNodes.Texture;
			for ( var nodeID in textureNodes ) {

				var texture = parseTexture( textureNodes[ nodeID ], loader, imageMap, connections );
				textureMap.set( parseInt( nodeID ), texture );

			}

		}

		return textureMap;

	}

	/**
	 * @param {textureNode} textureNode - Node to get texture information from.
	 * @param {THREE.TextureLoader} loader
	 * @param {Map<number, string(image blob URL)>} imageMap
	 * @param {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>} connections
	 * @returns {THREE.Texture}
	 */
	function parseTexture( textureNode, loader, imageMap, connections ) {

		var FBX_ID = textureNode.id;

		var name = textureNode.name;

		var fileName;

		var filePath = textureNode.properties.FileName;
		var relativeFilePath = textureNode.properties.RelativeFilename;



		var children = connections.get( FBX_ID ).children;

		if ( children !== undefined && children.length > 0 && imageMap.has( children[ 0 ].ID ) ) {

			fileName = imageMap.get( children[ 0 ].ID );

		} else if ( relativeFilePath !== undefined && relativeFilePath[ 0 ] !== '/' &&
				relativeFilePath.match( /^[a-zA-Z]:/ ) === null ) {

			// use textureNode.properties.RelativeFilename
			// if it exists and it doesn't seem an absolute path

			fileName = relativeFilePath;

		} else {

			var split = filePath.split( /[\\\/]/ );

			if ( split.length > 0 ) {

				fileName = split[ split.length - 1 ];

			} else {

				fileName = filePath;

			}

		}

		var currentPath = loader.path;

		if ( fileName.indexOf( 'blob:' ) === 0 ) {

			loader.setPath( undefined );

		}

		/**
		 * @type {THREE.Texture}
		 */

		if(THREE.FBXLoader.forceLocalPaths){
			var o = fileName;
			fileName = fileName.replace(/^.*[\\\/]/, '');
			if(o!=fileName)
				console.log('forcing local path of',fileName);
		}

		var texture = loader.load( fileName );
		texture.name = name;
		texture.FBX_ID = FBX_ID;

		var wrapModeU = textureNode.properties.WrapModeU;
		var wrapModeV = textureNode.properties.WrapModeV;

		var valueU = wrapModeU !== undefined ? wrapModeU.value : 0;
		var valueV = wrapModeV !== undefined ? wrapModeV.value : 0;

		// http://download.autodesk.com/us/fbx/SDKdocs/FBX_SDK_Help/files/fbxsdkref/class_k_fbx_texture.html#889640e63e2e681259ea81061b85143a
		// 0: repeat(default), 1: clamp

		texture.wrapS = valueU === 0 ? THREE.RepeatWrapping : THREE.ClampToEdgeWrapping;
		texture.wrapT = valueV === 0 ? THREE.RepeatWrapping : THREE.ClampToEdgeWrapping;

		loader.setPath( currentPath );

		return texture;

	}

	/**
	 * Parses map of Material information.
	 * @param {{Objects: {subNodes: {Material: Object.<number, FBXMaterialNode>}}}} FBXTree
	 * @param {Map<number, THREE.Texture>} textureMap
	 * @param {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>} connections
	 * @returns {Map<number, THREE.Material>}
	 */
	function parseMaterials( FBXTree, textureMap, connections ) {

		var materialMap = new Map();

		if ( 'Material' in FBXTree.Objects.subNodes ) {

			var materialNodes = FBXTree.Objects.subNodes.Material;
			for ( var nodeID in materialNodes ) {

				var material = parseMaterial( materialNodes[ nodeID ], textureMap, connections );
				materialMap.set( parseInt( nodeID ), material );

			}

		}

		return materialMap;

	}

	/**
	 * Takes information from Material node and returns a generated THREE.Material
	 * @param {FBXMaterialNode} materialNode
	 * @param {Map<number, THREE.Texture>} textureMap
	 * @param {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>} connections
	 * @returns {THREE.Material}
	 */
	function parseMaterial( materialNode, textureMap, connections ) {

		var FBX_ID = materialNode.id;
		var name = materialNode.attrName;
		var type = materialNode.properties.ShadingModel;

		//Case where FBXs wrap shading model in property object.
		if ( typeof type === 'object' ) {

			type = type.value;

		}

		var children = connections.get( FBX_ID ).children;

		var parameters = parseParameters( materialNode.properties, textureMap, children );

		var material;

		switch ( type.toLowerCase() ) {


			case 'phong':
				material = new THREE.MeshPhongMaterial();
				break;

			case 'lambert':
				material = new THREE.MeshLambertMaterial();
				break;
			default:
				console.warn( 'No implementation given for material type ' + type + ' in FBXLoader.js.  Defaulting to basic material' );
				material = new THREE.MeshBasicMaterial( { color: 0x3300ff } );
				break;

		}

		material.setValues( parameters );
		material.name = name;

		return material;

	}

	/**
	 * @typedef {{Diffuse: FBXVector3, Specular: FBXVector3, Shininess: FBXValue, Emissive: FBXVector3, EmissiveFactor: FBXValue, Opacity: FBXValue}} FBXMaterialProperties
	 */
	/**
	 * @typedef {{color: THREE.Color=, specular: THREE.Color=, shininess: number=, emissive: THREE.Color=, emissiveIntensity: number=, opacity: number=, transparent: boolean=, map: THREE.Texture=}} THREEMaterialParameterPack
	 */
	/**
	 * @param {FBXMaterialProperties} properties
	 * @param {Map<number, THREE.Texture>} textureMap
	 * @param {{ID: number, relationship: string}[]} childrenRelationships
	 * @returns {THREEMaterialParameterPack}
	 */
	function parseParameters( properties, textureMap, childrenRelationships ) {

		var parameters = {};

		var difuseFactorMap; //hack to support difuse factors

		if ( properties.Diffuse ) {

			parameters.color = parseColor( properties.Diffuse );

		}
		if ( properties.Specular ) {

			parameters.specular = parseColor( properties.Specular );

		}
		if ( properties.Shininess ) {

			parameters.shininess = properties.Shininess.value;

		}
		if ( properties.Emissive ) {

			parameters.emissive = parseColor( properties.Emissive );

		}
		if ( properties.EmissiveFactor ) {

			parameters.emissiveIntensity = properties.EmissiveFactor.value;

		}
		if ( properties.Opacity ) {

			parameters.opacity = properties.Opacity.value;

		}
		if ( parameters.opacity < 1.0 ) {

			parameters.transparent = true;

		}



		for ( var childrenRelationshipsIndex = 0, childrenRelationshipsLength = childrenRelationships.length; childrenRelationshipsIndex < childrenRelationshipsLength; ++ childrenRelationshipsIndex ) {

			var relationship = childrenRelationships[ childrenRelationshipsIndex ];

			var type = relationship.relationship;
			type = type.replace(/^ "/,'');


			switch ( type ) {

				case "DiffuseColor":
					parameters.map = textureMap.get( relationship.ID );
					break;

				case "Bump":
					parameters.bumpMap = textureMap.get( relationship.ID );

                    if (properties.BumpFactor) {
                        parameters.bumpScale = properties.BumpFactor.value/5;
                    }else{
                        parameters.bumpScale = 0.01;
					}

					break;

				case "NormalMap":
					parameters.normalMap = textureMap.get( relationship.ID );
					break;

				case "DiffuseFactor":
					difuseFactorMap = textureMap.get( relationship.ID );
					break;

				case "TransparentColor":
					parameters.alphaMap = textureMap.get( relationship.ID );
					parameters.transparent = true;
					break;

				case "SpecularColor":
                    parameters.specularMap = textureMap.get( relationship.ID );
					break;

				case "AmbientColor":
				case "EmissiveColor":
				default:
					console.warn( 'Unknown texture application of type ' + type + ', skipping texture' );
					break;

			}

		}

		if(parameters.map && difuseFactorMap){
		    //set color to a default value
            //maya does not allow to edit the Difuse value when its attached to a map;
            //so when we have a difuse map and and a difuse factor map we set the color to default
		    parameters.color=undefined;
			parameters.map.difuseFactorMap = difuseFactorMap;

			function __blend(){

                var img1 = parameters.map.image;
                var img2 = parameters.map.difuseFactorMap.image;

                var width = img1.width;
                var height = img1.height;
                var canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                var context = canvas.getContext('2d');

                var pixels = 4 * width * height;
                context.drawImage(img1, 0, 0);
                var image1 = context.getImageData(0, 0, width, height);
                var imageData1 = image1.data;
                context.drawImage(img2, 0, 0);
                var image2 = context.getImageData(0, 0, width, height);
                var imageData2 = image2.data;

                //blend .5 .5
                //while (pixels--) {
                //    imageData1[pixels] = imageData1[pixels] * 0.5 + imageData2[pixels] * 0.5;
                //}

                //multiply difuseFactor (green channel only)
                while (pixels--) {
                    var baseMultiplier = 1;
                    var df = ((imageData2[pixels] & 0x00FF00 >> 8)/0xFF) * baseMultiplier;
                    var pixel = imageData1[pixels];

                    var R = (pixel & 0xFF0000) >> 16;
                    var G = (pixel & 0xFF00) >> 8;
                    var B = (pixel & 0xFF);

                    imageData1[pixels] = ( Math.min(0xFF,R * df) <<16) | (Math.min(0xFF,G * df)<<8) | Math.min(0xFF,B * df);
                }

                image1.data = imageData1;
                context.putImageData(image1, 0, 0);

                img1.src = canvas.toDataURL();
            }

            parameters.map.image.addEventListener('load', function(){
                if(parameters.map.image.ready)return;
                parameters.map.image.ready = true;

                if(parameters.map.difuseFactorMap.image.ready)
                    __blend()
            });
            parameters.map.difuseFactorMap.image.addEventListener('load', function(){
                if(parameters.map.difuseFactorMap.image.ready)return;
                parameters.map.difuseFactorMap.image.ready = true;

                if(parameters.map.image.ready)
                    __blend()
            });

		}


		return parameters;

	}

	/**
	 * Generates map of Skeleton-like objects for use later when generating and binding skeletons.
	 * @param {{Objects: {subNodes: {Deformer: Object.<number, FBXSubDeformerNode>}}}} FBXTree
	 * @param {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>} connections
	 * @returns {Map<number, {map: Map<number, {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}>, array: {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}[], skeleton: THREE.Skeleton|null}>}
	 */
	function parseDeformers( FBXTree, connections ) {

		var deformers = {};

		if ( 'Deformer' in FBXTree.Objects.subNodes ) {

			var DeformerNodes = FBXTree.Objects.subNodes.Deformer;

			for ( var nodeID in DeformerNodes ) {

				var deformerNode = DeformerNodes[ nodeID ];

				if ( deformerNode.attrType === 'Skin' ) {

					var conns = connections.get( parseInt( nodeID ) );
					var skeleton = parseSkeleton( conns, DeformerNodes );
					skeleton.FBX_ID = parseInt( nodeID );

					deformers[ nodeID ] = skeleton;

				}

			}

		}

		return deformers;

	}

	/**
	 * Generates a "Skeleton Representation" of FBX nodes based on an FBX Skin Deformer's connections and an object containing SubDeformer nodes.
	 * @param {{parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}} connections
	 * @param {Object.<number, FBXSubDeformerNode>} DeformerNodes
	 * @returns {{map: Map<number, {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}>, array: {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}[], skeleton: THREE.Skeleton|null}}
	 */
	function parseSkeleton( connections, DeformerNodes ) {

		var subDeformers = {};
		var children = connections.children;

		for ( var i = 0, l = children.length; i < l; ++ i ) {

			var child = children[ i ];

			var subDeformerNode = DeformerNodes[ child.ID ];

			var subDeformer = {
				FBX_ID: child.ID,
				index: i,
				indices: [],
				weights: [],
				transform: parseMatrixArray( subDeformerNode.subNodes.Transform.properties.a ),
				transformLink: parseMatrixArray( subDeformerNode.subNodes.TransformLink.properties.a ),
				linkMode: subDeformerNode.properties.Mode
			};

			if ( 'Indexes' in subDeformerNode.subNodes ) {

				subDeformer.indices = parseIntArray( subDeformerNode.subNodes.Indexes.properties.a );
				subDeformer.weights = parseFloatArray( subDeformerNode.subNodes.Weights.properties.a );

			}

			subDeformers[ child.ID ] = subDeformer;

		}

		return {
			map: subDeformers,
			bones: []
		};

	}

	/**
	 * Generates Buffer geometries from geometry information in FBXTree, and generates map of THREE.BufferGeometries
	 * @param {{Objects: {subNodes: {Geometry: Object.<number, FBXGeometryNode}}}} FBXTree
	 * @param {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>} connections
	 * @param {Map<number, {map: Map<number, {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}>, array: {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}[], skeleton: THREE.Skeleton|null}>} deformers
	 * @returns {Map<number, THREE.BufferGeometry>}
	 */
	function parseGeometries( FBXTree, connections, deformers ) {

		var geometryMap = new Map();

		if ( 'Geometry' in FBXTree.Objects.subNodes ) {

			var geometryNodes = FBXTree.Objects.subNodes.Geometry;

			for ( var nodeID in geometryNodes ) {

				var relationships = connections.get( parseInt( nodeID ) );
				var geo = parseGeometry( geometryNodes[ nodeID ], relationships, deformers );
				geometryMap.set( parseInt( nodeID ), geo );

			}

		}

		return geometryMap;

	}

	/**
	 * Generates BufferGeometry from FBXGeometryNode.
	 * @param {FBXGeometryNode} geometryNode
	 * @param {{parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}} relationships
	 * @param {Map<number, {map: Map<number, {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}>, array: {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}[]}>} deformers
	 * @returns {THREE.BufferGeometry}
	 */
	function parseGeometry( geometryNode, relationships, deformers ) {

		switch ( geometryNode.attrType ) {

			case 'Mesh':
				return parseMeshGeometry( geometryNode, relationships, deformers );
				break;

			case 'NurbsCurve':
				return parseNurbsGeometry( geometryNode );
				break;

		}

	}

	/**
	 * Specialty function for parsing Mesh based Geometry Nodes.
	 * @param {FBXGeometryNode} geometryNode
	 * @param {{parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}} relationships - Object representing relationships between specific geometry node and other nodes.
	 * @param {Map<number, {map: Map<number, {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}>, array: {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}[]}>} deformers - Map object of deformers and subDeformers by ID.
	 * @returns {THREE.BufferGeometry}
	 */
	function parseMeshGeometry( geometryNode, relationships, deformers ) {

		for ( var i = 0; i < relationships.children.length; ++ i ) {

			var deformer = deformers[ relationships.children[ i ].ID ];
			if ( deformer !== undefined ) break;

		}

		return genGeometry( geometryNode, deformer );

	}

	/**
	 * @param {{map: Map<number, {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}>, array: {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}[]}} deformer - Skeleton representation for geometry instance.
	 * @returns {THREE.BufferGeometry}
	 */
	function genGeometry( geometryNode, deformer ) {

		var geometry = new Geometry();

		var subNodes = geometryNode.subNodes;

		// First, each index is going to be its own vertex.

		var vertexBuffer = parseFloatArray( subNodes.Vertices.properties.a );
		var indexBuffer = parseIntArray( subNodes.PolygonVertexIndex.properties.a );

		if ( subNodes.LayerElementNormal ) {

			var normalInfo = getNormals( subNodes.LayerElementNormal[ 0 ] );

		}

		if ( subNodes.LayerElementUV ) {

			var uvInfo = getUVs( subNodes.LayerElementUV[ 0 ] );

		}

		if ( subNodes.LayerElementColor ) {

			var colorInfo = getColors( subNodes.LayerElementColor[ 0 ] );

		}

		if ( subNodes.LayerElementMaterial ) {

			var materialInfo = getMaterials( subNodes.LayerElementMaterial[ 0 ] );

		}

		var weightTable = {};

		if ( deformer ) {

			var subDeformers = deformer.map;

			for ( var key in subDeformers ) {

				var subDeformer = subDeformers[ key ];
				var indices = subDeformer.indices;

				for ( var j = 0; j < indices.length; j ++ ) {

					var index = indices[ j ];
					var weight = subDeformer.weights[ j ];

					if ( weightTable[ index ] === undefined ) weightTable[ index ] = [];

					weightTable[ index ].push( {
						id: subDeformer.index,
						weight: weight
					} );

				}

			}

		}

		var faceVertexBuffer = [];
		var polygonIndex = 0;
		var displayedWeightsWarning = false;

		for ( var polygonVertexIndex = 0; polygonVertexIndex < indexBuffer.length; polygonVertexIndex ++ ) {

			var vertexIndex = indexBuffer[ polygonVertexIndex ];

			var endOfFace = false;

			if ( vertexIndex < 0 ) {

				vertexIndex = vertexIndex ^ - 1;
				indexBuffer[ polygonVertexIndex ] = vertexIndex;
				endOfFace = true;

			}

			var vertex = new Vertex();
			var weightIndices = [];
			var weights = [];

			vertex.position.fromArray( vertexBuffer, vertexIndex * 3 );

			if ( deformer ) {

				if ( weightTable[ vertexIndex ] !== undefined ) {

					var array = weightTable[ vertexIndex ];

					for ( var j = 0, jl = array.length; j < jl; j ++ ) {

						weights.push( array[ j ].weight );
						weightIndices.push( array[ j ].id );

					}

				}

				if ( weights.length > 4 ) {

					if ( ! displayedWeightsWarning ) {

						console.warn( 'FBXLoader: Vertex has more than 4 skinning weights assigned to vertex.  Deleting additional weights.' );
						displayedWeightsWarning = true;

					}

					var WIndex = [ 0, 0, 0, 0 ];
					var Weight = [ 0, 0, 0, 0 ];

					weights.forEach( function ( weight, weightIndex ) {

						var currentWeight = weight;
						var currentIndex = weightIndices[ weightIndex ];

						Weight.forEach( function ( comparedWeight, comparedWeightIndex, comparedWeightArray ) {

							if ( currentWeight > comparedWeight ) {

								comparedWeightArray[ comparedWeightIndex ] = currentWeight;
								currentWeight = comparedWeight;

								var tmp = WIndex[ comparedWeightIndex ];
								WIndex[ comparedWeightIndex ] = currentIndex;
								currentIndex = tmp;

							}

						} );

					} );

					weightIndices = WIndex;
					weights = Weight;

				}

				for ( var i = weights.length; i < 4; ++ i ) {

					weights[ i ] = 0;
					weightIndices[ i ] = 0;

				}

				vertex.skinWeights.fromArray( weights );
				vertex.skinIndices.fromArray( weightIndices );

			}

			if ( normalInfo ) {

				vertex.normal.fromArray( getData( polygonVertexIndex, polygonIndex, vertexIndex, normalInfo ) );

			}

			if ( uvInfo ) {

				vertex.uv.fromArray( getData( polygonVertexIndex, polygonIndex, vertexIndex, uvInfo ) );

			}

			if ( colorInfo ) {

				vertex.color.fromArray( getData( polygonVertexIndex, polygonIndex, vertexIndex, colorInfo ) );

			}

			faceVertexBuffer.push( vertex );

			if ( endOfFace ) {

				var face = new Face();
				face.genTrianglesFromVertices( faceVertexBuffer );

				if ( materialInfo !== undefined ) {

					var materials = getData( polygonVertexIndex, polygonIndex, vertexIndex, materialInfo );
					face.materialIndex = materials[ 0 ];

				} else {

					// Seems like some models don't have materialInfo(subNodes.LayerElementMaterial).
					// Set 0 in such a case.
					face.materialIndex = 0;

				}

				geometry.faces.push( face );
				faceVertexBuffer = [];
				polygonIndex ++;

				endOfFace = false;

			}

		}

		/**
		 * @type {{vertexBuffer: number[], normalBuffer: number[], uvBuffer: number[], skinIndexBuffer: number[], skinWeightBuffer: number[], materialIndexBuffer: number[]}}
		 */
		var bufferInfo = geometry.flattenToBuffers();

		var geo = new THREE.BufferGeometry();
		geo.name = geometryNode.name;
		geo.addAttribute( 'position', new THREE.Float32BufferAttribute( bufferInfo.vertexBuffer, 3 ) );

		if ( bufferInfo.normalBuffer.length > 0 ) {

			geo.addAttribute( 'normal', new THREE.Float32BufferAttribute( bufferInfo.normalBuffer, 3 ) );

		}
		if ( bufferInfo.uvBuffer.length > 0 ) {

			geo.addAttribute( 'uv', new THREE.Float32BufferAttribute( bufferInfo.uvBuffer, 2 ) );

		}
		if ( subNodes.LayerElementColor ) {

			geo.addAttribute( 'color', new THREE.Float32BufferAttribute( bufferInfo.colorBuffer, 3 ) );

		}

		if ( deformer ) {

			geo.addAttribute( 'skinIndex', new THREE.Float32BufferAttribute( bufferInfo.skinIndexBuffer, 4 ) );

			geo.addAttribute( 'skinWeight', new THREE.Float32BufferAttribute( bufferInfo.skinWeightBuffer, 4 ) );

			geo.FBX_Deformer = deformer;

		}

		// Convert the material indices of each vertex into rendering groups on the geometry.

		var materialIndexBuffer = bufferInfo.materialIndexBuffer;
		var prevMaterialIndex = materialIndexBuffer[ 0 ];
		var startIndex = 0;

		for ( var i = 0; i < materialIndexBuffer.length; ++ i ) {

			if ( materialIndexBuffer[ i ] !== prevMaterialIndex ) {

				geo.addGroup( startIndex, i - startIndex, prevMaterialIndex );

				prevMaterialIndex = materialIndexBuffer[ i ];
				startIndex = i;

			}

		}

		return geo;

	}

	/**
	 * Parses normal information for geometry.
	 * @param {FBXGeometryNode} geometryNode
	 * @returns {{dataSize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}}
	 */
	function getNormals( NormalNode ) {

		var mappingType = NormalNode.properties.MappingInformationType;
		var referenceType = NormalNode.properties.ReferenceInformationType;
		var buffer = parseFloatArray( NormalNode.subNodes.Normals.properties.a );
		var indexBuffer = [];
		if ( referenceType === 'IndexToDirect' ) {

			if ( 'NormalIndex' in NormalNode.subNodes ) {

				indexBuffer = parseIntArray( NormalNode.subNodes.NormalIndex.properties.a );

			} else if ( 'NormalsIndex' in NormalNode.subNodes ) {

				indexBuffer = parseIntArray( NormalNode.subNodes.NormalsIndex.properties.a );

			}

		}

		return {
			dataSize: 3,
			buffer: buffer,
			indices: indexBuffer,
			mappingType: mappingType,
			referenceType: referenceType
		};

	}

	/**
	 * Parses UV information for geometry.
	 * @param {FBXGeometryNode} geometryNode
	 * @returns {{dataSize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}}
	 */
	function getUVs( UVNode ) {

		var mappingType = UVNode.properties.MappingInformationType;
		var referenceType = UVNode.properties.ReferenceInformationType;
		var buffer = parseFloatArray( UVNode.subNodes.UV.properties.a );
		var indexBuffer = [];
		if ( referenceType === 'IndexToDirect' ) {

			indexBuffer = parseIntArray( UVNode.subNodes.UVIndex.properties.a );

		}

		return {
			dataSize: 2,
			buffer: buffer,
			indices: indexBuffer,
			mappingType: mappingType,
			referenceType: referenceType
		};

	}

	/**
	 * Parses Vertex Color information for geometry.
	 * @param {FBXGeometryNode} geometryNode
	 * @returns {{dataSize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}}
	 */
	function getColors( ColorNode ) {

		var mappingType = ColorNode.properties.MappingInformationType;
		var referenceType = ColorNode.properties.ReferenceInformationType;
		var buffer = parseFloatArray( ColorNode.subNodes.Colors.properties.a );
		var indexBuffer = [];
		if ( referenceType === 'IndexToDirect' ) {

			indexBuffer = parseFloatArray( ColorNode.subNodes.ColorIndex.properties.a );

		}

		return {
			dataSize: 4,
			buffer: buffer,
			indices: indexBuffer,
			mappingType: mappingType,
			referenceType: referenceType
		};

	}

	/**
	 * Parses material application information for geometry.
	 * @param {FBXGeometryNode}
	 * @returns {{dataSize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}}
	 */
	function getMaterials( MaterialNode ) {

		var mappingType = MaterialNode.properties.MappingInformationType;
		var referenceType = MaterialNode.properties.ReferenceInformationType;

		if ( mappingType === 'NoMappingInformation' ) {

			return {
				dataSize: 1,
				buffer: [ 0 ],
				indices: [ 0 ],
				mappingType: 'AllSame',
				referenceType: referenceType
			};

		}

		var materialIndexBuffer = parseIntArray( MaterialNode.subNodes.Materials.properties.a );

		// Since materials are stored as indices, there's a bit of a mismatch between FBX and what
		// we expect.  So we create an intermediate buffer that points to the index in the buffer,
		// for conforming with the other functions we've written for other data.
		var materialIndices = [];

		for ( var materialIndexBufferIndex = 0, materialIndexBufferLength = materialIndexBuffer.length; materialIndexBufferIndex < materialIndexBufferLength; ++ materialIndexBufferIndex ) {

			materialIndices.push( materialIndexBufferIndex );

		}

		return {
			dataSize: 1,
			buffer: materialIndexBuffer,
			indices: materialIndices,
			mappingType: mappingType,
			referenceType: referenceType
		};

	}

	/**
	 * Function uses the infoObject and given indices to return value array of object.
	 * @param {number} polygonVertexIndex - Index of vertex in draw order (which index of the index buffer refers to this vertex).
	 * @param {number} polygonIndex - Index of polygon in geometry.
	 * @param {number} vertexIndex - Index of vertex inside vertex buffer (used because some data refers to old index buffer that we don't use anymore).
	 * @param {{datasize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}} infoObject - Object containing data and how to access data.
	 * @returns {number[]}
	 */

	var dataArray = [];

	var GetData = {

		ByPolygonVertex: {

			/**
			 * Function uses the infoObject and given indices to return value array of object.
			 * @param {number} polygonVertexIndex - Index of vertex in draw order (which index of the index buffer refers to this vertex).
			 * @param {number} polygonIndex - Index of polygon in geometry.
			 * @param {number} vertexIndex - Index of vertex inside vertex buffer (used because some data refers to old index buffer that we don't use anymore).
			 * @param {{datasize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}} infoObject - Object containing data and how to access data.
			 * @returns {number[]}
			 */
			Direct: function ( polygonVertexIndex, polygonIndex, vertexIndex, infoObject ) {

				var from = ( polygonVertexIndex * infoObject.dataSize );
				var to = ( polygonVertexIndex * infoObject.dataSize ) + infoObject.dataSize;

				// return infoObject.buffer.slice( from, to );
				return slice( dataArray, infoObject.buffer, from, to );

			},

			/**
			 * Function uses the infoObject and given indices to return value array of object.
			 * @param {number} polygonVertexIndex - Index of vertex in draw order (which index of the index buffer refers to this vertex).
			 * @param {number} polygonIndex - Index of polygon in geometry.
			 * @param {number} vertexIndex - Index of vertex inside vertex buffer (used because some data refers to old index buffer that we don't use anymore).
			 * @param {{datasize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}} infoObject - Object containing data and how to access data.
			 * @returns {number[]}
			 */
			IndexToDirect: function ( polygonVertexIndex, polygonIndex, vertexIndex, infoObject ) {

				var index = infoObject.indices[ polygonVertexIndex ];
				var from = ( index * infoObject.dataSize );
				var to = ( index * infoObject.dataSize ) + infoObject.dataSize;

				// return infoObject.buffer.slice( from, to );
				return slice( dataArray, infoObject.buffer, from, to );

			}

		},

		ByPolygon: {

			/**
			 * Function uses the infoObject and given indices to return value array of object.
			 * @param {number} polygonVertexIndex - Index of vertex in draw order (which index of the index buffer refers to this vertex).
			 * @param {number} polygonIndex - Index of polygon in geometry.
			 * @param {number} vertexIndex - Index of vertex inside vertex buffer (used because some data refers to old index buffer that we don't use anymore).
			 * @param {{datasize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}} infoObject - Object containing data and how to access data.
			 * @returns {number[]}
			 */
			Direct: function ( polygonVertexIndex, polygonIndex, vertexIndex, infoObject ) {

				var from = polygonIndex * infoObject.dataSize;
				var to = polygonIndex * infoObject.dataSize + infoObject.dataSize;

				// return infoObject.buffer.slice( from, to );
				return slice( dataArray, infoObject.buffer, from, to );

			},

			/**
			 * Function uses the infoObject and given indices to return value array of object.
			 * @param {number} polygonVertexIndex - Index of vertex in draw order (which index of the index buffer refers to this vertex).
			 * @param {number} polygonIndex - Index of polygon in geometry.
			 * @param {number} vertexIndex - Index of vertex inside vertex buffer (used because some data refers to old index buffer that we don't use anymore).
			 * @param {{datasize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}} infoObject - Object containing data and how to access data.
			 * @returns {number[]}
			 */
			IndexToDirect: function ( polygonVertexIndex, polygonIndex, vertexIndex, infoObject ) {

				var index = infoObject.indices[ polygonIndex ];
				var from = index * infoObject.dataSize;
				var to = index * infoObject.dataSize + infoObject.dataSize;

				// return infoObject.buffer.slice( from, to );
				return slice( dataArray, infoObject.buffer, from, to );

			}

		},

		ByVertice: {

			Direct: function ( polygonVertexIndex, polygonIndex, vertexIndex, infoObject ) {

				var from = ( vertexIndex * infoObject.dataSize );
				var to = ( vertexIndex * infoObject.dataSize ) + infoObject.dataSize;

				// return infoObject.buffer.slice( from, to );
				return slice( dataArray, infoObject.buffer, from, to );

			}

		},

		AllSame: {

			/**
			 * Function uses the infoObject and given indices to return value array of object.
			 * @param {number} polygonVertexIndex - Index of vertex in draw order (which index of the index buffer refers to this vertex).
			 * @param {number} polygonIndex - Index of polygon in geometry.
			 * @param {number} vertexIndex - Index of vertex inside vertex buffer (used because some data refers to old index buffer that we don't use anymore).
			 * @param {{datasize: number, buffer: number[], indices: number[], mappingType: string, referenceType: string}} infoObject - Object containing data and how to access data.
			 * @returns {number[]}
			 */
			IndexToDirect: function ( polygonVertexIndex, polygonIndex, vertexIndex, infoObject ) {

				var from = infoObject.indices[ 0 ] * infoObject.dataSize;
				var to = infoObject.indices[ 0 ] * infoObject.dataSize + infoObject.dataSize;

				// return infoObject.buffer.slice( from, to );
				return slice( dataArray, infoObject.buffer, from, to );

			}

		}

	};

	function getData( polygonVertexIndex, polygonIndex, vertexIndex, infoObject ) {

		return GetData[ infoObject.mappingType ][ infoObject.referenceType ]( polygonVertexIndex, polygonIndex, vertexIndex, infoObject );

	}

	/**
	 * Specialty function for parsing NurbsCurve based Geometry Nodes.
	 * @param {FBXGeometryNode} geometryNode
	 * @param {{parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}} relationships
	 * @returns {THREE.BufferGeometry}
	 */
	function parseNurbsGeometry( geometryNode ) {

		if ( THREE.NURBSCurve === undefined ) {

			console.error( "THREE.FBXLoader relies on THREE.NURBSCurve for any nurbs present in the model.  Nurbs will show up as empty geometry." );
			return new THREE.BufferGeometry();

		}

		var order = parseInt( geometryNode.properties.Order );

		if ( isNaN( order ) ) {

			console.error( "FBXLoader: Invalid Order " + geometryNode.properties.Order + " given for geometry ID: " + geometryNode.id );
			return new THREE.BufferGeometry();

		}

		var degree = order - 1;

		var knots = parseFloatArray( geometryNode.subNodes.KnotVector.properties.a );
		var controlPoints = [];
		var pointsValues = parseFloatArray( geometryNode.subNodes.Points.properties.a );

		for ( var i = 0, l = pointsValues.length; i < l; i += 4 ) {

			controlPoints.push( new THREE.Vector4().fromArray( pointsValues, i ) );

		}

		var startKnot, endKnot;

		if ( geometryNode.properties.Form === 'Closed' ) {

			controlPoints.push( controlPoints[ 0 ] );

		} else if ( geometryNode.properties.Form === 'Periodic' ) {

			startKnot = degree;
			endKnot = knots.length - 1 - startKnot;

			for ( var i = 0; i < degree; ++ i ) {

				controlPoints.push( controlPoints[ i ] );

			}

		}

		var curve = new THREE.NURBSCurve( degree, knots, controlPoints, startKnot, endKnot );
		var vertices = curve.getPoints( controlPoints.length * 7 );

		var positions = new Float32Array( vertices.length * 3 );

		for ( var i = 0, l = vertices.length; i < l; ++ i ) {

			vertices[ i ].toArray( positions, i * 3 );

		}

		var geometry = new THREE.BufferGeometry();
		geometry.addAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );

		return geometry;

	}

	/**
	 * Finally generates Scene graph and Scene graph Objects.
	 * @param {{Objects: {subNodes: {Model: Object.<number, FBXModelNode>}}}} FBXTree
	 * @param {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>} connections
	 * @param {Map<number, {map: Map<number, {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}>, array: {FBX_ID: number, indices: number[], weights: number[], transform: number[], transformLink: number[], linkMode: string}[], skeleton: THREE.Skeleton|null}>} deformers
	 * @param {Map<number, THREE.BufferGeometry>} geometryMap
	 * @param {Map<number, THREE.Material>} materialMap
	 * @returns {THREE.Group}
	 */
	function parseScene( FBXTree, connections, deformers, geometryMap, materialMap ) {

		var sceneGraph = new THREE.Group();

		var ModelNode = FBXTree.Objects.subNodes.Model;

		/**
		 * @type {Array.<THREE.Object3D>}
		 */
		var modelArray = [];

		/**
		 * @type {Map.<number, THREE.Object3D>}
		 */
		var modelMap = new Map();

		for ( var nodeID in ModelNode ) {

			var id = parseInt( nodeID );
			var node = ModelNode[ nodeID ];
			var conns = connections.get( id );
			var model = null;

			for ( var i = 0; i < conns.parents.length; ++ i ) {

				for ( var FBX_ID in deformers ) {

					var deformer = deformers[ FBX_ID ];
					var subDeformers = deformer.map;
					var subDeformer = subDeformers[ conns.parents[ i ].ID ];

					if ( subDeformer ) {

						var model2 = model;
						model = new THREE.Bone();
						model.pdef=FBX_ID;
						deformer.bones[ subDeformer.index ] = model;

						// seems like we need this not to make non-connected bone, maybe?
						// TODO: confirm
						if ( model2 !== null ) model.add( model2 );

					}

				}

			}

			if ( ! model ) {

				switch ( node.attrType ) {

					case "Mesh":
						/**
						 * @type {?THREE.BufferGeometry}
						 */
						var geometry = null;

						/**
						 * @type {THREE.MultiMaterial|THREE.Material}
						 */
						var material = null;

						/**
						 * @type {Array.<THREE.Material>}
						 */
						var materials = [];

						for ( var childrenIndex = 0, childrenLength = conns.children.length; childrenIndex < childrenLength; ++ childrenIndex ) {

							var child = conns.children[ childrenIndex ];

							if ( geometryMap.has( child.ID ) ) {

								geometry = geometryMap.get( child.ID );

							}

							if ( materialMap.has( child.ID ) ) {

								materials.push( materialMap.get( child.ID ) );

							}

						}
						if ( materials.length > 1 ) {

							material = materials;

						} else if ( materials.length > 0 ) {

							material = materials[ 0 ];

						} else {

							material = new THREE.MeshBasicMaterial( { color: 0x3300ff } );
							materials.push( material );

						}
						if ( 'color' in geometry.attributes ) {

							for ( var materialIndex = 0, numMaterials = materials.length; materialIndex < numMaterials; ++materialIndex ) {

								materials[ materialIndex ].vertexColors = THREE.VertexColors;

							}

						}
						if ( geometry.FBX_Deformer ) {

							for ( var materialsIndex = 0, materialsLength = materials.length; materialsIndex < materialsLength; ++ materialsIndex ) {

								materials[ materialsIndex ].skinning = true;

							}
							model = new THREE.SkinnedMesh( geometry, material );

						} else {

							model = new THREE.Mesh( geometry, material );

						}
						break;

					case "NurbsCurve":
						var geometry = null;

						for ( var childrenIndex = 0, childrenLength = conns.children.length; childrenIndex < childrenLength; ++ childrenIndex ) {

							var child = conns.children[ childrenIndex ];

							if ( geometryMap.has( child.ID ) ) {

								geometry = geometryMap.get( child.ID );

							}

						}

						// FBX does not list materials for Nurbs lines, so we'll just put our own in here.
						material = new THREE.LineBasicMaterial( { color: 0x3300ff, linewidth: 5 } );
						model = new THREE.Line( geometry, material );
						break;
/*
					case "Camera":
						var fov = 50;
						var aspect = window.width/window.height;
						var near = 1;
						var far = 1000;
						model = new THREE.PerspectiveCamera( fov, aspect, near, far )

						debugger;
						break;
					case "Light":
*/
					case "Null":
						console.log("object of type",node.attrType,"loaded as Object3D");

					default:
						model = new THREE.Object3D();
						break;

				}

			}

			model.name = node.attrName.replace( /:/, '' ).replace( /_/, '' ).replace( /-/, '' );
			model.FBX_ID = id;

			modelArray.push( model );
			modelMap.set( id, model );

		}

		for ( var modelArrayIndex = 0, modelArrayLength = modelArray.length; modelArrayIndex < modelArrayLength; ++ modelArrayIndex ) {

			var model = modelArray[ modelArrayIndex ];

			var node = ModelNode[ model.FBX_ID ];

			if ( 'Lcl_Translation' in node.properties ) {

				model.position.fromArray( parseFloatArray( node.properties.Lcl_Translation.value ) );

			}

			if ( 'Lcl_Rotation' in node.properties ) {

				var rotation = parseFloatArray( node.properties.Lcl_Rotation.value ).map( degreeToRadian );
				rotation.push( 'ZYX' );
				model.rotation.fromArray( rotation );

			}

			if ( 'Lcl_Scaling' in node.properties ) {

				model.scale.fromArray( parseFloatArray( node.properties.Lcl_Scaling.value ) );

			}

			if ( 'PreRotation' in node.properties ) {

				var preRotations = new THREE.Euler().setFromVector3( parseVector3( node.properties.PreRotation ).multiplyScalar( DEG2RAD ), 'ZYX' );
				preRotations = new THREE.Quaternion().setFromEuler( preRotations );
				var currentRotation = new THREE.Quaternion().setFromEuler( model.rotation );
				preRotations.multiply( currentRotation );
				model.rotation.setFromQuaternion( preRotations, 'ZYX' );

			}

			var conns = connections.get( model.FBX_ID );
			for ( var parentIndex = 0; parentIndex < conns.parents.length; parentIndex ++ ) {

				var pIndex = findIndex( modelArray, function ( mod ) {

					return mod.FBX_ID === conns.parents[ parentIndex ].ID;

				} );
				if ( pIndex > - 1 ) {

					modelArray[ pIndex ].add( model );
					break;

				}

			}
			if ( model.parent === null ) {

				sceneGraph.add( model );

			}

		}


		// Now with the bones created, we can update the skeletons and bind them to the skinned meshes.
		sceneGraph.updateMatrixWorld( true );

		// Put skeleton into bind pose.
		var BindPoseNode = FBXTree.Objects.subNodes.Pose;
		for ( var nodeID in BindPoseNode ) {

			if ( BindPoseNode[ nodeID ].attrType === 'BindPose' ) {

				BindPoseNode = BindPoseNode[ nodeID ];
				break;

			}

		}
		if ( BindPoseNode ) {

			var PoseNode = BindPoseNode.subNodes.PoseNode;
			var worldMatrices = new Map();

			for ( var PoseNodeIndex = 0, PoseNodeLength = PoseNode.length; PoseNodeIndex < PoseNodeLength; ++ PoseNodeIndex ) {

				var node = PoseNode[ PoseNodeIndex ];

				var rawMatWrd = parseMatrixArray( node.subNodes.Matrix.properties.a );

				worldMatrices.set( parseInt( node.id ), rawMatWrd );

			}

		}else var worldMatrices = new Map();

		for ( var FBX_ID in deformers ) {

			var deformer = deformers[ FBX_ID ];
			var subDeformers = deformer.map;

			for ( var key in subDeformers ) {

				var subDeformer = subDeformers[ key ];
				var subDeformerIndex = subDeformer.index;

				/**
				 * @type {THREE.Bone}
				 */
				var bone = deformer.bones[ subDeformerIndex ];
				if ( ! worldMatrices.has( bone.FBX_ID ) ) {

					break;

				}
				var mat = worldMatrices.get( bone.FBX_ID );
				bone.matrixWorld.copy( mat );

			}

			// Now that skeleton is in bind pose, bind to model.
			deformer.skeleton = new THREE.Skeleton( deformer.bones );

			var conns = connections.get( deformer.FBX_ID );
			var parents = conns.parents;

			for ( var parentsIndex = 0, parentsLength = parents.length; parentsIndex < parentsLength; ++ parentsIndex ) {

				var parent = parents[ parentsIndex ];

				if ( geometryMap.has( parent.ID ) ) {

					var geoID = parent.ID;
					var geoConns = connections.get( geoID );

					for ( var i = 0; i < geoConns.parents.length; ++ i ) {

						if ( modelMap.has( geoConns.parents[ i ].ID ) ) {

							var model = modelMap.get( geoConns.parents[ i ].ID );
							//ASSERT model typeof SkinnedMesh
							model.bind( deformer.skeleton, model.matrixWorld );
							break;

						}

					}

				}

			}

		}

		//Skeleton is now bound, return objects to starting
		//world positions.
		sceneGraph.updateMatrixWorld( true );

		// Silly hack with the animation parsing.  We're gonna pretend the scene graph has a skeleton
		// to attach animations to, since FBXs treat animations as animations for the entire scene,
		// not just for individual objects.
		sceneGraph.skeleton = {
			bones: modelArray
		};

		var animations = parseAnimations( FBXTree, connections, sceneGraph );

		addAnimations( sceneGraph, animations );

		return sceneGraph;

	}

	/**
	 * Parses animation information from FBXTree and generates an AnimationInfoObject.
	 * @param {{Objects: {subNodes: {AnimationCurveNode: any, AnimationCurve: any, AnimationLayer: any, AnimationStack: any}}}} FBXTree
	 * @param {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>} connections
	 */
	function parseAnimations( FBXTree, connections, sceneGraph ) {

		var rawNodes = FBXTree.Objects.subNodes.AnimationCurveNode;
		var rawCurves = FBXTree.Objects.subNodes.AnimationCurve;
		var rawLayers = FBXTree.Objects.subNodes.AnimationLayer;
		var rawStacks = FBXTree.Objects.subNodes.AnimationStack;

		/**
		 * @type {{
				 curves: Map<number, {
				 T: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					};
				},
				 R: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					};
				},
				 S: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					};
				}
			 }>,
			 layers: Map<number, {
				T: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					},
				},
				R: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					},
				},
				S: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					},
				}
				}[]>,
			 stacks: Map<number, {
				 name: string,
				 layers: {
					T: {
						id: number;
						attr: string;
						internalID: number;
						attrX: boolean;
						attrY: boolean;
						attrZ: boolean;
						containerBoneID: number;
						containerID: number;
						curves: {
							x: {
								version: any;
								id: number;
								internalID: number;
								times: number[];
								values: number[];
								attrFlag: number[];
								attrData: number[];
							};
							y: {
								version: any;
								id: number;
								internalID: number;
								times: number[];
								values: number[];
								attrFlag: number[];
								attrData: number[];
							};
							z: {
								version: any;
								id: number;
								internalID: number;
								times: number[];
								values: number[];
								attrFlag: number[];
								attrData: number[];
							};
						};
					};
					R: {
						id: number;
						attr: string;
						internalID: number;
						attrX: boolean;
						attrY: boolean;
						attrZ: boolean;
						containerBoneID: number;
						containerID: number;
						curves: {
							x: {
								version: any;
								id: number;
								internalID: number;
								times: number[];
								values: number[];
								attrFlag: number[];
								attrData: number[];
							};
							y: {
								version: any;
								id: number;
								internalID: number;
								times: number[];
								values: number[];
								attrFlag: number[];
								attrData: number[];
							};
							z: {
								version: any;
								id: number;
								internalID: number;
								times: number[];
								values: number[];
								attrFlag: number[];
								attrData: number[];
							};
						};
					};
					S: {
						id: number;
						attr: string;
						internalID: number;
						attrX: boolean;
						attrY: boolean;
						attrZ: boolean;
						containerBoneID: number;
						containerID: number;
						curves: {
							x: {
								version: any;
								id: number;
								internalID: number;
								times: number[];
								values: number[];
								attrFlag: number[];
								attrData: number[];
							};
							y: {
								version: any;
								id: number;
								internalID: number;
								times: number[];
								values: number[];
								attrFlag: number[];
								attrData: number[];
							};
							z: {
								version: any;
								id: number;
								internalID: number;
								times: number[];
								values: number[];
								attrFlag: number[];
								attrData: number[];
							};
						};
					};
				}[][],
			 length: number,
			 frames: number }>,
			 length: number,
			 fps: number,
			 frames: number
		 }}
		 */
		var returnObject = {
			curves: new Map(),
			layers: {},
			stacks: {},
			length: 0,
			fps: 30,
			frames: 0
		};

		/**
		 * @type {Array.<{
				id: number;
				attr: string;
				internalID: number;
				attrX: boolean;
				attrY: boolean;
				attrZ: boolean;
				containerBoneID: number;
				containerID: number;
			}>}
		 */
		var animationCurveNodes = [];
		for ( var nodeID in rawNodes ) {

			if ( nodeID.match( /\d+/ ) ) {

				var animationNode = parseAnimationNode( FBXTree, rawNodes[ nodeID ], connections, sceneGraph );
				animationCurveNodes.push( animationNode );

			}

		}

		/**
		 * @type {Map.<number, {
				id: number,
				attr: string,
				internalID: number,
				attrX: boolean,
				attrY: boolean,
				attrZ: boolean,
				containerBoneID: number,
				containerID: number,
				curves: {
					x: {
						version: any,
						id: number,
						internalID: number,
						times: number[],
						values: number[],
						attrFlag: number[],
						attrData: number[],
					},
					y: {
						version: any,
						id: number,
						internalID: number,
						times: number[],
						values: number[],
						attrFlag: number[],
						attrData: number[],
					},
					z: {
						version: any,
						id: number,
						internalID: number,
						times: number[],
						values: number[],
						attrFlag: number[],
						attrData: number[],
					}
				}
			}>}
		 */
		var tmpMap = new Map();
		for ( var animationCurveNodeIndex = 0; animationCurveNodeIndex < animationCurveNodes.length; ++ animationCurveNodeIndex ) {

			if ( animationCurveNodes[ animationCurveNodeIndex ] === null ) {

				continue;

			}
			tmpMap.set( animationCurveNodes[ animationCurveNodeIndex ].id, animationCurveNodes[ animationCurveNodeIndex ] );

		}


		/**
		 * @type {{
				version: any,
				id: number,
				internalID: number,
				times: number[],
				values: number[],
				attrFlag: number[],
				attrData: number[],
			}[]}
		 */
		var animationCurves = [];
		for ( nodeID in rawCurves ) {

			if ( nodeID.match( /\d+/ ) ) {

				var animationCurve = parseAnimationCurve( rawCurves[ nodeID ] );

				// seems like this check would be necessary?
				if ( ! connections.has( animationCurve.id ) ) continue;

				animationCurves.push( animationCurve );

				var firstParentConn = connections.get( animationCurve.id ).parents[ 0 ];
				var firstParentID = firstParentConn.ID;
				var firstParentRelationship = firstParentConn.relationship;
				var axis = '';

				if ( firstParentRelationship.match( /X/ ) ) {

					axis = 'x';

				} else if ( firstParentRelationship.match( /Y/ ) ) {

					axis = 'y';

				} else if ( firstParentRelationship.match( /Z/ ) ) {

					axis = 'z';

				} else {

					continue;

				}

				tmpMap.get( firstParentID ).curves[ axis ] = animationCurve;

			}

		}

		tmpMap.forEach( function ( curveNode ) {

			var id = curveNode.containerBoneID;
			if ( ! returnObject.curves.has( id ) ) {

				returnObject.curves.set( id, { T: null, R: null, S: null } );

			}
			returnObject.curves.get( id )[ curveNode.attr ] = curveNode;
			if ( curveNode.attr === 'R' ) {

				var curves = curveNode.curves;

				// Seems like some FBX files have AnimationCurveNode
				// which doesn't have any connected AnimationCurve.
				// Setting animation parameter for them here.

				if ( curves.x === null ) {

					curves.x = {
						version: null,
						times: [ 0.0 ],
						values: [ 0.0 ]
					};

				}

				if ( curves.y === null ) {

					curves.y = {
						version: null,
						times: [ 0.0 ],
						values: [ 0.0 ]
					};

				}

				if ( curves.z === null ) {

					curves.z = {
						version: null,
						times: [ 0.0 ],
						values: [ 0.0 ]
					};

				}

				curves.x.values = curves.x.values.map( degreeToRadian );
				curves.y.values = curves.y.values.map( degreeToRadian );
				curves.z.values = curves.z.values.map( degreeToRadian );

				if ( curveNode.preRotations !== null ) {

					var preRotations = new THREE.Euler().setFromVector3( curveNode.preRotations, 'ZYX' );
					preRotations = new THREE.Quaternion().setFromEuler( preRotations );
					var frameRotation = new THREE.Euler();
					var frameRotationQuaternion = new THREE.Quaternion();
					for ( var frame = 0; frame < curves.x.times.length; ++ frame ) {

						frameRotation.set( curves.x.values[ frame ], curves.y.values[ frame ], curves.z.values[ frame ], 'ZYX' );
						frameRotationQuaternion.setFromEuler( frameRotation ).premultiply( preRotations );
						frameRotation.setFromQuaternion( frameRotationQuaternion, 'ZYX' );
						curves.x.values[ frame ] = frameRotation.x;
						curves.y.values[ frame ] = frameRotation.y;
						curves.z.values[ frame ] = frameRotation.z;

					}

				}

			}

		} );

		for ( var nodeID in rawLayers ) {

			/**
			 * @type {{
				T: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					},
				},
				R: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					},
				},
				S: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					},
				}
				}[]}
			 */
			var layer = [];
			var children = connections.get( parseInt( nodeID ) ).children;

			for ( var childIndex = 0; childIndex < children.length; childIndex ++ ) {

				// Skip lockInfluenceWeights
				if ( tmpMap.has( children[ childIndex ].ID ) ) {

					var curveNode = tmpMap.get( children[ childIndex ].ID );
					var boneID = curveNode.containerBoneID;
					if ( layer[ boneID ] === undefined ) {

						layer[ boneID ] = {
							T: null,
							R: null,
							S: null
						};

					}

					layer[ boneID ][ curveNode.attr ] = curveNode;

				}

			}

			returnObject.layers[ nodeID ] = layer;

		}

		for ( var nodeID in rawStacks ) {

			var layers = [];
			var children = connections.get( parseInt( nodeID ) ).children;
			var timestamps = { max: 0, min: Number.MAX_VALUE };

			for ( var childIndex = 0; childIndex < children.length; ++ childIndex ) {

				var currentLayer = returnObject.layers[ children[ childIndex ].ID ];

				if ( currentLayer !== undefined ) {

					layers.push( currentLayer );

					for ( var currentLayerIndex = 0, currentLayerLength = currentLayer.length; currentLayerIndex < currentLayerLength; ++ currentLayerIndex ) {

						var layer = currentLayer[ currentLayerIndex ];

						if ( layer ) {

							getCurveNodeMaxMinTimeStamps( layer, timestamps );

						}

					}

				}

			}

			// Do we have an animation clip with actual length?
			if ( timestamps.max > timestamps.min ) {

				returnObject.stacks[ nodeID ] = {
					name: rawStacks[ nodeID ].attrName,
					layers: layers,
					length: timestamps.max - timestamps.min,
					frames: ( timestamps.max - timestamps.min ) * 30
				};

			}

		}

		return returnObject;

	}

	/**
	 * @param {Object} FBXTree
	 * @param {{id: number, attrName: string, properties: Object<string, any>}} animationCurveNode
	 * @param {Map<number, {parents: {ID: number, relationship: string}[], children: {ID: number, relationship: string}[]}>} connections
	 * @param {{skeleton: {bones: {FBX_ID: number}[]}}} sceneGraph
	 */
	function parseAnimationNode( FBXTree, animationCurveNode, connections, sceneGraph ) {

		var rawModels = FBXTree.Objects.subNodes.Model;

		var returnObject = {
			/**
			 * @type {number}
			 */
			id: animationCurveNode.id,

			/**
			 * @type {string}
			 */
			attr: animationCurveNode.attrName,

			/**
			 * @type {number}
			 */
			internalID: animationCurveNode.id,

			/**
			 * @type {boolean}
			 */
			attrX: false,

			/**
			 * @type {boolean}
			 */
			attrY: false,

			/**
			 * @type {boolean}
			 */
			attrZ: false,

			/**
			 * @type {number}
			 */
			containerBoneID: - 1,

			/**
			 * @type {number}
			 */
			containerID: - 1,

			curves: {
				x: null,
				y: null,
				z: null
			},

			/**
			 * @type {number[]}
			 */
			preRotations: null
		};

		if ( returnObject.attr.match( /S|R|T/ ) ) {

			for ( var attributeKey in animationCurveNode.properties ) {

				if ( attributeKey.match( /X/ ) ) {

					returnObject.attrX = true;

				}
				if ( attributeKey.match( /Y/ ) ) {

					returnObject.attrY = true;

				}
				if ( attributeKey.match( /Z/ ) ) {

					returnObject.attrZ = true;

				}

			}

		} else {

			return null;

		}

		var conns = connections.get( returnObject.id );
		var containerIndices = conns.parents;

		for ( var containerIndicesIndex = containerIndices.length - 1; containerIndicesIndex >= 0; -- containerIndicesIndex ) {

			var boneID = findIndex( sceneGraph.skeleton.bones, function ( bone ) {

				return bone.FBX_ID === containerIndices[ containerIndicesIndex ].ID;

			} );
			if ( boneID > - 1 ) {

				returnObject.containerBoneID = boneID;
				returnObject.containerID = containerIndices[ containerIndicesIndex ].ID;
				var model = rawModels[ returnObject.containerID.toString() ];
				if ( 'PreRotation' in model.properties ) {

					returnObject.preRotations = parseVector3( model.properties.PreRotation ).multiplyScalar( Math.PI / 180 );

				}
				break;

			}

		}

		return returnObject;

	}

	/**
	 * @param {{id: number, subNodes: {KeyTime: {properties: {a: string}}, KeyValueFloat: {properties: {a: string}}, KeyAttrFlags: {properties: {a: string}}, KeyAttrDataFloat: {properties: {a: string}}}}} animationCurve
	 */
	function parseAnimationCurve( animationCurve ) {

		return {
			version: null,
			id: animationCurve.id,
			internalID: animationCurve.id,
			times: parseFloatArray( animationCurve.subNodes.KeyTime.properties.a ).map( convertFBXTimeToSeconds ),
			values: parseFloatArray( animationCurve.subNodes.KeyValueFloat.properties.a ),

			attrFlag: parseIntArray( animationCurve.subNodes.KeyAttrFlags.properties.a ),
			attrData: parseFloatArray( animationCurve.subNodes.KeyAttrDataFloat.properties.a )
		};

	}

	/**
	 * Sets the maxTimeStamp and minTimeStamp variables if it has timeStamps that are either larger or smaller
	 * than the max or min respectively.
	 * @param {{
				T: {
						id: number,
						attr: string,
						internalID: number,
						attrX: boolean,
						attrY: boolean,
						attrZ: boolean,
						containerBoneID: number,
						containerID: number,
						curves: {
								x: {
										version: any,
										id: number,
										internalID: number,
										times: number[],
										values: number[],
										attrFlag: number[],
										attrData: number[],
								},
								y: {
										version: any,
										id: number,
										internalID: number,
										times: number[],
										values: number[],
										attrFlag: number[],
										attrData: number[],
								},
								z: {
										version: any,
										id: number,
										internalID: number,
										times: number[],
										values: number[],
										attrFlag: number[],
										attrData: number[],
								},
						},
				},
				R: {
						id: number,
						attr: string,
						internalID: number,
						attrX: boolean,
						attrY: boolean,
						attrZ: boolean,
						containerBoneID: number,
						containerID: number,
						curves: {
								x: {
										version: any,
										id: number,
										internalID: number,
										times: number[],
										values: number[],
										attrFlag: number[],
										attrData: number[],
								},
								y: {
										version: any,
										id: number,
										internalID: number,
										times: number[],
										values: number[],
										attrFlag: number[],
										attrData: number[],
								},
								z: {
										version: any,
										id: number,
										internalID: number,
										times: number[],
										values: number[],
										attrFlag: number[],
										attrData: number[],
								},
						},
				},
				S: {
						id: number,
						attr: string,
						internalID: number,
						attrX: boolean,
						attrY: boolean,
						attrZ: boolean,
						containerBoneID: number,
						containerID: number,
						curves: {
								x: {
										version: any,
										id: number,
										internalID: number,
										times: number[],
										values: number[],
										attrFlag: number[],
										attrData: number[],
								},
								y: {
										version: any,
										id: number,
										internalID: number,
										times: number[],
										values: number[],
										attrFlag: number[],
										attrData: number[],
								},
								z: {
										version: any,
										id: number,
										internalID: number,
										times: number[],
										values: number[],
										attrFlag: number[],
										attrData: number[],
								},
						},
				},
		}} layer
	 */
	function getCurveNodeMaxMinTimeStamps( layer, timestamps ) {

		if ( layer.R ) {

			getCurveMaxMinTimeStamp( layer.R.curves, timestamps );

		}
		if ( layer.S ) {

			getCurveMaxMinTimeStamp( layer.S.curves, timestamps );

		}
		if ( layer.T ) {

			getCurveMaxMinTimeStamp( layer.T.curves, timestamps );

		}

	}

	/**
	 * Sets the maxTimeStamp and minTimeStamp if one of the curve's time stamps
	 * exceeds the maximum or minimum.
	 * @param {{
				x: {
						version: any,
						id: number,
						internalID: number,
						times: number[],
						values: number[],
						attrFlag: number[],
						attrData: number[],
				},
				y: {
						version: any,
						id: number,
						internalID: number,
						times: number[],
						values: number[],
						attrFlag: number[],
						attrData: number[],
				},
				z: {
						version: any,
						id: number,
						internalID: number,
						times: number[],
						values: number[],
						attrFlag: number[],
						attrData: number[],
				}
		}} curve
	 */
	function getCurveMaxMinTimeStamp( curve, timestamps ) {

		if ( curve.x ) {

			getCurveAxisMaxMinTimeStamps( curve.x, timestamps );

		}
		if ( curve.y ) {

			getCurveAxisMaxMinTimeStamps( curve.y, timestamps );

		}
		if ( curve.z ) {

			getCurveAxisMaxMinTimeStamps( curve.z, timestamps );

		}

	}

	/**
	 * Sets the maxTimeStamp and minTimeStamp if one of its timestamps exceeds the maximum or minimum.
	 * @param {{times: number[]}} axis
	 */
	function getCurveAxisMaxMinTimeStamps( axis, timestamps ) {

		timestamps.max = axis.times[ axis.times.length - 1 ] > timestamps.max ? axis.times[ axis.times.length - 1 ] : timestamps.max;
		timestamps.min = axis.times[ 0 ] < timestamps.min ? axis.times[ 0 ] : timestamps.min;

	}

	/**
	 * @param {{
		curves: Map<number, {
			T: {
				id: number;
				attr: string;
				internalID: number;
				attrX: boolean;
				attrY: boolean;
				attrZ: boolean;
				containerBoneID: number;
				containerID: number;
				curves: {
					x: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					y: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					z: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
				};
			};
			R: {
				id: number;
				attr: string;
				internalID: number;
				attrX: boolean;
				attrY: boolean;
				attrZ: boolean;
				containerBoneID: number;
				containerID: number;
				curves: {
					x: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					y: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					z: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
				};
			};
			S: {
				id: number;
				attr: string;
				internalID: number;
				attrX: boolean;
				attrY: boolean;
				attrZ: boolean;
				containerBoneID: number;
				containerID: number;
				curves: {
					x: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					y: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					z: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
				};
			};
		}>;
		layers: Map<number, {
			T: {
				id: number;
				attr: string;
				internalID: number;
				attrX: boolean;
				attrY: boolean;
				attrZ: boolean;
				containerBoneID: number;
				containerID: number;
				curves: {
					x: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					y: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					z: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
				};
			};
			R: {
				id: number;
				attr: string;
				internalID: number;
				attrX: boolean;
				attrY: boolean;
				attrZ: boolean;
				containerBoneID: number;
				containerID: number;
				curves: {
					x: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					y: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					z: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
				};
			};
			S: {
				id: number;
				attr: string;
				internalID: number;
				attrX: boolean;
				attrY: boolean;
				attrZ: boolean;
				containerBoneID: number;
				containerID: number;
				curves: {
					x: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					y: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
					z: {
						version: any;
						id: number;
						internalID: number;
						times: number[];
						values: number[];
						attrFlag: number[];
						attrData: number[];
					};
				};
			};
		}[]>;
		stacks: Map<number, {
			name: string;
			layers: {
				T: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					};
				};
				R: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					};
				};
				S: {
					id: number;
					attr: string;
					internalID: number;
					attrX: boolean;
					attrY: boolean;
					attrZ: boolean;
					containerBoneID: number;
					containerID: number;
					curves: {
						x: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						y: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
						z: {
							version: any;
							id: number;
							internalID: number;
							times: number[];
							values: number[];
							attrFlag: number[];
							attrData: number[];
						};
					};
				};
			}[][];
			length: number;
			frames: number;
		}>;
		length: number;
		fps: number;
		frames: number;
	}} animations,
	 * @param {{skeleton: { bones: THREE.Bone[]}}} group
	 */
	function addAnimations( group, animations ) {

		if ( group.animations === undefined ) {

			group.animations = [];

		}

		var stacks = animations.stacks;

		for ( var key in stacks ) {

			var stack = stacks[ key ];

			/**
			 * @type {{
			 * name: string,
			 * fps: number,
			 * length: number,
			 * hierarchy: Array.<{
			 * 	parent: number,
			 * 	name: string,
			 * 	keys: Array.<{
			 * 		time: number,
			 * 		pos: Array.<number>,
			 * 		rot: Array.<number>,
			 * 		scl: Array.<number>
			 * 	}>
			 * }>
			 * }}
			 */
			var animationData = {
				name: stack.name,
				fps: 30,
				length: stack.length,
				hierarchy: []
			};

			var bones = group.skeleton.bones;

			for ( var bonesIndex = 0, bonesLength = bones.length; bonesIndex < bonesLength; ++ bonesIndex ) {

				var bone = bones[ bonesIndex ];

				var name = bone.name.replace( /.*:/, '' );
				var parentIndex = findIndex( bones, function ( parentBone ) {

					return bone.parent === parentBone;

				} );
				animationData.hierarchy.push( { parent: parentIndex, name: name, keys: [] } );

			}

			for ( var frame = 0; frame <= stack.frames; frame ++ ) {

				for ( var bonesIndex = 0, bonesLength = bones.length; bonesIndex < bonesLength; ++ bonesIndex ) {

					var bone = bones[ bonesIndex ];
					var boneIndex = bonesIndex;

					var animationNode = stack.layers[ 0 ][ boneIndex ];

					for ( var hierarchyIndex = 0, hierarchyLength = animationData.hierarchy.length; hierarchyIndex < hierarchyLength; ++ hierarchyIndex ) {

						var node = animationData.hierarchy[ hierarchyIndex ];

						if ( node.name === bone.name ) {

							node.keys.push( generateKey( animations, animationNode, bone, frame ) );

						}

					}

				}

			}

			group.animations.push( THREE.AnimationClip.parseAnimation( animationData, bones ) );

		}

	}

	var euler = new THREE.Euler();
	var quaternion = new THREE.Quaternion();

	/**
	 * @param {THREE.Bone} bone
	 */
	function generateKey( animations, animationNode, bone, frame ) {

		var key = {
			time: frame / animations.fps,
			pos: bone.position.toArray(),
			rot: bone.quaternion.toArray(),
			scl: bone.scale.toArray()
		};

		if ( animationNode === undefined ) return key;

		try {

			if ( hasCurve( animationNode, 'T' ) && hasKeyOnFrame( animationNode.T, frame ) ) {

				key.pos = [ animationNode.T.curves.x.values[ frame ], animationNode.T.curves.y.values[ frame ], animationNode.T.curves.z.values[ frame ] ];

			}

			if ( hasCurve( animationNode, 'R' ) && hasKeyOnFrame( animationNode.R, frame ) ) {

				var rotationX = animationNode.R.curves.x.values[ frame ];
				var rotationY = animationNode.R.curves.y.values[ frame ];
				var rotationZ = animationNode.R.curves.z.values[ frame ];

				quaternion.setFromEuler( euler.set( rotationX, rotationY, rotationZ, 'ZYX' ) );
				key.rot = quaternion.toArray();

			}

			if ( hasCurve( animationNode, 'S' ) && hasKeyOnFrame( animationNode.S, frame ) ) {

				key.scl = [ animationNode.S.curves.x.values[ frame ], animationNode.S.curves.y.values[ frame ], animationNode.S.curves.z.values[ frame ] ];

			}

		} catch ( error ) {

			// Curve is not fully plotted.
			console.log( bone );
			console.log( error );

		}

		return key;

	}

	var AXES = [ 'x', 'y', 'z' ];

	function hasCurve( animationNode, attribute ) {

		if ( animationNode === undefined ) {

			return false;

		}

		var attributeNode = animationNode[ attribute ];

		if ( ! attributeNode ) {

			return false;

		}

		return AXES.every( function ( key ) {

			return attributeNode.curves[ key ] !== null;

		} );

	}

	function hasKeyOnFrame( attributeNode, frame ) {

		return AXES.every( function ( key ) {

			return isKeyExistOnFrame( attributeNode.curves[ key ], frame );

		} );

	}

	function isKeyExistOnFrame( curve, frame ) {

		return curve.values[ frame ] !== undefined;

	}

	/**
	 * An instance of a Vertex with data for drawing vertices to the screen.
	 * @constructor
	 */
	function Vertex() {

		/**
		 * Position of the vertex.
		 * @type {THREE.Vector3}
		 */
		this.position = new THREE.Vector3();

		/**
		 * Normal of the vertex
		 * @type {THREE.Vector3}
		 */
		this.normal = new THREE.Vector3();

		/**
		 * UV coordinates of the vertex.
		 * @type {THREE.Vector2}
		 */
		this.uv = new THREE.Vector2();

		/**
		 * Color of the vertex
		 * @type {THREE.Vector3}
		 */
		this.color = new THREE.Vector3();

		/**
		 * Indices of the bones vertex is influenced by.
		 * @type {THREE.Vector4}
		 */
		this.skinIndices = new THREE.Vector4( 0, 0, 0, 0 );

		/**
		 * Weights that each bone influences the vertex.
		 * @type {THREE.Vector4}
		 */
		this.skinWeights = new THREE.Vector4( 0, 0, 0, 0 );

	}

	Object.assign( Vertex.prototype, {

		copy: function ( target ) {

			var returnVar = target || new Vertex();

			returnVar.position.copy( this.position );
			returnVar.normal.copy( this.normal );
			returnVar.uv.copy( this.uv );
			returnVar.skinIndices.copy( this.skinIndices );
			returnVar.skinWeights.copy( this.skinWeights );

			return returnVar;

		},

		flattenToBuffers: function ( vertexBuffer, normalBuffer, uvBuffer, colorBuffer, skinIndexBuffer, skinWeightBuffer ) {

			this.position.toArray( vertexBuffer, vertexBuffer.length );
			this.normal.toArray( normalBuffer, normalBuffer.length );
			this.uv.toArray( uvBuffer, uvBuffer.length );
			this.color.toArray( colorBuffer, colorBuffer.length );
			this.skinIndices.toArray( skinIndexBuffer, skinIndexBuffer.length );
			this.skinWeights.toArray( skinWeightBuffer, skinWeightBuffer.length );

		}

	} );

	/**
	 * @constructor
	 */
	function Triangle() {

		/**
		 * @type {{position: THREE.Vector3, normal: THREE.Vector3, uv: THREE.Vector2, skinIndices: THREE.Vector4, skinWeights: THREE.Vector4}[]}
		 */
		this.vertices = [];

	}

	Object.assign( Triangle.prototype, {

		copy: function ( target ) {

			var returnVar = target || new Triangle();

			for ( var i = 0; i < this.vertices.length; ++ i ) {

				 this.vertices[ i ].copy( returnVar.vertices[ i ] );

			}

			return returnVar;

		},

		flattenToBuffers: function ( vertexBuffer, normalBuffer, uvBuffer, colorBuffer, skinIndexBuffer, skinWeightBuffer ) {

			var vertices = this.vertices;

			for ( var i = 0, l = vertices.length; i < l; ++ i ) {

				vertices[ i ].flattenToBuffers( vertexBuffer, normalBuffer, uvBuffer, colorBuffer, skinIndexBuffer, skinWeightBuffer );

			}

		}

	} );

	/**
	 * @constructor
	 */
	function Face() {

		/**
		 * @type {{vertices: {position: THREE.Vector3, normal: THREE.Vector3, uv: THREE.Vector2, skinIndices: THREE.Vector4, skinWeights: THREE.Vector4}[]}[]}
		 */
		this.triangles = [];
		this.materialIndex = 0;

	}

	Object.assign( Face.prototype, {

		copy: function ( target ) {

			var returnVar = target || new Face();

			for ( var i = 0; i < this.triangles.length; ++ i ) {

				this.triangles[ i ].copy( returnVar.triangles[ i ] );

			}

			returnVar.materialIndex = this.materialIndex;

			return returnVar;

		},

		genTrianglesFromVertices: function ( vertexArray ) {

			for ( var i = 2; i < vertexArray.length; ++ i ) {

				var triangle = new Triangle();
				triangle.vertices[ 0 ] = vertexArray[ 0 ];
				triangle.vertices[ 1 ] = vertexArray[ i - 1 ];
				triangle.vertices[ 2 ] = vertexArray[ i ];
				this.triangles.push( triangle );

			}

		},

		flattenToBuffers: function ( vertexBuffer, normalBuffer, uvBuffer, colorBuffer, skinIndexBuffer, skinWeightBuffer, materialIndexBuffer ) {

			var triangles = this.triangles;
			var materialIndex = this.materialIndex;

			for ( var i = 0, l = triangles.length; i < l; ++ i ) {

				triangles[ i ].flattenToBuffers( vertexBuffer, normalBuffer, uvBuffer, colorBuffer, skinIndexBuffer, skinWeightBuffer );
				append( materialIndexBuffer, [ materialIndex, materialIndex, materialIndex ] );

			}

		}

	} );

	/**
	 * @constructor
	 */
	function Geometry() {

		/**
		 * @type {{triangles: {vertices: {position: THREE.Vector3, normal: THREE.Vector3, uv: THREE.Vector2, skinIndices: THREE.Vector4, skinWeights: THREE.Vector4}[]}[], materialIndex: number}[]}
		 */
		this.faces = [];

		/**
		 * @type {{}|THREE.Skeleton}
		 */
		this.skeleton = null;

	}

	Object.assign( Geometry.prototype, {

		/**
		 * @returns	{{vertexBuffer: number[], normalBuffer: number[], uvBuffer: number[], skinIndexBuffer: number[], skinWeightBuffer: number[], materialIndexBuffer: number[]}}
		 */
		flattenToBuffers: function () {

			var vertexBuffer = [];
			var normalBuffer = [];
			var uvBuffer = [];
			var colorBuffer = [];
			var skinIndexBuffer = [];
			var skinWeightBuffer = [];

			var materialIndexBuffer = [];

			var faces = this.faces;

			for ( var i = 0, l = faces.length; i < l; ++ i ) {

				faces[ i ].flattenToBuffers( vertexBuffer, normalBuffer, uvBuffer, colorBuffer, skinIndexBuffer, skinWeightBuffer, materialIndexBuffer );

			}

			return {
				vertexBuffer: vertexBuffer,
				normalBuffer: normalBuffer,
				uvBuffer: uvBuffer,
				colorBuffer: colorBuffer,
				skinIndexBuffer: skinIndexBuffer,
				skinWeightBuffer: skinWeightBuffer,
				materialIndexBuffer: materialIndexBuffer
			};

		}

	} );

	function TextParser() {}

	Object.assign( TextParser.prototype, {

		getPrevNode: function () {

			return this.nodeStack[ this.currentIndent - 2 ];

		},

		getCurrentNode: function () {

			return this.nodeStack[ this.currentIndent - 1 ];

		},

		getCurrentProp: function () {

			return this.currentProp;

		},

		pushStack: function ( node ) {

			this.nodeStack.push( node );
			this.currentIndent += 1;

		},

		popStack: function () {

			this.nodeStack.pop();
			this.currentIndent -= 1;

		},

		setCurrentProp: function ( val, name ) {

			this.currentProp = val;
			this.currentPropName = name;

		},

		// ----------parse ---------------------------------------------------
		parse: function ( text ) {

			this.currentIndent = 0;
			this.allNodes = new FBXTree();
			this.nodeStack = [];
			this.currentProp = [];
			this.currentPropName = '';

			var split = text.split( "\n" );

			for ( var line in split ) {

				var l = split[ line ];

				// short cut
				if ( l.match( /^[\s\t]*;/ ) ) {

					continue;

				} // skip comment line
				if ( l.match( /^[\s\t]*$/ ) ) {

					continue;

				} // skip empty line

				// beginning of node
				var beginningOfNodeExp = new RegExp( "^\\t{" + this.currentIndent + "}(\\w+):(.*){", '' );
				var match = l.match( beginningOfNodeExp );
				if ( match ) {

					var nodeName = match[ 1 ].trim().replace( /^"/, '' ).replace( /"$/, "" );
					var nodeAttrs = match[ 2 ].split( ',' );

					for ( var i = 0, l = nodeAttrs.length; i < l; i ++ ) {
						nodeAttrs[ i ] = nodeAttrs[ i ].trim().replace( /^"/, '' ).replace( /"$/, '' );
					}

					this.parseNodeBegin( l, nodeName, nodeAttrs || null );
					continue;

				}

				// node's property
				var propExp = new RegExp( "^\\t{" + ( this.currentIndent ) + "}(\\w+):[\\s\\t\\r\\n](.*)" );
				var match = l.match( propExp );
				if ( match ) {

					var propName = match[ 1 ].replace( /^"/, '' ).replace( /"$/, "" ).trim();
					var propValue = match[ 2 ].replace( /^"/, '' ).replace( /"$/, "" ).trim();

					this.parseNodeProperty( l, propName, propValue );
					continue;

				}

				// end of node
				var endOfNodeExp = new RegExp( "^\\t{" + ( this.currentIndent - 1 ) + "}}" );
				if ( l.match( endOfNodeExp ) ) {

					this.nodeEnd();
					continue;

				}

				// for special case,
				//
				//	  Vertices: *8670 {
				//		  a: 0.0356229953467846,13.9599733352661,-0.399196773.....(snip)
				// -0.0612030513584614,13.960485458374,-0.409748703241348,-0.10.....
				// 0.12490539252758,13.7450733184814,-0.454119384288788,0.09272.....
				// 0.0836158767342567,13.5432004928589,-0.435397416353226,0.028.....
				//
				// these case the lines must contiue with previous line
				if ( l.match( /^[^\s\t}]/ ) ) {

					this.parseNodePropertyContinued( l );

				}

			}

			return this.allNodes;

		},

		parseNodeBegin: function ( line, nodeName, nodeAttrs ) {

			// var nodeName = match[1];
			var node = { 'name': nodeName, properties: {}, 'subNodes': {} };
			var attrs = this.parseNodeAttr( nodeAttrs );
			var currentNode = this.getCurrentNode();

			// a top node
			if ( this.currentIndent === 0 ) {

				this.allNodes.add( nodeName, node );

			} else {

				// a subnode

				// already exists subnode, then append it
				if ( nodeName in currentNode.subNodes ) {

					var tmp = currentNode.subNodes[ nodeName ];

					// console.log( "duped entry found\nkey: " + nodeName + "\nvalue: " + propValue );
					if ( this.isFlattenNode( currentNode.subNodes[ nodeName ] ) ) {


						if ( attrs.id === '' ) {

							currentNode.subNodes[ nodeName ] = [];
							currentNode.subNodes[ nodeName ].push( tmp );

						} else {

							currentNode.subNodes[ nodeName ] = {};
							currentNode.subNodes[ nodeName ][ tmp.id ] = tmp;

						}

					}

					if ( attrs.id === '' ) {

						currentNode.subNodes[ nodeName ].push( node );

					} else {

						currentNode.subNodes[ nodeName ][ attrs.id ] = node;

					}

				} else if ( typeof attrs.id === 'number' || attrs.id.match( /^\d+$/ ) ) {

					currentNode.subNodes[ nodeName ] = {};
					currentNode.subNodes[ nodeName ][ attrs.id ] = node;

				} else {

					currentNode.subNodes[ nodeName ] = node;

				}

			}

			// for this		  â†“â†“â†“â†“â†“â†“â†“â†“â†“â†“â†“â†“â†“â†“â†“â†“â†“â†“
			// NodeAttribute: 1001463072, "NodeAttribute::", "LimbNode" {
			if ( nodeAttrs ) {

				node.id = attrs.id;
				node.attrName = attrs.name;
				node.attrType = attrs.type;

			}

			this.pushStack( node );

		},

		parseNodeAttr: function ( attrs ) {

			var id = attrs[ 0 ];

			if ( attrs[ 0 ] !== "" ) {

				id = parseInt( attrs[ 0 ] );

				if ( isNaN( id ) ) {

					// PolygonVertexIndex: *16380 {
					id = attrs[ 0 ];

				}

			}

			var name = '', type = '';

			if ( attrs.length > 1 ) {

				name = attrs[ 1 ].replace( /^(\w+)::/, '' );
				type = attrs[ 2 ];

			}

			return { id: id, name: name, type: type };

		},

		parseNodeProperty: function ( line, propName, propValue ) {

			var currentNode = this.getCurrentNode();
			var parentName = currentNode.name;

			// special case parent node's is like "Properties70"
			// these chilren nodes must treat with careful
			if ( parentName !== undefined ) {

				var propMatch = parentName.match( /Properties(\d)+/ );
				if ( propMatch ) {

					this.parseNodeSpecialProperty( line, propName, propValue );
					return;

				}

			}

			// special case Connections
			if ( propName == 'C' ) {

				var connProps = propValue.split( ',' ).slice( 1 );
				var from = parseInt( connProps[ 0 ] );
				var to = parseInt( connProps[ 1 ] );

				var rest = propValue.split( ',' ).slice( 3 );

				propName = 'connections';
				propValue = [ from, to ];
				append( propValue, rest );

				if ( currentNode.properties[ propName ] === undefined ) {

					currentNode.properties[ propName ] = [];

				}

			}

			// special case Connections
			if ( propName == 'Node' ) {

				var id = parseInt( propValue );
				currentNode.properties.id = id;
				currentNode.id = id;

			}

			// already exists in properties, then append this
			if ( propName in currentNode.properties ) {

				// console.log( "duped entry found\nkey: " + propName + "\nvalue: " + propValue );
				if ( Array.isArray( currentNode.properties[ propName ] ) ) {

					currentNode.properties[ propName ].push( propValue );

				} else {

					currentNode.properties[ propName ] += propValue;

				}

			} else {

				// console.log( propName + ":  " + propValue );
				if ( Array.isArray( currentNode.properties[ propName ] ) ) {

					currentNode.properties[ propName ].push( propValue );

				} else {

					currentNode.properties[ propName ] = propValue;

				}

			}

			this.setCurrentProp( currentNode.properties, propName );

		},

		// TODO:
		parseNodePropertyContinued: function ( line ) {

			this.currentProp[ this.currentPropName ] += line;

		},

		parseNodeSpecialProperty: function ( line, propName, propValue ) {

			// split this
			// P: "Lcl Scaling", "Lcl Scaling", "", "A",1,1,1
			// into array like below
			// ["Lcl Scaling", "Lcl Scaling", "", "A", "1,1,1" ]
			var props = propValue.split( '",' );

			for ( var i = 0, l = props.length; i < l; i ++ ) {
				props[ i ] = props[ i ].trim().replace( /^\"/, '' ).replace( /\s/, '_' );
			}

			var innerPropName = props[ 0 ];
			var innerPropType1 = props[ 1 ];
			var innerPropType2 = props[ 2 ];
			var innerPropFlag = props[ 3 ];
			var innerPropValue = props[ 4 ];

			/*
			if ( innerPropValue === undefined ) {
				innerPropValue = props[3];
			}
			*/

			// cast value in its type
			switch ( innerPropType1 ) {

				case "int":
					innerPropValue = parseInt( innerPropValue );
					break;

				case "double":
					innerPropValue = parseFloat( innerPropValue );
					break;

				case "ColorRGB":
				case "Vector3D":
					innerPropValue = parseFloatArray( innerPropValue );
					break;

			}

			// CAUTION: these props must append to parent's parent
			this.getPrevNode().properties[ innerPropName ] = {

				'type': innerPropType1,
				'type2': innerPropType2,
				'flag': innerPropFlag,
				'value': innerPropValue

			};

			this.setCurrentProp( this.getPrevNode().properties, innerPropName );

		},

		nodeEnd: function () {

			this.popStack();

		},

		/* ---------------------------------------------------------------- */
		/*		util													  */
		isFlattenNode: function ( node ) {

			return ( 'subNodes' in node && 'properties' in node ) ? true : false;

		}

	} );

	// Binary format specification:
	//   https://code.blender.org/2013/08/fbx-binary-file-format-specification/
	//   https://wiki.rogiken.org/specifications/file-format/fbx/ (more detail but Japanese)
	function BinaryParser() {}

	Object.assign( BinaryParser.prototype, {

		/**
		 * Parses binary data and builds FBXTree as much compatible as possible with the one built by TextParser.
		 * @param {ArrayBuffer} buffer
		 * @returns {THREE.FBXTree}
		 */
		parse: function ( buffer ) {

			var reader = new BinaryReader( buffer );
			reader.skip( 23 ); // skip magic 23 bytes

			var version = reader.getUint32();

			console.log( 'FBX binary version: ' + version );

			var allNodes = new FBXTree();

			while ( ! this.endOfContent( reader ) ) {

				var node = this.parseNode( reader, version );
				if ( node !== null ) allNodes.add( node.name, node );

			}

			return allNodes;

		},

		/**
		 * Checks if reader has reached the end of content.
		 * @param {BinaryReader} reader
		 * @returns {boolean}
		 */
		endOfContent: function( reader ) {

			// footer size: 160bytes + 16-byte alignment padding
			// - 16bytes: magic
			// - padding til 16-byte alignment (at least 1byte?)
			//   (seems like some exporters embed fixed 15bytes?)
			// - 4bytes: magic
			// - 4bytes: version
			// - 120bytes: zero
			// - 16bytes: magic
			if ( reader.size() % 16 === 0 ) {

				return ( ( reader.getOffset() + 160 + 16 ) & ~0xf ) >= reader.size();

			} else {

				return reader.getOffset() + 160 + 15 >= reader.size();

			}

		},

		/**
		 * Parses Node as much compatible as possible with the one parsed by TextParser
		 * TODO: could be optimized more?
		 * @param {BinaryReader} reader
		 * @param {number} version
		 * @returns {Object} - Returns an Object as node, or null if NULL-record.
		 */
		parseNode: function ( reader, version ) {

			// The first three data sizes depends on version.
			var endOffset = ( version >= 7500 ) ? reader.getUint64() : reader.getUint32();
			var numProperties = ( version >= 7500 ) ? reader.getUint64() : reader.getUint32();
			var propertyListLen = ( version >= 7500 ) ? reader.getUint64() : reader.getUint32();
			var nameLen = reader.getUint8();
			var name = reader.getString( nameLen );

			// Regards this node as NULL-record if endOffset is zero
			if ( endOffset === 0 ) return null;

			var propertyList = [];

			for ( var i = 0; i < numProperties; i ++ ) {

				propertyList.push( this.parseProperty( reader ) );

			}

			// Regards the first three elements in propertyList as id, attrName, and attrType
			var id = propertyList.length > 0 ? propertyList[ 0 ] : '';
			var attrName = propertyList.length > 1 ? propertyList[ 1 ] : '';
			var attrType = propertyList.length > 2 ? propertyList[ 2 ] : '';

			var subNodes = {};
			var properties = {};

			var isSingleProperty = false;

			// if this node represents just a single property
			// like (name, 0) set or (name2, [0, 1, 2]) set of {name: 0, name2: [0, 1, 2]}
			if ( numProperties === 1 && reader.getOffset() === endOffset ) {

				isSingleProperty = true;

			}

			while ( endOffset > reader.getOffset() ) {

				var node = this.parseNode( reader, version );

				if ( node === null ) continue;

				// special case: child node is single property
				if ( node.singleProperty === true ) {

					var value = node.propertyList[ 0 ];

					if ( Array.isArray( value ) ) {

						// node represents
						//	Vertices: *3 {
						//		a: 0.01, 0.02, 0.03
						//	}
						// of text format here.

						node.properties[ node.name ] = node.propertyList[ 0 ];
						subNodes[ node.name ] = node;

						// Later phase expects single property array is in node.properties.a as String.
						// TODO: optimize
						node.properties.a = value.toString();

					} else {

						// node represents
						// 	Version: 100
						// of text format here.

						properties[ node.name ] = value;

					}

					continue;

				}

				// special case: connections
				if ( name === 'Connections' && node.name === 'C' ) {

					var array = [];

					// node.propertyList would be like
					// ["OO", 111264976, 144038752, "d|x"] (?, from, to, additional values)
					for ( var i = 1, il = node.propertyList.length; i < il; i ++ ) {

						array[ i - 1 ] = node.propertyList[ i ];

					}

					if ( properties.connections === undefined ) {

						properties.connections = [];

					}

					properties.connections.push( array );

					continue;

				}

				// special case: child node is Properties\d+
				if ( node.name.match( /^Properties\d+$/ ) ) {

					// move child node's properties to this node.

					var keys = Object.keys( node.properties );

					for ( var i = 0, il = keys.length; i < il; i ++ ) {

						var key = keys[ i ];
						properties[ key ] = node.properties[ key ];

					}

					continue;

				}

				// special case: properties
				if ( name.match( /^Properties\d+$/ ) && node.name === 'P' ) {

					var innerPropName = node.propertyList[ 0 ];
					var innerPropType1 = node.propertyList[ 1 ];
					var innerPropType2 = node.propertyList[ 2 ];
					var innerPropFlag = node.propertyList[ 3 ];
					var innerPropValue;

					if ( innerPropName.indexOf( 'Lcl ' ) === 0 ) innerPropName = innerPropName.replace( 'Lcl ', 'Lcl_' );
					if ( innerPropType1.indexOf( 'Lcl ' ) === 0 ) innerPropType1 = innerPropType1.replace( 'Lcl ', 'Lcl_' );

					if ( innerPropType1 === 'ColorRGB' || innerPropType1 === 'Vector' ||
						 innerPropType1 === 'Vector3D' || innerPropType1.indexOf( 'Lcl_' ) === 0 ) {

						innerPropValue = [
							node.propertyList[ 4 ],
							node.propertyList[ 5 ],
							node.propertyList[ 6 ]
						];

					} else {

						innerPropValue = node.propertyList[ 4 ];

					}

					if ( innerPropType1.indexOf( 'Lcl_' ) === 0 ) {

						innerPropValue = innerPropValue.toString();

					}

					// this will be copied to parent. see above.
					properties[ innerPropName ] = {

						'type': innerPropType1,
						'type2': innerPropType2,
						'flag': innerPropFlag,
						'value': innerPropValue

					};

					continue;

				}

				// standard case
				// follows TextParser's manner.
				if ( subNodes[ node.name ] === undefined ) {

					if ( typeof node.id === 'number' ) {

						subNodes[ node.name ] = {};
						subNodes[ node.name ][ node.id ] = node;

					} else {

						subNodes[ node.name ] = node;

					}

				} else {

					if ( node.id === '' ) {

						if ( ! Array.isArray( subNodes[ node.name ] ) ) {

							subNodes[ node.name ] = [ subNodes[ node.name ] ];

						}

						subNodes[ node.name ].push( node );

					} else {

						if ( subNodes[ node.name ][ node.id ] === undefined ) {

							subNodes[ node.name ][ node.id ] = node;

						} else {

							// conflict id. irregular?

							if ( ! Array.isArray( subNodes[ node.name ][ node.id ] ) ) {

								subNodes[ node.name ][ node.id ] = [ subNodes[ node.name ][ node.id ] ];

							}

							subNodes[ node.name ][ node.id ].push( node );

						}

					}

				}

			}

			return {

				singleProperty: isSingleProperty,
				id: id,
				attrName: attrName,
				attrType: attrType,
				name: name,
				properties: properties,
				propertyList: propertyList, // raw property list, would be used by parent
				subNodes: subNodes

			};

		},

		parseProperty: function ( reader ) {

			var type = reader.getChar();

			switch ( type ) {

				case 'F':
					return reader.getFloat32();

				case 'D':
					return reader.getFloat64();

				case 'L':
					return reader.getInt64();

				case 'I':
					return reader.getInt32();

				case 'Y':
					return reader.getInt16();

				case 'C':
					return reader.getBoolean();

				case 'f':
				case 'd':
				case 'l':
				case 'i':
				case 'b':

					var arrayLength = reader.getUint32();
					var encoding = reader.getUint32(); // 0: non-compressed, 1: compressed
					var compressedLength = reader.getUint32();

					if ( encoding === 0 ) {

						switch ( type ) {

							case 'f':
								return reader.getFloat32Array( arrayLength );

							case 'd':
								return reader.getFloat64Array( arrayLength );

							case 'l':
								return reader.getInt64Array( arrayLength );

							case 'i':
								return reader.getInt32Array( arrayLength );

							case 'b':
								return reader.getBooleanArray( arrayLength );

						}

					}

					if ( window.Zlib === undefined ) {

						throw new Error( 'FBXLoader: External library Inflate.min.js required, obtain or import from https://github.com/imaya/zlib.js' );

					}

					var inflate = new Zlib.Inflate( new Uint8Array( reader.getArrayBuffer( compressedLength ) ) );
					var reader2 = new BinaryReader( inflate.decompress().buffer );

					switch ( type ) {

						case 'f':
							return reader2.getFloat32Array( arrayLength );

						case 'd':
							return reader2.getFloat64Array( arrayLength );

						case 'l':
							return reader2.getInt64Array( arrayLength );

						case 'i':
							return reader2.getInt32Array( arrayLength );

						case 'b':
							return reader2.getBooleanArray( arrayLength );

					}

				case 'S':
					var length = reader.getUint32();
					return reader.getString( length );

				case 'R':
					var length = reader.getUint32();
					return reader.getArrayBuffer( length );

				default:
					throw new Error( 'FBXLoader: Unknown property type ' + type );

			}

		}

	} );


	function BinaryReader( buffer, littleEndian ) {

		this.dv = new DataView( buffer );
		this.offset = 0;
		this.littleEndian = ( littleEndian !== undefined ) ? littleEndian : true;

	}

	Object.assign( BinaryReader.prototype, {

		getOffset: function () {

			return this.offset;

		},

		size: function () {

			return this.dv.buffer.byteLength;

		},

		skip: function ( length ) {

			this.offset += length;

		},

		// seems like true/false representation depends on exporter.
		//   true: 1 or 'Y'(=0x59), false: 0 or 'T'(=0x54)
		// then sees LSB.
		getBoolean: function () {

			return ( this.getUint8() & 1 ) === 1;

		},

		getBooleanArray: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getBoolean() );

			}

			return a;

		},

		getInt8: function () {

			var value = this.dv.getInt8( this.offset );
			this.offset += 1;
			return value;

		},

		getInt8Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getInt8() );

			}

			return a;

		},

		getUint8: function () {

			var value = this.dv.getUint8( this.offset );
			this.offset += 1;
			return value;

		},

		getUint8Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getUint8() );

			}

			return a;

		},

		getInt16: function () {

			var value = this.dv.getInt16( this.offset, this.littleEndian );
			this.offset += 2;
			return value;

		},

		getInt16Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getInt16() );

			}

			return a;

		},

		getUint16: function () {

			var value = this.dv.getUint16( this.offset, this.littleEndian );
			this.offset += 2;
			return value;

		},

		getUint16Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getUint16() );

			}

			return a;

		},

		getInt32: function () {

			var value = this.dv.getInt32( this.offset, this.littleEndian );
			this.offset += 4;
			return value;

		},

		getInt32Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getInt32() );

			}

			return a;

		},

		getUint32: function () {

			var value = this.dv.getUint32( this.offset, this.littleEndian );
			this.offset += 4;
			return value;

		},

		getUint32Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getUint32() );

			}

			return a;

		},

		// JavaScript doesn't support 64-bit integer so attempting to calculate by ourselves.
		// 1 << 32 will return 1 so using multiply operation instead here.
		// There'd be a possibility that this method returns wrong value if the value
		// is out of the range between Number.MAX_SAFE_INTEGER and Number.MIN_SAFE_INTEGER.
		// TODO: safely handle 64-bit integer
		getInt64: function () {

			var low, high;

			if ( this.littleEndian ) {

				low = this.getUint32();
				high = this.getUint32();

			} else {

				high = this.getUint32();
				low = this.getUint32();

			}

			// calculate negative value
			if ( high & 0x80000000 ) {

				high = ~high & 0xFFFFFFFF;
				low = ~low & 0xFFFFFFFF;

				if ( low === 0xFFFFFFFF ) high = ( high + 1 ) & 0xFFFFFFFF;

				low = ( low + 1 ) & 0xFFFFFFFF;

				return - ( high * 0x100000000 + low );

			}

			return high * 0x100000000 + low;

		},

		getInt64Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getInt64() );

			}

			return a;

		},

		// Note: see getInt64() comment
		getUint64: function () {

			var low, high;

			if ( this.littleEndian ) {

				low = this.getUint32();
				high = this.getUint32();

			} else {

				high = this.getUint32();
				low = this.getUint32();

			}

			return high * 0x100000000 + low;

		},

		getUint64Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getUint64() );

			}

			return a;

		},

		getFloat32: function () {

			var value = this.dv.getFloat32( this.offset, this.littleEndian );
			this.offset += 4;
			return value;

		},

		getFloat32Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getFloat32() );

			}

			return a;

		},

		getFloat64: function () {

			var value = this.dv.getFloat64( this.offset, this.littleEndian );
			this.offset += 8;
			return value;

		},

		getFloat64Array: function ( size ) {

			var a = [];

			for ( var i = 0; i < size; i ++ ) {

				a.push( this.getFloat64() );

			}

			return a;

		},

		getArrayBuffer: function ( size ) {

			var value = this.dv.buffer.slice( this.offset, this.offset + size );
			this.offset += size;
			return value;

		},

		getChar: function () {

			return String.fromCharCode( this.getUint8() );

		},

		getString: function ( size ) {

			var s = '';

			while ( size > 0 ) {

				var value = this.getUint8();
				size--;

				if ( value === 0 ) break;

				s += String.fromCharCode( value );

			}

			this.skip( size );

			return s;

		}

	} );


	function FBXTree() {}

	Object.assign( FBXTree.prototype, {

		add: function ( key, val ) {

			this[ key ] = val;

		},

		searchConnectionParent: function ( id ) {

			if ( this.__cache_search_connection_parent === undefined ) {

				this.__cache_search_connection_parent = [];

			}

			if ( this.__cache_search_connection_parent[ id ] !== undefined ) {

				return this.__cache_search_connection_parent[ id ];

			} else {

				this.__cache_search_connection_parent[ id ] = [];

			}

			var conns = this.Connections.properties.connections;

			var results = [];
			for ( var i = 0; i < conns.length; ++ i ) {

				if ( conns[ i ][ 0 ] == id ) {

					// 0 means scene root
					var res = conns[ i ][ 1 ] === 0 ? - 1 : conns[ i ][ 1 ];
					results.push( res );

				}

			}

			if ( results.length > 0 ) {

				append( this.__cache_search_connection_parent[ id ], results );
				return results;

			} else {

				this.__cache_search_connection_parent[ id ] = [ - 1 ];
				return [ - 1 ];

			}

		},

		searchConnectionChildren: function ( id ) {

			if ( this.__cache_search_connection_children === undefined ) {

				this.__cache_search_connection_children = [];

			}

			if ( this.__cache_search_connection_children[ id ] !== undefined ) {

				return this.__cache_search_connection_children[ id ];

			} else {

				this.__cache_search_connection_children[ id ] = [];

			}

			var conns = this.Connections.properties.connections;

			var res = [];
			for ( var i = 0; i < conns.length; ++ i ) {

				if ( conns[ i ][ 1 ] == id ) {

					// 0 means scene root
					res.push( conns[ i ][ 0 ] === 0 ? - 1 : conns[ i ][ 0 ] );
					// there may more than one kid, then search to the end

				}

			}

			if ( res.length > 0 ) {

				append( this.__cache_search_connection_children[ id ], res );
				return res;

			} else {

				this.__cache_search_connection_children[ id ] = [ ];
				return [ ];

			}

		},

		searchConnectionType: function ( id, to ) {

			var key = id + ',' + to; // TODO: to hash
			if ( this.__cache_search_connection_type === undefined ) {

				this.__cache_search_connection_type = {};

			}

			if ( this.__cache_search_connection_type[ key ] !== undefined ) {

				return this.__cache_search_connection_type[ key ];

			} else {

				this.__cache_search_connection_type[ key ] = '';

			}

			var conns = this.Connections.properties.connections;

			for ( var i = 0; i < conns.length; ++ i ) {

				if ( conns[ i ][ 0 ] == id && conns[ i ][ 1 ] == to ) {

					// 0 means scene root
					this.__cache_search_connection_type[ key ] = conns[ i ][ 2 ];
					return conns[ i ][ 2 ];

				}

			}

			this.__cache_search_connection_type[ id ] = null;
			return null;

		}

	} );


	/**
	 * @param {ArrayBuffer} buffer
	 * @returns {boolean}
	 */
	function isFbxFormatBinary( buffer ) {

		var CORRECT = 'Kaydara FBX Binary  \0';

		return buffer.byteLength >= CORRECT.length && CORRECT === convertArrayBufferToString( buffer, 0, CORRECT.length );

	}

	/**
	 * @returns {boolean}
	 */
	function isFbxFormatASCII( text ) {

		var CORRECT = [ 'K', 'a', 'y', 'd', 'a', 'r', 'a', '\\', 'F', 'B', 'X', '\\', 'B', 'i', 'n', 'a', 'r', 'y', '\\', '\\' ];

		var cursor = 0;

		function read( offset ) {

			var result = text[ offset - 1 ];
			text = text.slice( cursor + offset );
			cursor ++;
			return result;

		}

		for ( var i = 0; i < CORRECT.length; ++ i ) {

			var num = read( 1 );
			if ( num == CORRECT[ i ] ) {

				return false;

			}

		}

		return true;

	}

	/**
	 * @returns {number}
	 */
	function getFbxVersion( text ) {

		var versionRegExp = /FBXVersion: (\d+)/;
		var match = text.match( versionRegExp );
		if ( match ) {

			var version = parseInt( match[ 1 ] );
			return version;

		}
		throw new Error( 'FBXLoader: Cannot find the version number for the file given.' );

	}

	/**
	 * Converts FBX ticks into real time seconds.
	 * @param {number} time - FBX tick timestamp to convert.
	 * @returns {number} - FBX tick in real world time.
	 */
	function convertFBXTimeToSeconds( time ) {

		// Constant is FBX ticks per second.
		return time / 46186158000;

	}

	/**
	 * Parses comma separated list of float numbers and returns them in an array.
	 * @example
	 * // Returns [ 5.6, 9.4, 2.5, 1.4 ]
	 * parseFloatArray( "5.6,9.4,2.5,1.4" )
	 * @returns {number[]}
	 */
	function parseFloatArray( string ) {

		var array = string.split( ',' );

		for ( var i = 0, l = array.length; i < l; i ++ ) {

			array[ i ] = parseFloat( array[ i ] );

		}

		return array;

	}

	/**
	 * Parses comma separated list of int numbers and returns them in an array.
	 * @example
	 * // Returns [ 5, 8, 2, 3 ]
	 * parseFloatArray( "5,8,2,3" )
	 * @returns {number[]}
	 */
	function parseIntArray( string ) {

		var array = string.split( ',' );

		for ( var i = 0, l = array.length; i < l; i ++ ) {

			array[ i ] = parseInt( array[ i ] );

		}

		return array;

	}

	/**
	 * Parses Vector3 property from FBXTree.  Property is given as .value.x, .value.y, etc.
	 * @param {FBXVector3} property - Property to parse as Vector3.
	 * @returns {THREE.Vector3}
	 */
	function parseVector3( property ) {

		return new THREE.Vector3().fromArray( property.value );

	}

	/**
	 * Parses Color property from FBXTree.  Property is given as .value.x, .value.y, etc.
	 * @param {FBXVector3} property - Property to parse as Color.
	 * @returns {THREE.Color}
	 */
	function parseColor( property ) {

		return new THREE.Color().fromArray( property.value );

	}

	function parseMatrixArray( floatString ) {

		return new THREE.Matrix4().fromArray( parseFloatArray( floatString ) );

	}

	/**
	 * Converts ArrayBuffer to String.
	 * @param {ArrayBuffer} buffer
	 * @param {number} from
	 * @param {number} to
	 * @returns {String}
	 */
	function convertArrayBufferToString( buffer, from, to ) {

		if ( from === undefined ) from = 0;
		if ( to === undefined ) to = buffer.byteLength;

		var array = new Uint8Array( buffer, from, to );

		if ( window.TextDecoder !== undefined ) {

			return new TextDecoder().decode( array );

		}

		var s = '';

		for ( var i = 0, il = array.length; i < il; i ++ ) {

			s += String.fromCharCode( array[ i ] );

		}

		return s;

	}

	/**
	 * Converts number from degrees into radians.
	 * @param {number} value
	 * @returns {number}
	 */
	function degreeToRadian( value ) {

		return value * DEG2RAD;

	}

	var DEG2RAD = Math.PI / 180;

	//

	function findIndex( array, func ) {

		for ( var i = 0, l = array.length; i < l; i ++ ) {

			if ( func( array[ i ] ) ) return i;

		}

		return -1;

	}

	function append( a, b ) {

		for ( var i = 0, j = a.length, l = b.length; i < l; i ++, j ++ ) {

			a[ j ] = b[ i ];

		}

	}

	function slice( a, b, from, to ) {

		for ( var i = from, j = 0; i < to; i ++, j ++ ) {

			a[ j ] = b[ i ];

		}

		return a;

	}

} )();


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Landing__ = __webpack_require__("X4if");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Admin_adminMessaging__ = __webpack_require__("jCYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Admin_adminLogin__ = __webpack_require__("RcLo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Admin_adminGroupData__ = __webpack_require__("5wB+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Avatar_Avatar__ = __webpack_require__("L0tu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Challenge_Challenge__ = __webpack_require__("z2cB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Fitness_FitnessHistory__ = __webpack_require__("RVzV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Market__ = __webpack_require__("iy0w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Avatar_createNewAvatarModal__ = __webpack_require__("7f5Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Avatar_cameraModal__ = __webpack_require__("GEU/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Avatar_loaderModal__ = __webpack_require__("dO9g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Registration_registerModal__ = __webpack_require__("Cqth");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Admin_adminRegister__ = __webpack_require__("EetY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Inbox_Inbox__ = __webpack_require__("+B+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Account__ = __webpack_require__("uK6g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__auth_guard__ = __webpack_require__("hlOO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__store__ = __webpack_require__("IcnI");























// Needed to make use of the vue-router system
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/', // this is the path in the UR
    name: 'Landing',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Landing__["a" /* default */] // created component
  }, {
    path: '/account',
    name: 'Account',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Account__["a" /* default */]
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */]
  }, {
    path: '/avatar',
    name: 'Avatar',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Avatar_Avatar__["a" /* default */]
  }, {
    path: '/market',
    name: 'Market',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Market__["a" /* default */]
  }, {
    path: '/challenge',
    name: 'Challenge',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Challenge_Challenge__["a" /* default */]
  }, {
    path: '/fitnesshistory',
    name: 'FitnessHistory',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Fitness_FitnessHistory__["a" /* default */]
  }, {
    path: '/inbox',
    name: 'Inbox',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Inbox_Inbox__["a" /* default */]
  }, {
    path: '/admin',
    name: 'AdminLogin',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Admin_adminLogin__["a" /* default */]
  }, {
    path: '/adminMessaging',
    name: 'Messaging',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Admin_adminMessaging__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_21__store__["a" /* store */].getters.admin) {
        next();
      } else {
        next({ path: '/admin', query: { redirect: to.fullPath } });
        alert("User does not have administrative privileges!");
      }
    }
  }, {
    path: '/adminGroupData',
    name: 'GroupData',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Admin_adminGroupData__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_21__store__["a" /* store */].getters.admin) {
        next();
      } else {
        next({ path: '/admin', query: { redirect: to.fullPath } });
        alert("User does not have administrative privileges!");
      }
    }
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "Zfjb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_vm._m(0,false,false),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"field is-horizontal"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded has-icons-left"},[_c('input',{staticClass:"input",attrs:{"type":"text","id":"username","placeholder":"Username","required":""},domProps:{"value":_vm.username.toLowerCase()},on:{"input":function($event){_vm.username = $event.target.value.toLowerCase()},"keyup":_vm.checkUsername}}),_vm._v(" "),_vm._m(2,false,false)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded"},[(_vm.usernameAvailable)?_c('b',{staticClass:"help is-success"},[_vm._v("\n                @"+_vm._s(_vm.username)+" is available\n              ")]):_vm._e(),_vm._v(" "),(!_vm.usernameAvailable)?_c('b',{staticClass:"help is-danger"},[_vm._v("\n                @"+_vm._s(_vm.username)+" has already been taken\n              ")]):_vm._e()])])])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-fullwidth",on:{"click":function($event){_vm.submitUsername(); _vm.$emit('close')}}},[_vm._v("Submit")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"modal-card-title"},[_c('b',[_vm._v("Create a Knosis Username")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Username:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-user"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aGek":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aIeS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('table',{staticClass:"table is-striped is-narrow-tablet is-narrow-mobile is-hoverable"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',[_c('tr',[_vm._m(1,false,false),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.user.username))])]),_vm._v(" "),_c('tr',[_vm._m(2,false,false),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_vm._m(3,false,false),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"}],staticClass:"input",attrs:{"type":"text"},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_vm._m(4,false,false),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.user.email))])]),_vm._v(" "),_c('tr',[_vm._m(5,false,false),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.user.dob))])]),_vm._v(" "),_c('tr',[_vm._m(6,false,false),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.user.gender))])]),_vm._v(" "),_c('tr',[_vm._m(7,false,false),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.user.race))])]),_vm._v(" "),_c('tr',[_vm._m(8,false,false),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.weight),expression:"weight"}],staticClass:"input",attrs:{"type":"number"},domProps:{"value":(_vm.weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.weight=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_vm._m(9,false,false),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.user.heightFT))])]),_vm._v(" "),_c('tr',[_vm._m(10,false,false),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.user.heightIN))])]),_vm._v(" "),_c('tr',[_vm._m(11,false,false),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"}],staticClass:"input",attrs:{"type":"number"},domProps:{"value":(_vm.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td'),_c('td',[_c('button',{staticClass:"button is-fullwidth",on:{"click":function($event){_vm.updateUserData()}}},[_vm._v("Update")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Current/Updated")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Username")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("First Name")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Last Name")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Birthday")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Gender")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Race")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Weight")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Height Feet")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Height Inches")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('strong',[_vm._v("Zipcode")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aRC9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.messageModal),expression:"messageModal"}],staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_vm._m(0,false,false),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',[_c('p',{staticClass:"subtitle is-6",attrs:{"align":"left"}},[_c('b',[_vm._v("Date: ")]),_vm._v(_vm._s(_vm.message.date))]),_vm._v(" "),_c('p',{staticClass:"subtitle is-6",attrs:{"align":"left"}},[_c('b',[_vm._v("Subject: ")]),_vm._v(_vm._s(_vm.message.subject))]),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('p',{staticClass:"subtitle is-6",attrs:{"align":"left"},domProps:{"innerHTML":_vm._s(_vm.message.message)}},[_vm._v(" "+_vm._s(_vm.message.message)+" ")])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-fullwidth",on:{"click":_vm.dismissMessage}},[_vm._v("Dismiss")]),_vm._v(" "),_c('button',{staticClass:"button is-light is-fullwidth",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Close")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"modal-card-title"},[_c('b',[_vm._v("Message!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"subtitle is-6",attrs:{"align":"left"}},[_c('b',[_vm._v("Message: ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b634":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-one-third"},[_c('div',{staticClass:"parent"},[_vm._m(0,false,false),_c('br'),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.progress)+" %")]),_vm._v(" "),_c('progress',{staticClass:"progress",attrs:{"max":"100"},domProps:{"value":_vm.progress}},[_vm._v(_vm._s(_vm.progress))]),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":__webpack_require__("fcNI"),"alt":"KNOSIS"}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("Please wait while your avatar loads."),_c('br'),_vm._v("This should take about a minute."),_c('br'),_vm._v("Please do not leave the page.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bG/c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[(_vm.groupView)?_c('p',{staticClass:"title is-3",attrs:{"align":"center"}},[_vm._v("Group Data - User Averages")]):_vm._e(),_vm._v(" "),(_vm.individualView)?_c('p',{staticClass:"title is-3",attrs:{"align":"center"}},[_vm._v("User Data - Dailies")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"columns"},[(_vm.groupView)?_c('div',{staticClass:"column"},[_vm._m(0,false,false),_vm._v(" "),_c('table',{staticClass:"table is-striped is-narrow-tablet is-narrow-mobile is-hoverable"},[_vm._m(1,false,false),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('a',{on:{"click":_vm.detailView}},[_vm._v("Wilman")])]),_c('td',[_vm._v("7045")]),_c('td',[_vm._v("5.4")]),_c('td',[_vm._v("62")]),_c('td',[_vm._v("148")])]),_vm._v(" "),_vm._m(2,false,false)])])]):_vm._e(),_vm._v(" "),(_vm.individualView)?_c('div',{staticClass:"column"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"field is-grouped"},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"as-text",staticStyle:{"color":"white"},on:{"click":_vm.reloadPage}},[_c('i',{staticClass:"fas fa-angle-double-left"}),_vm._v(" BACK")])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"as-text",staticStyle:{"color":"white"},on:{"click":_vm.reloadPage}},[_vm._v("DOWNLOAD "),_c('i',{staticClass:"fas fa-download"})])])])]),_vm._v(" "),_vm._m(3,false,false)]):_vm._e()])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"title is-6"},[_vm._v("DOWNLOAD"),_c('i',{staticClass:"fas fa-download"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("User")]),_vm._v(" "),_c('th',[_vm._v("Steps")]),_vm._v(" "),_c('th',[_vm._v("Distance (mi)")]),_vm._v(" "),_c('th',[_vm._v("Resting HR (bpm)")]),_vm._v(" "),_c('th',[_vm._v("Active Minutes")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Wilma")]),_c('td',[_vm._v("8047")]),_c('td',[_vm._v("6.2")]),_c('td',[_vm._v("72")]),_c('td',[_vm._v("160")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table is-striped is-narrow-tablet is-narrow-mobile is-hoverable"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Steps")]),_vm._v(" "),_c('th',[_vm._v("Distance (mi)")]),_vm._v(" "),_c('th',[_vm._v("Resting HR (bpm)")]),_vm._v(" "),_c('th',[_vm._v("Active Minutes")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("02/18/2018")]),_c('td',[_vm._v("7045")]),_c('td',[_vm._v("5.4")]),_c('td',[_vm._v("62")]),_c('td',[_vm._v("148")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("02/19/2018")]),_c('td',[_vm._v("8047")]),_c('td',[_vm._v("6.2")]),_c('td',[_vm._v("72")]),_c('td',[_vm._v("160")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bjju":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bk3v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bqaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('backtotop'),_vm._v(" "),(this.navEnabled() && this.$route.path !== '/' && this.$route.path !== '/login' && this.$route.path !== '/admin')?_c('nav',[_c('knosisNavbar')],1):(!this.navEnabled() && this.$route.path !== '/' && this.$route.path !== '/login' && this.$route.path !== '/admin')?_c('nav',[_c('adminNavbar')],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cPqB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.challengeModal),expression:"challengeModal"}],staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_vm._m(0,false,false),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',[_c('p',{staticClass:"subtitle is-6",attrs:{"align":"center"}},[_vm._v("You have selected to challenge "+_vm._s(_vm.opponent.firstName))]),_vm._v(" "),_c('p',{staticClass:"subtitle is-6",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.opponent.firstName)+" holds a rank of "+_vm._s(_vm.opponent.rank))]),_vm._v(" "),_c('p',{staticClass:"subtitle is-6",attrs:{"align":"center"}},[_vm._v("Please choose your challenge")])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-fullwidth",on:{"click":function($event){_vm.challengeUser(1); _vm.$emit('close')}}},[_vm._v("1 Day Challenge")]),_vm._v(" "),_c('button',{staticClass:"button is-fullwidth",on:{"click":function($event){_vm.challengeUser(3); _vm.$emit('close')}}},[_vm._v("3 Day Challenge")]),_vm._v(" "),_c('button',{staticClass:"button is-light is-fullwidth",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"modal-card-title"},[_c('b',[_vm._v("Start a New Challenge!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dO9g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loaderModal_vue__ = __webpack_require__("XxzK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455dad52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loaderModal_vue__ = __webpack_require__("b634");
function injectStyle (ssrContext) {
  __webpack_require__("FJSo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-455dad52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_loaderModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_455dad52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_loaderModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dY5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Sync Your Device!")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control button-control"},[_c('a',{staticClass:"button is-medium is-fullwidth",attrs:{"href":"https://www.fitbit.com/oauth2/authorize?response_type=token&client_id=22CKBV&redirect_uri=https%3A%2F%2Fknosis-beta.firebaseapp.com%2Fhome&scope=activity%20profile%20heartrate&expires_in=2592000&state=confirm","placeholder":"Sync Device"}},[_vm._v("Sync Device")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "doCN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fK5R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fcNI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/landing.c5e08a2.png";

/***/ }),

/***/ "gA8B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gKAU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/AthenaBadgeGold.03a758c.png";

/***/ }),

/***/ "hlOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");


/* unused harmony default export */ var _unused_webpack_default_export = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user) {
    next();
  } else {
    next('/login');
  }
});

/***/ }),

/***/ "iKFn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iy0w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Market_vue__ = __webpack_require__("33Z3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cb49c02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Market_vue__ = __webpack_require__("2gZF");
function injectStyle (ssrContext) {
  __webpack_require__("FGg3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8cb49c02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Market_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8cb49c02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Market_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jCYW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminMessaging_vue__ = __webpack_require__("WVXU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b51cad2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminMessaging_vue__ = __webpack_require__("5ETr");
function injectStyle (ssrContext) {
  __webpack_require__("bk3v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b51cad2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_adminMessaging_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b51cad2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_adminMessaging_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kkW7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    diameter: {
      type: Number,
      required: false,
      default: 200
    },
    totalSteps: {
      type: Number,
      required: true,
      default: 10
    },
    completedSteps: {
      type: Number,
      required: true,
      default: 0
    },
    startColor: {
      type: String,
      required: false,
      default: '#bbff42'
    },
    stopColor: {
      type: String,
      required: false,
      default: '#429321'
    },
    strokeWidth: {
      type: Number,
      required: false,
      default: 10
    },
    animateSpeed: {
      type: Number,
      required: false,
      default: 1000
    },
    innerStrokeColor: {
      type: String,
      required: false,
      default: '#323232'
    },
    fps: {
      type: Number,
      required: false,
      default: 60
    },
    timingFunc: {
      type: String,
      required: false,
      default: 'linear'
    }
  },

  data: function data() {
    return {
      gradient: {
        fx: 0.99,
        fy: 0.5,
        cx: 0.5,
        cy: 0.5,
        r: 0.65
      },
      gradientAnimation: null,
      currentAngle: 0,
      strokeDashoffset: 0
    };
  },


  computed: {
    radius: function radius() {
      return this.diameter / 2;
    },
    circumference: function circumference() {
      return Math.PI * this.innerCircleDiameter;
    },
    stepSize: function stepSize() {
      if (this.totalSteps === 0) {
        return 0;
      }

      return 100 / this.totalSteps;
    },
    finishedPercentage: function finishedPercentage() {
      return this.stepSize * this.completedSteps;
    },
    circleSlice: function circleSlice() {
      return 2 * Math.PI / this.totalSteps;
    },
    animateSlice: function animateSlice() {
      return this.circleSlice / this.totalPoints;
    },
    innerCircleDiameter: function innerCircleDiameter() {
      return this.diameter - this.strokeWidth * 2;
    },
    innerCircleRadius: function innerCircleRadius() {
      return this.innerCircleDiameter / 2;
    },
    totalPoints: function totalPoints() {
      return this.animateSpeed / this.animationIncrements;
    },
    animationIncrements: function animationIncrements() {
      return 1000 / this.fps;
    },
    hasGradient: function hasGradient() {
      return this.startColor !== this.stopColor;
    },
    containerStyle: function containerStyle() {
      return {
        height: this.diameter + 'px',
        width: this.diameter + 'px'
      };
    },
    progressStyle: function progressStyle() {
      return {
        height: this.diameter + 'px',
        width: this.diameter + 'px',
        strokeWidth: this.strokeWidth + 'px',
        strokeDashoffset: this.strokeDashoffset,
        transition: 'stroke-dashoffset ' + this.animateSpeed + 'ms ' + this.timingFunc
      };
    },
    strokeStyle: function strokeStyle() {
      return {
        height: this.diameter + 'px',
        width: this.diameter + 'px',
        strokeWidth: this.strokeWidth + 'px'
      };
    },
    innerCircleStyle: function innerCircleStyle() {
      return {
        width: this.innerCircleDiameter + 'px'
      };
    }
  },

  methods: {
    getStopPointsOfCircle: function getStopPointsOfCircle(steps) {
      var points = [];

      for (var i = 0; i < steps; i++) {
        var angle = this.circleSlice * i;
        points.push(this.getPointOfCircle(angle));
      }

      return points;
    },
    getPointOfCircle: function getPointOfCircle(angle) {
      var radius = 0.5;

      var x = radius + radius * Math.cos(angle);
      var y = radius + radius * Math.sin(angle);

      return { x: x, y: y };
    },
    gotoPoint: function gotoPoint() {
      var point = this.getPointOfCircle(this.currentAngle);

      this.gradient.fx = point.x;
      this.gradient.fy = point.y;
    },
    changeProgress: function changeProgress(_ref) {
      var _this = this;

      var _ref$isAnimate = _ref.isAnimate,
          isAnimate = _ref$isAnimate === undefined ? true : _ref$isAnimate;

      this.strokeDashoffset = (100 - this.finishedPercentage) / 100 * this.circumference;

      if (this.gradientAnimation) {
        clearInterval(this.gradientAnimation);
      }

      if (!isAnimate) {
        this.gotoNextStep();
        return;
      }

      var angleOffset = (this.completedSteps - 1) * this.circleSlice;
      var i = (this.currentAngle - angleOffset) / this.animateSlice;
      var incrementer = Math.abs(i - this.totalPoints) / this.totalPoints;
      var isMoveForward = i < this.totalPoints;

      this.gradientAnimation = setInterval(function () {
        if (isMoveForward && i >= _this.totalPoints || !isMoveForward && i < _this.totalPoints) {
          clearInterval(_this.gradientAnimation);
          return;
        }

        _this.currentAngle = angleOffset + _this.animateSlice * i;
        _this.gotoPoint();

        i += isMoveForward ? incrementer : -incrementer;
      }, this.animationIncrements);
    },
    gotoNextStep: function gotoNextStep() {
      this.currentAngle = this.completedSteps * this.circleSlice;
      this.gotoPoint();
    }
  },

  watch: {
    totalSteps: function totalSteps() {
      this.changeProgress({ isAnimate: true });
    },
    completedSteps: function completedSteps() {
      this.changeProgress({ isAnimate: true });
    },
    diameter: function diameter() {
      this.changeProgress({ isAnimate: true });
    },
    strokeWidth: function strokeWidth() {
      this.changeProgress({ isAnimate: true });
    }
  },

  created: function created() {
    this.changeProgress({ isAnimate: false });
  }
};

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26838eff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("4tVb");
function injectStyle (ssrContext) {
  __webpack_require__("rFoe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26838eff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26838eff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08aab84f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("MU/q");
function injectStyle (ssrContext) {
  __webpack_require__("iKFn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08aab84f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08aab84f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "myNo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-one-third"},[_c('div',{staticClass:"parent"},[_c('img',{staticClass:"image",attrs:{"src":__webpack_require__("8fqk"),"alt":"KNOSIS"}}),_vm._v(" "),_c('img',{staticClass:"imagespin",attrs:{"src":__webpack_require__("7Otq"),"alt":""}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n7oK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Registration_registerModal_vue__ = __webpack_require__("Cqth");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      showRegisterModal: false,
      email: '',
      password: ''
    };
  },

  components: {
    registerModal: __WEBPACK_IMPORTED_MODULE_0__Registration_registerModal_vue__["a" /* default */]
  },
  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push({ path: '/home' });
      }
    }
  },
  methods: {
    toastErr: function toastErr() {
      var message = 'New Users Not Currently Accepted. Thank You.';
      this.$toasted.show(message, {
        theme: "outline",
        position: "bottom-center",
        duration: 3000,
        fitToScreen: true
      });
    },

    //Login calls for firebase to authenticate login credentials
    login: function login() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase__["database"]().ref('/users/').once('value').then(function (data) {
        var userAccept = false;
        var obj = data.val();
        for (var key in obj) {
          if (obj[key].email == _this.email) {
            _this.$store.dispatch('signUserIn', { email: _this.email, password: _this.password });
            userAccept = true;
          }
        }
        if (!userAccept) {
          _this.$toasted.show("Incorrect Email/Password! Please try again.", {
            theme: "outline",
            position: "bottom-center",
            duration: 3000,
            fitToScreen: true
          });
        }
      });
    },
    goToAdminLogin: function goToAdminLogin() {
      this.$router.push({ path: '/admin' });
    }
  }
});

/***/ }),

/***/ "oeeS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_challengeModal_vue__ = __webpack_require__("DK0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f5b0271_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_challengeModal_vue__ = __webpack_require__("cPqB");
function injectStyle (ssrContext) {
  __webpack_require__("Gf+F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f5b0271"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_challengeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f5b0271_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_challengeModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ozE5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messageModal_vue__ = __webpack_require__("FVO4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfc4b92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messageModal_vue__ = __webpack_require__("aRC9");
function injectStyle (ssrContext) {
  __webpack_require__("n7oK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cfc4b92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_messageModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cfc4b92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_messageModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "p6ZZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


/*
  This is just a regular javascript object and no longer is a store.
  It no longer is a store, instead it gets sent to the store file now.
*/
/* harmony default export */ __webpack_exports__["a"] = ({
  // the store configuration
  state: {
    avatar: null
  },
  mutations: {
    // changes the state of data properties
    setAvatar: function setAvatar(state, payload) {
      state.avatar = payload;
    }
  },
  /*
    Perform all asynchronous tasks in the actions area
   */
  actions: {
    // to dispatch the mutations
    fetchAvatarData: function fetchAvatarData(_ref) {
      var commit = _ref.commit,
          getters = _ref.getters;

      // commit('setLoading', true)

      // get user data from firebase using the getters
      // once fetches the data once.  It doesn't set up a permanent listener
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/users/').child(getters.user.id).once('value', function (data) {
        var updatedAvatar = {
          didimoKey: data.child('didimoKey').val(),
          hasAvatar: data.child('hasAvatar').val()
        };
        commit('setAvatar', updatedAvatar);
      }).catch(function (error) {
        console.log(error);
        // commit('setLoading', false)
      });
    },


    //Modify Setters
    changeDidimoKey: function changeDidimoKey(_ref2, payload) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/users/').child(getters.user.id).update({
        "didimoKey": payload
      });
      commit('setDidimoKey', { didimoKey: payload });
    },
    changeHasAvatar: function changeHasAvatar(_ref3, payload) {
      var commit = _ref3.commit,
          getters = _ref3.getters;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/users/').child(getters.user.id).update({
        "hasAvatar": payload
      });
      commit('setHasAvatar', { hasAvatar: payload });
    }
  },
  getters: {
    // get the store in pur components
    avatar: function avatar(state) {
      // return the user from vuex store
      return state.avatar;
    }
  }
});

/***/ }),

/***/ "phKf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


/*
  This is just a regular javascript object and no longer is a store.
  It no longer is a store, instead it gets sent to the store file now.
*/
/* harmony default export */ __webpack_exports__["a"] = ({
  // the store configuration
  state: {
    admin: null
  },
  mutations: {
    // changes the state of data properties
    setAdmin: function setAdmin(state, payload) {
      state.admin = payload; // the currently signed in admin
    }
  },
  /*
    Perform all asynchronous tasks in the actions area
   */
  actions: {
    // to dispatch the mutations
    signAdminUp: function signAdminUp(_ref, payload) {
      var commit = _ref.commit;
      // manage the user signup in our store
      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().createUserWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('admin/' + __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().currentUser.uid).set({
          company: payload.company,
          email: payload.email,
          admin: true,
          messageHistory: []
        });
        commit('setAdmin', {
          company: payload.company,
          email: payload.email,
          admin: true,
          messageHistory: []
        });
      }).catch(function (error) {
        console.log(error);
      });
    },
    signAdminIn: function signAdminIn(_ref2, payload) {
      var commit = _ref2.commit;
      // payload is an object with an email and password
      // payload is what is currently in the store
      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
        // receive the user and store it in the store
        var newAdmin = {
          id: user.uid
        };
        commit('setAdmin', newAdmin); // mutation and pass the new user
      }).catch(function (error) {
        console.log(error);
      });
    },
    autoAdminSignIn: function autoAdminSignIn(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setAdmin', {
        id: payload.uid
      });
    },
    fetchAdminData: function fetchAdminData(_ref4) {
      var commit = _ref4.commit,
          getters = _ref4.getters;

      // commit('setLoading', true)

      // get admin data from firebase using the getters
      // once fetches the data once.  It doesn't set up a permanent listener
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('/admin/').child(getters.admin.id).once('value').then(function (data) {
        var updatedAdmin = {
          id: getters.admin.id,
          company: data.child('company').val(),
          permission: data.child('admin').val()
        };
        commit('setAdmin', updatedAdmin);
      }).catch(function (error) {
        console.log(error);
      });
    },
    logoutAdmin: function logoutAdmin(_ref5) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"]().signOut();
      commit('setAdmin', null);
    }
  },
  getters: {
    // get the store in our components
    admin: function admin(state) {
      // return the user from vuex store
      return state.admin;
    }
  }
});

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7d2989da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("doCN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7d2989da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "q2Ik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PrivacyModal',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "qDI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "account",
  data: function data() {
    return {
      userName: '',
      firstName: '',
      lastName: '',
      email: '',
      dob: '',
      gender: '',
      race: '',
      weight: '',
      feet: '',
      inches: '',
      zipcode: ''
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  mounted: function mounted() {
    this.firstName = this.user.firstName;
    this.lastName = this.user.lastName;
    this.weight = this.user.weight;
    this.zipcode = this.user.zipcode;
  },

  methods: {
    updateUserData: function updateUserData() {
      var updatedUser = {
        firstName: this.firstName,
        lastName: this.lastName,
        weight: this.weight,
        zipcode: this.zipcode
      };
      this.$store.dispatch('updateUserData', updatedUser);
    }
  }
});

/***/ }),

/***/ "qKFl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToCModal_vue__ = __webpack_require__("KQCA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PrivacyModal_vue__ = __webpack_require__("uKca");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'registerModal',
  components: {
    ToCModal: __WEBPACK_IMPORTED_MODULE_1__ToCModal_vue__["a" /* default */],
    PrivacyModal: __WEBPACK_IMPORTED_MODULE_2__PrivacyModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      failTOC: 'Please accept the Terms and Conditions and Privacy Policy to continue.',
      usernameAvailable: true,
      checked: '',
      firstName: '',
      lastName: '',
      username: '',
      email: '',
      password: '',
      dob: '',
      gender: '',
      race: '',
      weight: '',
      feet: '',
      inches: '',
      zipcode: '',
      showToCModal: false,
      showPrivacyModal: false,
      confirmPassword: '',
      passwordsNotMatch: false
    };
  },

  methods: {
    //If T&C not accepted deliver message to user
    toastErr: function toastErr(bool, message) {
      this.checked = bool;
      this.showToCModal = false;
      if (!bool) {
        this.$toasted.show(message, {
          theme: "outline",
          position: "bottom-center",
          duration: 3000,
          fitToScreen: true
        });
      }
    },


    //Check username to make sure it is unique using debounce
    //debounce is a function provided by lodash to limit how
    //often a particularly expensive operation can be run.
    //In this case, we want to limit how often we access
    //the firebase database, waiting until the user has completely
    //finished typing before making the request.
    checkUsername: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database().ref('users').once('value').then(function (data) {
        var obj = data.val(); // store all objects
        for (var key in obj) {
          if (obj[key].username == _this.username) {
            _this.usernameAvailable = false;
            return;
          }
        }
        _this.usernameAvailable = true;
      });
    },
    // This is the number of milliseconds we wait for the
    // user to stop typing.
    500),

    //Ensure user enters same password in both input fields
    comparePasswords: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function () {
      return this.passwordsNotMatch = this.password == this.confirmPassword;
    }, 500),

    //Register new user with firebase authentication
    register: function register() {
      if (document.getElementById('checkbox').checked == false) {
        this.toastErr(false, this.failTOC);
      } else {
        if (this.usernameAvailable == false || this.passwordsNotMatch == false) {
          if (this.usernameAvailable == false) {
            this.toastErr(false, 'Username Unavailable');
          } else if (this.passwordsNotMatch == false) {
            this.toastErr(false, 'Passwords Do Not Match');
          }
        } else {
          this.$store.dispatch('signUserUp', {
            firstName: this.firstName,
            lastName: this.lastName,
            username: this.username,
            email: this.email,
            password: this.password,
            dob: this.dob,
            gender: this.gender,
            race: this.race,
            weight: this.weight,
            feet: this.feet,
            inches: this.inches,
            zipcode: this.zipcode
          });
        }
      }
    }
  }
});

/***/ }),

/***/ "r/ZB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rFoe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ri/H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t0Z9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/clothes.d0b5999.png";

/***/ }),

/***/ "uK6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__("qDI4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527f5d76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__("aIeS");
function injectStyle (ssrContext) {
  __webpack_require__("GkPm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-527f5d76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527f5d76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uKca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyModal_vue__ = __webpack_require__("q2Ik");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e410d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyModal_vue__ = __webpack_require__("NEe7");
function injectStyle (ssrContext) {
  __webpack_require__("Cj4E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70e410d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70e410d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uLGF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ulJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrivacyModal_vue__ = __webpack_require__("uKca");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ToCModal',
  components: {
    PrivacyModal: __WEBPACK_IMPORTED_MODULE_0__PrivacyModal_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showPrivacyModal: false
    };
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v1Zf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active",attrs:{"id":"uploadPhotoModal"}},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Upload New Photo")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-fullwidth",on:{"click":function($event){_vm.showCameraModal=true; _vm.accessUserMedia();}}},[_vm._v("Proceed")]),_vm._v(" "),_c('button',{staticClass:"button is-fullwidth",on:{"click":function($event){_vm.$emit('close')}}},[_vm._v("Cancel")])])]),_vm._v(" "),_c('cameraModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCameraModal),expression:"showCameraModal"}],on:{"closeCanvas":function($event){_vm.accessUserMedia()},"closeCreateNewAvatarModal":function($event){_vm.$emit('close')},"accessCamera":function($event){_vm.accessUserMedia()},"close":function($event){_vm.showCameraModal = false;}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"subtitle is-4",attrs:{"align":"center"}},[_vm._v("All it takes is a single photo.")]),_vm._v(" "),_c('p',[_vm._v("For best results:")]),_vm._v(" "),_c('ul',{staticStyle:{"list-style-type":"disc","padding-left":"25px"}},[_c('li',[_vm._v("subject facing directly at camera")]),_vm._v(" "),_c('li',[_vm._v("no expression - poker face")]),_vm._v(" "),_c('li',[_vm._v("no hair or accessories covering face")]),_vm._v(" "),_c('li',[_vm._v("clearly lit from front and above")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v1zE":
/***/ (function(module, exports, __webpack_require__) {

/**
 * @author Eberhard Graether / http://egraether.com/
 * @author Mark Lundin 	/ http://mark-lundin.com
 * @author Simone Manini / http://daron1337.github.io
 * @author Luca Antiga 	/ http://lantiga.github.io
 */

var THREE = window.THREE || __webpack_require__("Ml+6");

THREE.TrackballControls = function ( object, domElement ) {

	var _this = this;
	var STATE = { NONE: - 1, ROTATE: 0, ZOOM: 1, PAN: 2, TOUCH_ROTATE: 3, TOUCH_ZOOM_PAN: 4 };

	this.object = object;
	this.domElement = ( domElement !== undefined ) ? domElement : document;

	// API

	this.enabled = true;

	this.screen = { left: 0, top: 0, width: 0, height: 0 };

	this.rotateSpeed = 1.0;
	this.zoomSpeed = 1.2;
	this.panSpeed = 0.3;

	this.noRotate = false;
	this.noZoom = false;
	this.noPan = false;

	this.staticMoving = false;
	this.dynamicDampingFactor = 0.2;

	this.minDistance = 0;
	this.maxDistance = Infinity;

	this.keys = [ 65 /*A*/, 83 /*S*/, 68 /*D*/ ];

	// internals

	this.target = new THREE.Vector3();

	var EPS = 0.000001;

	var lastPosition = new THREE.Vector3();

	var _state = STATE.NONE,
	_prevState = STATE.NONE,

	_eye = new THREE.Vector3(),

	_movePrev = new THREE.Vector2(),
	_moveCurr = new THREE.Vector2(),

	_lastAxis = new THREE.Vector3(),
	_lastAngle = 0,

	_zoomStart = new THREE.Vector2(),
	_zoomEnd = new THREE.Vector2(),

	_touchZoomDistanceStart = 0,
	_touchZoomDistanceEnd = 0,

	_panStart = new THREE.Vector2(),
	_panEnd = new THREE.Vector2();

	// for reset

	this.target0 = this.target.clone();
	this.position0 = this.object.position.clone();
	this.up0 = this.object.up.clone();

	// events

	var changeEvent = { type: 'change' };
	var startEvent = { type: 'start' };
	var endEvent = { type: 'end' };


	// methods

	this.handleResize = function () {

		if ( this.domElement === document ) {

			this.screen.left = 0;
			this.screen.top = 0;
			this.screen.width = window.innerWidth;
			this.screen.height = window.innerHeight;

		} else {

			var box = this.domElement.getBoundingClientRect();
			// adjustments come from similar code in the jquery offset() function
			var d = this.domElement.ownerDocument.documentElement;
			this.screen.left = box.left + window.pageXOffset - d.clientLeft;
			this.screen.top = box.top + window.pageYOffset - d.clientTop;
			this.screen.width = box.width;
			this.screen.height = box.height;

		}

	};

	this.handleEvent = function ( event ) {

		if ( typeof this[ event.type ] == 'function' ) {

			this[ event.type ]( event );

		}

	};

	var getMouseOnScreen = ( function () {

		var vector = new THREE.Vector2();

		return function getMouseOnScreen( pageX, pageY ) {

			vector.set(
				( pageX - _this.screen.left ) / _this.screen.width,
				( pageY - _this.screen.top ) / _this.screen.height
			);

			return vector;

		};

	}() );

	var getMouseOnCircle = ( function () {

		var vector = new THREE.Vector2();

		return function getMouseOnCircle( pageX, pageY ) {

			vector.set(
				( ( pageX - _this.screen.width * 0.5 - _this.screen.left ) / ( _this.screen.width * 0.5 ) ),
				( ( _this.screen.height + 2 * ( _this.screen.top - pageY ) ) / _this.screen.width ) // screen.width intentional
			);

			return vector;

		};

	}() );

	this.rotateCamera = ( function() {

		var axis = new THREE.Vector3(),
			quaternion = new THREE.Quaternion(),
			eyeDirection = new THREE.Vector3(),
			objectUpDirection = new THREE.Vector3(),
			objectSidewaysDirection = new THREE.Vector3(),
			moveDirection = new THREE.Vector3(),
			angle;

		return function rotateCamera() {

			moveDirection.set( _moveCurr.x - _movePrev.x, _moveCurr.y - _movePrev.y, 0 );
			angle = moveDirection.length();

			if ( angle ) {

				_eye.copy( _this.object.position ).sub( _this.target );

				eyeDirection.copy( _eye ).normalize();
				objectUpDirection.copy( _this.object.up ).normalize();
				objectSidewaysDirection.crossVectors( objectUpDirection, eyeDirection ).normalize();

				objectUpDirection.setLength( _moveCurr.y - _movePrev.y );
				objectSidewaysDirection.setLength( _moveCurr.x - _movePrev.x );

				moveDirection.copy( objectUpDirection.add( objectSidewaysDirection ) );

				axis.crossVectors( moveDirection, _eye ).normalize();

				angle *= _this.rotateSpeed;
				quaternion.setFromAxisAngle( axis, angle );

				_eye.applyQuaternion( quaternion );
				_this.object.up.applyQuaternion( quaternion );

				_lastAxis.copy( axis );
				_lastAngle = angle;

			} else if ( ! _this.staticMoving && _lastAngle ) {

				_lastAngle *= Math.sqrt( 1.0 - _this.dynamicDampingFactor );
				_eye.copy( _this.object.position ).sub( _this.target );
				quaternion.setFromAxisAngle( _lastAxis, _lastAngle );
				_eye.applyQuaternion( quaternion );
				_this.object.up.applyQuaternion( quaternion );

			}

			_movePrev.copy( _moveCurr );

		};

	}() );


	this.zoomCamera = function () {

		var factor;

		if ( _state === STATE.TOUCH_ZOOM_PAN ) {

			factor = _touchZoomDistanceStart / _touchZoomDistanceEnd;
			_touchZoomDistanceStart = _touchZoomDistanceEnd;
			_eye.multiplyScalar( factor );

		} else {

			factor = 1.0 + ( _zoomEnd.y - _zoomStart.y ) * _this.zoomSpeed;

			if ( factor !== 1.0 && factor > 0.0 ) {

				_eye.multiplyScalar( factor );

			}

			if ( _this.staticMoving ) {

				_zoomStart.copy( _zoomEnd );

			} else {

				_zoomStart.y += ( _zoomEnd.y - _zoomStart.y ) * this.dynamicDampingFactor;

			}

		}

	};

	this.panCamera = ( function() {

		var mouseChange = new THREE.Vector2(),
			objectUp = new THREE.Vector3(),
			pan = new THREE.Vector3();

		return function panCamera() {

			mouseChange.copy( _panEnd ).sub( _panStart );

			if ( mouseChange.lengthSq() ) {

				mouseChange.multiplyScalar( _eye.length() * _this.panSpeed );

				pan.copy( _eye ).cross( _this.object.up ).setLength( mouseChange.x );
				pan.add( objectUp.copy( _this.object.up ).setLength( mouseChange.y ) );

				_this.object.position.add( pan );
				_this.target.add( pan );

				if ( _this.staticMoving ) {

					_panStart.copy( _panEnd );

				} else {

					_panStart.add( mouseChange.subVectors( _panEnd, _panStart ).multiplyScalar( _this.dynamicDampingFactor ) );

				}

			}

		};

	}() );

	this.checkDistances = function () {

		if ( ! _this.noZoom || ! _this.noPan ) {

			if ( _eye.lengthSq() > _this.maxDistance * _this.maxDistance ) {

				_this.object.position.addVectors( _this.target, _eye.setLength( _this.maxDistance ) );
				_zoomStart.copy( _zoomEnd );

			}

			if ( _eye.lengthSq() < _this.minDistance * _this.minDistance ) {

				_this.object.position.addVectors( _this.target, _eye.setLength( _this.minDistance ) );
				_zoomStart.copy( _zoomEnd );

			}

		}

	};

	this.update = function () {

		_eye.subVectors( _this.object.position, _this.target );

		if ( ! _this.noRotate ) {

			_this.rotateCamera();

		}

		if ( ! _this.noZoom ) {

			_this.zoomCamera();

		}

		if ( ! _this.noPan ) {

			_this.panCamera();

		}

		_this.object.position.addVectors( _this.target, _eye );

		_this.checkDistances();

		_this.object.lookAt( _this.target );

		if ( lastPosition.distanceToSquared( _this.object.position ) > EPS ) {

			_this.dispatchEvent( changeEvent );

			lastPosition.copy( _this.object.position );

		}

	};

	this.reset = function () {

		_state = STATE.NONE;
		_prevState = STATE.NONE;

		_this.target.copy( _this.target0 );
		_this.object.position.copy( _this.position0 );
		_this.object.up.copy( _this.up0 );

		_eye.subVectors( _this.object.position, _this.target );

		_this.object.lookAt( _this.target );

		_this.dispatchEvent( changeEvent );

		lastPosition.copy( _this.object.position );

	};

	// listeners

	function keydown( event ) {

		if ( _this.enabled === false ) return;

		window.removeEventListener( 'keydown', keydown );

		_prevState = _state;

		if ( _state !== STATE.NONE ) {

			return;

		} else if ( event.keyCode === _this.keys[ STATE.ROTATE ] && ! _this.noRotate ) {

			_state = STATE.ROTATE;

		} else if ( event.keyCode === _this.keys[ STATE.ZOOM ] && ! _this.noZoom ) {

			_state = STATE.ZOOM;

		} else if ( event.keyCode === _this.keys[ STATE.PAN ] && ! _this.noPan ) {

			_state = STATE.PAN;

		}

	}

	function keyup( event ) {

		if ( _this.enabled === false ) return;

		_state = _prevState;

		window.addEventListener( 'keydown', keydown, false );

	}

	function mousedown( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		if ( _state === STATE.NONE ) {

			_state = event.button;

		}

		if ( _state === STATE.ROTATE && ! _this.noRotate ) {

			_moveCurr.copy( getMouseOnCircle( event.pageX, event.pageY ) );
			_movePrev.copy( _moveCurr );

		} else if ( _state === STATE.ZOOM && ! _this.noZoom ) {

			_zoomStart.copy( getMouseOnScreen( event.pageX, event.pageY ) );
			_zoomEnd.copy( _zoomStart );

		} else if ( _state === STATE.PAN && ! _this.noPan ) {

			_panStart.copy( getMouseOnScreen( event.pageX, event.pageY ) );
			_panEnd.copy( _panStart );

		}

		document.addEventListener( 'mousemove', mousemove, false );
		document.addEventListener( 'mouseup', mouseup, false );

		_this.dispatchEvent( startEvent );

	}

	function mousemove( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		if ( _state === STATE.ROTATE && ! _this.noRotate ) {

			_movePrev.copy( _moveCurr );
			_moveCurr.copy( getMouseOnCircle( event.pageX, event.pageY ) );

		} else if ( _state === STATE.ZOOM && ! _this.noZoom ) {

			_zoomEnd.copy( getMouseOnScreen( event.pageX, event.pageY ) );

		} else if ( _state === STATE.PAN && ! _this.noPan ) {

			_panEnd.copy( getMouseOnScreen( event.pageX, event.pageY ) );

		}

	}

	function mouseup( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		_state = STATE.NONE;

		document.removeEventListener( 'mousemove', mousemove );
		document.removeEventListener( 'mouseup', mouseup );
		_this.dispatchEvent( endEvent );

	}

	function mousewheel( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		switch ( event.deltaMode ) {

                        case 2:
                                // Zoom in pages
                                _zoomStart.y -= event.deltaY * 0.025;
                                break;

			case 1:
                                // Zoom in lines
				_zoomStart.y -= event.deltaY * 0.01;
				break;

			default:
				// undefined, 0, assume pixels
				_zoomStart.y -= event.deltaY * 0.00025;
				break;

		}

		_this.dispatchEvent( startEvent );
		_this.dispatchEvent( endEvent );

	}

	function touchstart( event ) {

		if ( _this.enabled === false ) return;

		switch ( event.touches.length ) {

			case 1:
				_state = STATE.TOUCH_ROTATE;
				_moveCurr.copy( getMouseOnCircle( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY ) );
				_movePrev.copy( _moveCurr );
				break;

			default: // 2 or more
				_state = STATE.TOUCH_ZOOM_PAN;
				var dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
				var dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;
				_touchZoomDistanceEnd = _touchZoomDistanceStart = Math.sqrt( dx * dx + dy * dy );

				var x = ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX ) / 2;
				var y = ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY ) / 2;
				_panStart.copy( getMouseOnScreen( x, y ) );
				_panEnd.copy( _panStart );
				break;

		}

		_this.dispatchEvent( startEvent );

	}

	function touchmove( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();
		event.stopPropagation();

		switch ( event.touches.length ) {

			case 1:
				_movePrev.copy( _moveCurr );
				_moveCurr.copy( getMouseOnCircle( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY ) );
				break;

			default: // 2 or more
				var dx = event.touches[ 0 ].pageX - event.touches[ 1 ].pageX;
				var dy = event.touches[ 0 ].pageY - event.touches[ 1 ].pageY;
				_touchZoomDistanceEnd = Math.sqrt( dx * dx + dy * dy );

				var x = ( event.touches[ 0 ].pageX + event.touches[ 1 ].pageX ) / 2;
				var y = ( event.touches[ 0 ].pageY + event.touches[ 1 ].pageY ) / 2;
				_panEnd.copy( getMouseOnScreen( x, y ) );
				break;

		}

	}

	function touchend( event ) {

		if ( _this.enabled === false ) return;

		switch ( event.touches.length ) {

			case 0:
				_state = STATE.NONE;
				break;

			case 1:
				_state = STATE.TOUCH_ROTATE;
				_moveCurr.copy( getMouseOnCircle( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY ) );
				_movePrev.copy( _moveCurr );
				break;

		}

		_this.dispatchEvent( endEvent );

	}

	function contextmenu( event ) {

		if ( _this.enabled === false ) return;

		event.preventDefault();

	}

	this.dispose = function() {

		this.domElement.removeEventListener( 'contextmenu', contextmenu, false );
		this.domElement.removeEventListener( 'mousedown', mousedown, false );
		this.domElement.removeEventListener( 'wheel', mousewheel, false );

		this.domElement.removeEventListener( 'touchstart', touchstart, false );
		this.domElement.removeEventListener( 'touchend', touchend, false );
		this.domElement.removeEventListener( 'touchmove', touchmove, false );

		document.removeEventListener( 'mousemove', mousemove, false );
		document.removeEventListener( 'mouseup', mouseup, false );

		window.removeEventListener( 'keydown', keydown, false );
		window.removeEventListener( 'keyup', keyup, false );

	};

	this.domElement.addEventListener( 'contextmenu', contextmenu, false );
	this.domElement.addEventListener( 'mousedown', mousedown, false );
	this.domElement.addEventListener( 'wheel', mousewheel, false );

	this.domElement.addEventListener( 'touchstart', touchstart, false );
	this.domElement.addEventListener( 'touchend', touchend, false );
	this.domElement.addEventListener( 'touchmove', touchmove, false );

	window.addEventListener( 'keydown', keydown, false );
	window.addEventListener( 'keyup', keyup, false );

	this.handleResize();

	// force an update at start
	this.update();

};

THREE.TrackballControls.prototype = Object.create( THREE.EventDispatcher.prototype );
THREE.TrackballControls.prototype.constructor = THREE.TrackballControls;


/***/ }),

/***/ "v6u5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container is-fluid"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('p',{staticClass:"title is-1",attrs:{"align":"center"}},[_vm._v("Inbox")]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-two-thirds"},[_c('div',{staticClass:"card"},[_c('table',{staticClass:"table is-striped is-narrow-tablet is-narrow-mobile is-hoverable"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.messages.slice().reverse()),function(m){return _c('tr',[(!m.dismissed)?_c('td',[_vm._v(_vm._s(m.date))]):_vm._e(),_vm._v(" "),(!m.dismissed)?_c('td',[_vm._v(_vm._s(m.subject))]):_vm._e(),_vm._v(" "),(!m.dismissed)?_c('td',[_c('button',{staticClass:"button is-small",on:{"click":function($event){_vm.showModal(m.key, m.date, m.subject, m.message)}}},[_vm._v("Open")])]):_vm._e(),_vm._v(" "),(!m.dismissed)?_c('td',[_c('button',{staticClass:"button is-small",on:{"click":function($event){_vm.dismissMessage(m)}}},[_vm._v("Dismiss")])]):_vm._e()])}))])]),_c('br'),_c('br'),_vm._v(" "),_c('a',{staticClass:"button is-fullwidth",attrs:{"href":"http://knosishealth.com/contact.html"}},[_vm._v("Feedback")])])])])]),_vm._v(" "),_c('message-modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMessageModal),expression:"showMessageModal"}],on:{"close":_vm.closeMessageModal}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Subject")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vdG7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'adminNavbar',
  data: function data() {
    return {
      showNav: false
    };
  },

  components: {},
  methods: {
    logout: function logout() {
      this.$store.dispatch('logoutAdmin'); // call the logout method from the store
      this.$router.push({ path: '/login' });
    },
    goToGroupDataPage: function goToGroupDataPage() {
      this.showNav = false;
      this.$router.push({ path: '/adminGroupData' });
    },
    goToMessagingPage: function goToMessagingPage() {
      this.showNav = false;
      this.$router.push({ path: '/adminMessaging' });
    }
  }
});

/***/ }),

/***/ "vvyU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/VestaBadgeSilver.2767f43.png";

/***/ }),

/***/ "wBKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center",attrs:{"id":"parentCanvas"}},[_c('div',{attrs:{"id":"loading"}}),_vm._v(" "),_c('div',{staticClass:"card-content is-flex is-horizontal-center"},[_c('div',{attrs:{"id":"previewcanvas"}})]),_vm._v(" "),_c('div',{attrs:{"id":"userWaitAMinuteNotification"}}),_vm._v(" "),_c('img',{attrs:{"id":"capturedPhoto"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wCqn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usernameModal_vue__ = __webpack_require__("BzcA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd7e0edc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usernameModal_vue__ = __webpack_require__("Zfjb");
function injectStyle (ssrContext) {
  __webpack_require__("aGek")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd7e0edc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_usernameModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd7e0edc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_usernameModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wsFh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deviceSyncModal_vue__ = __webpack_require__("1Oe9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7055fc0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deviceSyncModal_vue__ = __webpack_require__("dY5C");
function injectStyle (ssrContext) {
  __webpack_require__("UFh7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a7055fc0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deviceSyncModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7055fc0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deviceSyncModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Navbar__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_backtotop__ = __webpack_require__("7HfY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Admin_adminNavbar__ = __webpack_require__("AD8Z");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'knosisNavbar': __WEBPACK_IMPORTED_MODULE_1__components_Navbar__["a" /* default */],
    'backtotop': __WEBPACK_IMPORTED_MODULE_2__components_backtotop__["a" /* default */],
    'adminNavbar': __WEBPACK_IMPORTED_MODULE_3__components_Admin_adminNavbar__["a" /* default */]
  },
  data: function data() {
    return {
      noNavPaths: ['/adminMessaging', '/adminGroupData']
    };
  },


  methods: {
    navEnabled: function navEnabled() {
      for (var i = 0; i < this.noNavPaths.length; i++) {
        if (this.$route.path === this.noNavPaths[i]) {
          return false;
        }
      }
      return true;
    }
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e3bf7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("CUFp");
function injectStyle (ssrContext) {
  __webpack_require__("6dM0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03e3bf7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03e3bf7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y1TV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


/*
  This is just a regular javascript object and no longer is a store.
  It no longer is a store, instead it gets sent to the store file now.
*/
/* harmony default export */ __webpack_exports__["a"] = ({
  // the store configuration
  state: {
    position: {},
    challenges: [],
    pastChallenges: [],
    availableChallengers: [],
    mapCenter: { lat: 33.423650, lng: -111.939623 }
  },
  mutations: {
    // changes the state of data properties
    setUserPosition: function setUserPosition(state, payload) {
      state.position = payload;
    },
    setChallenges: function setChallenges(state, payload) {
      state.challenges = payload;
    },
    setPastChallenges: function setPastChallenges(state, payload) {
      state.pastChallenges = payload;
    },
    createChallenge: function createChallenge(state, payload) {
      state.challenges.push(payload);
    },
    setAvailableChallengers: function setAvailableChallengers(state, payload) {
      state.availableChallengers = payload;
    },
    setMapCenter: function setMapCenter(state, payload) {
      state.mapCenter = payload;
    }
  },
  /*
    Perform all asynchronous tasks in the actions area
   */
  actions: {
    // to dispatch the mutations
    fetchUserPosition: function fetchUserPosition(_ref) {
      var commit = _ref.commit,
          getters = _ref.getters;

      // get user data from firebase using the getters
      // once fetches the data once.  It doesn't set up a permanent listener
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(getters.user.id).once('value').then(function (data) {
        var updatedPosition = {
          latitude: data.child('latitude').val(),
          longitude: data.child('longitude').val()
        };
        commit('setUserPosition', updatedPosition);
      }).catch(function (error) {
        console.log(error);
      });
    },
    loadChallenges: function loadChallenges(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('challenges').on('value', function (data) {
        var obj = data.val();
        var challenges = [];
        var user = getters.user.id;

        // loop through the challenges
        for (var key in obj) {
          if (user == obj[key].challengerId || user == obj[key].opponentId) {
            challenges.push({
              key: key,
              accepted: obj[key].opponentHasAccepted,
              opponentRank: obj[key].opponentRank,
              opponentId: obj[key].opponentId,
              opponentFirstName: obj[key].opponentFirstName,
              challengerRank: obj[key].challengerRank,
              challengerId: obj[key].challengerId,
              challengerFirstName: obj[key].challengerFirstName,
              startDate: obj[key].startDate,
              duration: obj[key].duration
            });
          }
        }
        commit('setChallenges', challenges);
      });
    },
    loadPastChallenges: function loadPastChallenges(_ref3, payload) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(payload.uid).child('challengeHistory').on('value', function (data) {
        var obj = data.val();
        var pastChallenges = [];

        for (var key in obj) {
          pastChallenges.push({
            user: obj[key].opponentFirstName,
            outcome: obj[key].winnerId,
            key: obj[key].opponentId
          });
        }
        commit('setPastChallenges', pastChallenges);
      });
    },
    loadAvailableChallengers: function loadAvailableChallengers(_ref4, payload) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').on('value', function (data) {
        var obj = data.val(); // store all objects
        var availableChallengers = [];
        for (var key in obj) {
          if (key != payload.uid) {
            //typeof will be string if no lat or long stored
            if (typeof obj[key].latitude == 'number' && typeof obj[key].longitude == 'number') {
              if (obj[key].latitude != 0 && obj[key].longitude != 0) {
                var newMarker = {
                  position: {
                    lat: obj[key].latitude,
                    lng: obj[key].longitude
                  },
                  rank: obj[key].rank,
                  name: obj[key].firstName,
                  id: key,
                  clickable: "true"
                };
                availableChallengers.push(newMarker);
              }
            }
          }
        }
        commit('setAvailableChallengers', availableChallengers);
      });
    },
    createChallenge: function createChallenge(_ref5, payload) {
      var _this = this;

      var commit = _ref5.commit,
          getters = _ref5.getters;

      var challenge = {
        challengerId: getters.user.id,
        challengerRank: getters.user.rank,
        challengerFirstName: getters.user.firstName,
        opponentRank: payload.opponentRank,
        opponentId: payload.opponentId,
        opponentFirstName: payload.opponentFirstName,
        opponentHasAccepted: false,
        startDate: '',
        winnerId: '',
        duration: payload.duration
      };
      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('challenges').push(challenge).then(function () {
        _this.dispatch('loadChallenges');
      }).catch(function (error) {
        console.log(error);
      });
    },
    acceptChallenge: function acceptChallenge(_ref6, payload) {
      var commit = _ref6.commit;

      if (payload.opponentHasAccepted) {
        __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('challenges').child(payload.key).update({
          "opponentHasAccepted": true,
          "startDate": payload.startDate
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.dispatch('deleteChallenge', payload.key);
      }
    },
    deleteChallenge: function deleteChallenge(_ref7, payload) {
      var commit = _ref7.commit;

      __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('challenges').child(payload).remove().catch(function (error) {
        console.log(error);
      });
    },
    loadMapCenter: function loadMapCenter(_ref8) {
      var commit = _ref8.commit,
          getters = _ref8.getters;

      //Ensure geolocation services are available and request location permissions
      if (navigator.geolocation) {
        var buffer = null;
        if (Math.random() >= 0.5) {
          buffer = Math.random() / 100;
        }

        navigator.geolocation.getCurrentPosition(function (position) {
          var center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
            //Set map center to current device location
          };commit('setMapCenter', center);

          //Store logged in users location to the DB and update
          __WEBPACK_IMPORTED_MODULE_0_firebase__["database"]().ref('users').child(getters.user.id).update({
            longitude: center.lng + buffer,
            latitude: center.lat + buffer
          });
          commit('setUserPosition', { longitude: center.lng + buffer, latitude: center.lng + buffer });
        }.bind(this));
      }
    }
  },
  getters: {
    // get the store in pur components
    position: function position(state) {
      // return the user from vuex store
      return state.position;
    },
    challenges: function challenges(state) {
      return state.challenges;
    },
    pastChallenges: function pastChallenges(state) {
      return state.pastChallenges.slice(0, 5);
    },
    availableChallengers: function availableChallengers(state) {
      return state.availableChallengers;
    },
    mapCenter: function mapCenter(state) {
      return state.mapCenter;
    }
  }
});

/***/ }),

/***/ "yDfm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal is-active"},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Register New User")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.$emit('close')}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"field is-horizontal"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.firstName),expression:"firstName"}],staticClass:"input",attrs:{"type":"text","id":"firstName","placeholder":"First Name","required":""},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lastName),expression:"lastName"}],staticClass:"input",attrs:{"type":"text","id":"lastName","placeholder":"Last Name","required":""},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded has-icons-left"},[_c('input',{staticClass:"input",attrs:{"type":"text","id":"username","placeholder":"Username","required":""},domProps:{"value":_vm.username.toLowerCase()},on:{"input":function($event){_vm.username = $event.target.value.toLowerCase()},"keyup":_vm.checkUsername}}),_vm._v(" "),_vm._m(2,false,false)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded"},[(_vm.usernameAvailable)?_c('b',{staticClass:"help is-success"},[_vm._v("\n                  @"+_vm._s(_vm.username)+" is available\n                ")]):_vm._e(),_vm._v(" "),(!_vm.usernameAvailable)?_c('b',{staticClass:"help is-danger"},[_vm._v("\n                  @"+_vm._s(_vm.username)+" has already been taken\n                ")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input",attrs:{"type":"email","id":"registerEmail","placeholder":"Email","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_vm._m(4,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input",attrs:{"type":"password","id":"password","placeholder":"Password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_vm._m(6,false,false)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"input",attrs:{"type":"password","id":"confirmPassword","placeholder":"Confirm Password","required":""},domProps:{"value":(_vm.confirmPassword)},on:{"keyup":_vm.comparePasswords,"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}}),_vm._v(" "),_vm._m(7,false,false)])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control is-expanded"},[(_vm.passwordsNotMatch)?_c('b',{staticClass:"help is-success"},[_vm._v("\n                  Passwords match\n                ")]):_vm._e(),_vm._v(" "),(!_vm.passwordsNotMatch)?_c('b',{staticClass:"help is-danger"},[_vm._v("\n                  Passwords do not match\n                ")]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(8,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dob),expression:"dob"}],staticClass:"input",attrs:{"type":"date","id":"dob","placeholder":"Date of Birth","required":""},domProps:{"value":(_vm.dob)},on:{"input":function($event){if($event.target.composing){ return; }_vm.dob=$event.target.value}}}),_vm._v(" "),_vm._m(9,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(10,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.gender=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","selected":"","value":""}},[_vm._v("Select Gender")]),_vm._v(" "),_c('option',[_vm._v("Male")]),_vm._v(" "),_c('option',[_vm._v("Female")])])])])])]),_vm._v(" "),_vm._m(11,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.race),expression:"race"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.race=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","selected":"","value":""}},[_vm._v("Select One")]),_vm._v(" "),_c('option',[_vm._v("White")]),_vm._v(" "),_c('option',[_vm._v("African American")]),_vm._v(" "),_c('option',[_vm._v("Hispanic")]),_vm._v(" "),_c('option',[_vm._v("Native American")]),_vm._v(" "),_c('option',[_vm._v("Asian")]),_vm._v(" "),_c('option',[_vm._v("Other")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(12,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.feet),expression:"feet"}],staticClass:"input",attrs:{"id":"feet","type":"number","min":"0","step":"1","placeholder":"Feet","required":""},domProps:{"value":(_vm.feet)},on:{"input":function($event){if($event.target.composing){ return; }_vm.feet=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inches),expression:"inches"}],staticClass:"input",attrs:{"id":"inches","type":"number","min":"0","max":"11","step":"1","placeholder":"Inches","required":""},domProps:{"value":(_vm.inches)},on:{"input":function($event){if($event.target.composing){ return; }_vm.inches=$event.target.value}}})])])]),_vm._v(" "),_vm._m(13,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.weight),expression:"weight"}],staticClass:"input",attrs:{"type":"number","id":"weight","placeholder":"Weight","required":""},domProps:{"value":(_vm.weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.weight=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"field is-horizontal"},[_vm._m(14,false,false),_vm._v(" "),_c('div',{staticClass:"field-body"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.zipcode),expression:"zipcode"}],staticClass:"input",attrs:{"type":"number","id":"zipcode","placeholder":"Zipcode","required":""},domProps:{"value":(_vm.zipcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.zipcode=$event.target.value}}}),_vm._v(" "),_vm._m(15,false,false)])])])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"field is-grouped"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checked),expression:"checked"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.checked)?_vm._i(_vm.checked,null)>-1:(_vm.checked)},on:{"change":function($event){var $$a=_vm.checked,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checked=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checked=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checked=$$c}}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"white"},attrs:{"for":"checkbox"}},[_vm._v("Accept\n                  "),_c('button',{staticClass:"as-text",staticStyle:{"color":"white"},on:{"click":function($event){_vm.showToCModal=true}}},[_c('u',[_vm._v("Terms and Conditions")])]),_vm._v(" and\n                  "),_c('button',{staticClass:"as-text",staticStyle:{"color":"white"},on:{"click":function($event){_vm.showPrivacyModal=true}}},[_c('u',[_vm._v("Privacy Policy")])])]),_vm._v(" "),_c('button',{staticClass:"button is-medium is-fullwidth",on:{"click":_vm.register}},[_vm._v("Submit")]),_vm._v(" "),_c('ToCModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showToCModal),expression:"showToCModal"}],on:{"close":function($event){_vm.showToCModal = false},"event_TOC":function($event){_vm.toastErr($event, _vm.failTOC)}}}),_vm._v(" "),_c('PrivacyModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPrivacyModal),expression:"showPrivacyModal"}],on:{"close":function($event){_vm.showPrivacyModal = false}}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Name:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Username:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-user"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Email:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-envelope"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Password:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-lock"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("DOB:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-calendar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Gender:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Race:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Height:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Weight:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label"},[_vm._v("Zipcode:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fas fa-globe"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ypKJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.email)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login($event)},"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.login($event)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control button-control"},[_c('button',{staticClass:"button is-medium is-fullwidth",attrs:{"placeholder":"Login"},on:{"click":_vm.login}},[_vm._v("Login")])])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('p',{staticClass:"forgot-password",attrs:{"align":"center"},on:{"click":function($event){_vm.showAdminRegisterModal=true}}},[_vm._v("Register Admin\n            "),_c('i',{staticClass:"fas fa-angle-right"})])])])])]),_vm._v(" "),_c('adminRegisterModal',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAdminRegisterModal),expression:"showAdminRegisterModal"}],on:{"close":function($event){_vm.showAdminRegisterModal = false}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-image"},[_c('img',{attrs:{"id":"profile-img","src":__webpack_require__("5Ej0")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"has-text-centered\thas-text-weight-bold is-size-3"},[_c('b',[_vm._v("Admin Login")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z2cB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Challenge_vue__ = __webpack_require__("IBEa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efe60b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Challenge_vue__ = __webpack_require__("UCMs");
function injectStyle (ssrContext) {
  __webpack_require__("CXlY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4efe60b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Challenge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4efe60b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Challenge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zPDV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Line */],
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
});

/***/ }),

/***/ "zjAN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zo0N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.29211cc9f481dc77657d.js